// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3E%3Cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3E%3Ccircle r=%273%27 fill=%27%23fff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3E%3Cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Bootstrap v4.0.0 (https://getbootstrap.com)
 * Copyright 2011-2018 The Bootstrap Authors
 * Copyright 2011-2018 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #3f51b5;
  --secondary: #E91E63;
  --success: #4caf50;
  --info: #00bcd4;
  --warning: #ff9800;
  --danger: #f44336;
  --light: #e8eaf6;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: "Roboto", sans-serif;
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

*,
*::before,
*::after {
  box-sizing: border-box; }

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

@-ms-viewport {
  width: device-width; }

article, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block; }

body {
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  color: #5c5c5c;
  text-align: left;
  background-color: #fff; }

[tabindex="-1"]:focus {
  outline: 0 !important; }

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible; }

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 12px; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 700; }

dd {
  margin-bottom: .5rem;
  margin-left: 0; }

blockquote {
  margin: 0 0 1rem; }

dfn {
  font-style: italic; }

b,
strong {
  font-weight: bolder; }

small {
  font-size: 80%; }

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: #3f51b5;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects; }
  a:hover {
    color: #32408f;
    text-decoration: underline; }

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none; }
  a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
    color: inherit;
    text-decoration: none; }
  a:not([href]):not([tabindex]):focus {
    outline: 0; }

pre,
code,
kbd,
samp {
  font-family: monospace, monospace;
  font-size: 1em; }

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar; }

figure {
  margin: 0 0 1rem; }

img {
  vertical-align: middle;
  border-style: none; }

svg:not(:root) {
  overflow: hidden; }

table {
  border-collapse: collapse; }

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom; }

th {
  text-align: inherit; }

label {
  display: inline-block;
  margin-bottom: .5rem; }

button {
  border-radius: 0; }

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
input {
  overflow: visible; }

button,
select {
  text-transform: none; }

button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none; }

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0; }

input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
  -webkit-appearance: listbox; }

textarea {
  overflow: auto;
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal; }

progress {
  vertical-align: baseline; }

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto; }

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none; }

[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

summary {
  display: list-item;
  cursor: pointer; }

template {
  display: none; }

[hidden] {
  display: none !important; }

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 12px;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.2;
  color: inherit; }

h1, .h1 {
  font-size: 24px; }

h2, .h2 {
  font-size: 18px; }

h3, .h3 {
  font-size: 16px; }

h4, .h4 {
  font-size: 15px; }

h5, .h5 {
  font-size: 13px; }

h6, .h6 {
  font-size: 12px; }

.lead {
  font-size: 1.25rem;
  font-weight: 300; }

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2; }

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2; }

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2; }

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2; }

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1); }

small,
.small {
  font-size: 80%;
  font-weight: 400; }

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3; }

.list-unstyled {
  padding-left: 0;
  list-style: none; }

.list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 90%;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem; }

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d; }
  .blockquote-footer::before {
    content: "\\2014 \\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 90%;
  color: #6c757d; }

code,
kbd,
pre,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-break: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 2px;
  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25); }
  kbd kbd {
    padding: 0;
    font-size: 100%;
    font-weight: 700;
    box-shadow: none; }

pre {
  display: block;
  font-size: 87.5%;
  color: #212529; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll; }

.container {
  width: 100%;
  padding-right: 17px;
  padding-left: 17px;
  margin-right: auto;
  margin-left: auto; }
  @media (min-width: 576px) {
    .container {
      max-width: 540px; } }
  @media (min-width: 768px) {
    .container {
      max-width: 720px; } }
  @media (min-width: 992px) {
    .container {
      max-width: 960px; } }
  @media (min-width: 1200px) {
    .container {
      max-width: 1140px; } }

.container-fluid {
  width: 100%;
  padding-right: 17px;
  padding-left: 17px;
  margin-right: auto;
  margin-left: auto; }

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -17px;
  margin-left: -17px; }

.no-gutters {
  margin-right: 0;
  margin-left: 0; }
  .no-gutters > .col,
  .no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0; }

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 17px;
  padding-left: 17px; }

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%; }

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: none; }

.col-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%; }

.col-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%; }

.col-3 {
  flex: 0 0 25%;
  max-width: 25%; }

.col-4 {
  flex: 0 0 33.33333%;
  max-width: 33.33333%; }

.col-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%; }

.col-6 {
  flex: 0 0 50%;
  max-width: 50%; }

.col-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%; }

.col-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%; }

.col-9 {
  flex: 0 0 75%;
  max-width: 75%; }

.col-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%; }

.col-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%; }

.col-12 {
  flex: 0 0 100%;
  max-width: 100%; }

.order-first {
  order: -1; }

.order-last {
  order: 13; }

.order-0 {
  order: 0; }

.order-1 {
  order: 1; }

.order-2 {
  order: 2; }

.order-3 {
  order: 3; }

.order-4 {
  order: 4; }

.order-5 {
  order: 5; }

.order-6 {
  order: 6; }

.order-7 {
  order: 7; }

.order-8 {
  order: 8; }

.order-9 {
  order: 9; }

.order-10 {
  order: 10; }

.order-11 {
  order: 11; }

.order-12 {
  order: 12; }

.offset-1 {
  margin-left: 8.33333%; }

.offset-2 {
  margin-left: 16.66667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.33333%; }

.offset-5 {
  margin-left: 41.66667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.33333%; }

.offset-8 {
  margin-left: 66.66667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.33333%; }

.offset-11 {
  margin-left: 91.66667%; }

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none; }
  .col-sm-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-sm-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-sm-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-sm-first {
    order: -1; }
  .order-sm-last {
    order: 13; }
  .order-sm-0 {
    order: 0; }
  .order-sm-1 {
    order: 1; }
  .order-sm-2 {
    order: 2; }
  .order-sm-3 {
    order: 3; }
  .order-sm-4 {
    order: 4; }
  .order-sm-5 {
    order: 5; }
  .order-sm-6 {
    order: 6; }
  .order-sm-7 {
    order: 7; }
  .order-sm-8 {
    order: 8; }
  .order-sm-9 {
    order: 9; }
  .order-sm-10 {
    order: 10; }
  .order-sm-11 {
    order: 11; }
  .order-sm-12 {
    order: 12; }
  .offset-sm-0 {
    margin-left: 0; }
  .offset-sm-1 {
    margin-left: 8.33333%; }
  .offset-sm-2 {
    margin-left: 16.66667%; }
  .offset-sm-3 {
    margin-left: 25%; }
  .offset-sm-4 {
    margin-left: 33.33333%; }
  .offset-sm-5 {
    margin-left: 41.66667%; }
  .offset-sm-6 {
    margin-left: 50%; }
  .offset-sm-7 {
    margin-left: 58.33333%; }
  .offset-sm-8 {
    margin-left: 66.66667%; }
  .offset-sm-9 {
    margin-left: 75%; }
  .offset-sm-10 {
    margin-left: 83.33333%; }
  .offset-sm-11 {
    margin-left: 91.66667%; } }

@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none; }
  .col-md-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-md-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-md-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-md-first {
    order: -1; }
  .order-md-last {
    order: 13; }
  .order-md-0 {
    order: 0; }
  .order-md-1 {
    order: 1; }
  .order-md-2 {
    order: 2; }
  .order-md-3 {
    order: 3; }
  .order-md-4 {
    order: 4; }
  .order-md-5 {
    order: 5; }
  .order-md-6 {
    order: 6; }
  .order-md-7 {
    order: 7; }
  .order-md-8 {
    order: 8; }
  .order-md-9 {
    order: 9; }
  .order-md-10 {
    order: 10; }
  .order-md-11 {
    order: 11; }
  .order-md-12 {
    order: 12; }
  .offset-md-0 {
    margin-left: 0; }
  .offset-md-1 {
    margin-left: 8.33333%; }
  .offset-md-2 {
    margin-left: 16.66667%; }
  .offset-md-3 {
    margin-left: 25%; }
  .offset-md-4 {
    margin-left: 33.33333%; }
  .offset-md-5 {
    margin-left: 41.66667%; }
  .offset-md-6 {
    margin-left: 50%; }
  .offset-md-7 {
    margin-left: 58.33333%; }
  .offset-md-8 {
    margin-left: 66.66667%; }
  .offset-md-9 {
    margin-left: 75%; }
  .offset-md-10 {
    margin-left: 83.33333%; }
  .offset-md-11 {
    margin-left: 91.66667%; } }

@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none; }
  .col-lg-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-lg-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-lg-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-lg-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-lg-first {
    order: -1; }
  .order-lg-last {
    order: 13; }
  .order-lg-0 {
    order: 0; }
  .order-lg-1 {
    order: 1; }
  .order-lg-2 {
    order: 2; }
  .order-lg-3 {
    order: 3; }
  .order-lg-4 {
    order: 4; }
  .order-lg-5 {
    order: 5; }
  .order-lg-6 {
    order: 6; }
  .order-lg-7 {
    order: 7; }
  .order-lg-8 {
    order: 8; }
  .order-lg-9 {
    order: 9; }
  .order-lg-10 {
    order: 10; }
  .order-lg-11 {
    order: 11; }
  .order-lg-12 {
    order: 12; }
  .offset-lg-0 {
    margin-left: 0; }
  .offset-lg-1 {
    margin-left: 8.33333%; }
  .offset-lg-2 {
    margin-left: 16.66667%; }
  .offset-lg-3 {
    margin-left: 25%; }
  .offset-lg-4 {
    margin-left: 33.33333%; }
  .offset-lg-5 {
    margin-left: 41.66667%; }
  .offset-lg-6 {
    margin-left: 50%; }
  .offset-lg-7 {
    margin-left: 58.33333%; }
  .offset-lg-8 {
    margin-left: 66.66667%; }
  .offset-lg-9 {
    margin-left: 75%; }
  .offset-lg-10 {
    margin-left: 83.33333%; }
  .offset-lg-11 {
    margin-left: 91.66667%; } }

@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none; }
  .col-xl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-xl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-xl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-xl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-xl-first {
    order: -1; }
  .order-xl-last {
    order: 13; }
  .order-xl-0 {
    order: 0; }
  .order-xl-1 {
    order: 1; }
  .order-xl-2 {
    order: 2; }
  .order-xl-3 {
    order: 3; }
  .order-xl-4 {
    order: 4; }
  .order-xl-5 {
    order: 5; }
  .order-xl-6 {
    order: 6; }
  .order-xl-7 {
    order: 7; }
  .order-xl-8 {
    order: 8; }
  .order-xl-9 {
    order: 9; }
  .order-xl-10 {
    order: 10; }
  .order-xl-11 {
    order: 11; }
  .order-xl-12 {
    order: 12; }
  .offset-xl-0 {
    margin-left: 0; }
  .offset-xl-1 {
    margin-left: 8.33333%; }
  .offset-xl-2 {
    margin-left: 16.66667%; }
  .offset-xl-3 {
    margin-left: 25%; }
  .offset-xl-4 {
    margin-left: 33.33333%; }
  .offset-xl-5 {
    margin-left: 41.66667%; }
  .offset-xl-6 {
    margin-left: 50%; }
  .offset-xl-7 {
    margin-left: 58.33333%; }
  .offset-xl-8 {
    margin-left: 66.66667%; }
  .offset-xl-9 {
    margin-left: 75%; }
  .offset-xl-10 {
    margin-left: 83.33333%; }
  .offset-xl-11 {
    margin-left: 91.66667%; } }

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent; }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6; }
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6; }
  .table tbody + tbody {
    border-top: 2px solid #dee2e6; }
  .table .table {
    background-color: #fff; }

.table-sm th,
.table-sm td {
  padding: 0.3rem; }

.table-bordered {
  border: 1px solid #dee2e6; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6; }
  .table-bordered thead th,
  .table-bordered thead td {
    border-bottom-width: 2px; }

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05); }

.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075); }

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #c9ceea; }

.table-hover .table-primary:hover {
  background-color: #b7bde3; }
  .table-hover .table-primary:hover > td,
  .table-hover .table-primary:hover > th {
    background-color: #b7bde3; }

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #f9c0d3; }

.table-hover .table-secondary:hover {
  background-color: #f7a9c3; }
  .table-hover .table-secondary:hover > td,
  .table-hover .table-secondary:hover > th {
    background-color: #f7a9c3; }

.table-success,
.table-success > th,
.table-success > td {
  background-color: #cde9ce; }

.table-hover .table-success:hover {
  background-color: #bbe1bd; }
  .table-hover .table-success:hover > td,
  .table-hover .table-success:hover > th {
    background-color: #bbe1bd; }

.table-info,
.table-info > th,
.table-info > td {
  background-color: #b8ecf3; }

.table-hover .table-info:hover {
  background-color: #a2e6ef; }
  .table-hover .table-info:hover > td,
  .table-hover .table-info:hover > th {
    background-color: #a2e6ef; }

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffe2b8; }

.table-hover .table-warning:hover {
  background-color: #ffd89f; }
  .table-hover .table-warning:hover > td,
  .table-hover .table-warning:hover > th {
    background-color: #ffd89f; }

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #fccac7; }

.table-hover .table-danger:hover {
  background-color: #fbb3af; }
  .table-hover .table-danger:hover > td,
  .table-hover .table-danger:hover > th {
    background-color: #fbb3af; }

.table-light,
.table-light > th,
.table-light > td {
  background-color: #f9f9fc; }

.table-hover .table-light:hover {
  background-color: #e8e8f4; }
  .table-hover .table-light:hover > td,
  .table-hover .table-light:hover > th {
    background-color: #e8e8f4; }

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c6c8ca; }

.table-hover .table-dark:hover {
  background-color: #b9bbbe; }
  .table-hover .table-dark:hover > td,
  .table-hover .table-dark:hover > th {
    background-color: #b9bbbe; }

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075); }

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075); }
  .table-hover .table-active:hover > td,
  .table-hover .table-active:hover > th {
    background-color: rgba(0, 0, 0, 0.075); }

.table .thead-dark th {
  color: #fff;
  background-color: #212529;
  border-color: #32383e; }

.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6; }

.table-dark {
  color: #fff;
  background-color: #212529; }
  .table-dark th,
  .table-dark td,
  .table-dark thead th {
    border-color: #32383e; }
  .table-dark.table-bordered {
    border: 0; }
  .table-dark.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(255, 255, 255, 0.05); }
  .table-dark.table-hover tbody tr:hover {
    background-color: rgba(255, 255, 255, 0.075); }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar; }
    .table-responsive-sm > .table-bordered {
      border: 0; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar; }
    .table-responsive-md > .table-bordered {
      border: 0; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar; }
    .table-responsive-lg > .table-bordered {
      border: 0; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar; }
    .table-responsive-xl > .table-bordered {
      border: 0; } }

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar; }
  .table-responsive > .table-bordered {
    border: 0; }

.table-middle td,
.table-middle thead th {
  vertical-align: middle; }

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 13px;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  .form-control::-ms-expand {
    background-color: transparent;
    border: 0; }
  .form-control:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .form-control::placeholder {
    color: #6c757d;
    opacity: 1; }
  .form-control:disabled, .form-control[readonly] {
    background-color: #e9ecef;
    opacity: 1; }

select.form-control:not([size]):not([multiple]) {
  height: calc(2.25rem + 2px); }

select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff; }

.form-control-file,
.form-control-range {
  display: block;
  width: 100%; }

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 17px;
  line-height: 1.5; }

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 13px;
  line-height: 1.5; }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0;
  line-height: 1.5;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0; }
  .form-control-plaintext.form-control-sm, .input-group-sm > .form-control-plaintext.form-control,
  .input-group-sm > .input-group-prepend > .form-control-plaintext.input-group-text,
  .input-group-sm > .input-group-append > .form-control-plaintext.input-group-text,
  .input-group-sm > .input-group-prepend > .form-control-plaintext.btn,
  .input-group-sm > .input-group-append > .form-control-plaintext.btn, .form-control-plaintext.form-control-lg, .input-group-lg > .form-control-plaintext.form-control,
  .input-group-lg > .input-group-prepend > .form-control-plaintext.input-group-text,
  .input-group-lg > .input-group-append > .form-control-plaintext.input-group-text,
  .input-group-lg > .input-group-prepend > .form-control-plaintext.btn,
  .input-group-lg > .input-group-append > .form-control-plaintext.btn {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm, .input-group-sm > .form-control,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 13px;
  line-height: 1.5;
  border-radius: 0.2rem; }

select.form-control-sm:not([size]):not([multiple]), .input-group-sm > select.form-control:not([size]):not([multiple]),
.input-group-sm > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),
.input-group-sm > .input-group-append > select.input-group-text:not([size]):not([multiple]),
.input-group-sm > .input-group-prepend > select.btn:not([size]):not([multiple]),
.input-group-sm > .input-group-append > select.btn:not([size]):not([multiple]) {
  height: calc(1.8125rem + 2px); }

.form-control-lg, .input-group-lg > .form-control,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 17px;
  line-height: 1.5;
  border-radius: 0.3rem; }

select.form-control-lg:not([size]):not([multiple]), .input-group-lg > select.form-control:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),
.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]) {
  height: calc(2.875rem + 2px); }

.form-group {
  margin-bottom: 1rem; }

.form-text {
  display: block;
  margin-top: 0.25rem; }

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px; }
  .form-row > .col,
  .form-row > [class*="col-"] {
    padding-right: 5px;
    padding-left: 5px; }

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem; }

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem; }
  .form-check-input:disabled ~ .form-check-label {
    color: #6c757d; }

.form-check-label {
  margin-bottom: 0; }

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem; }
  .form-check-inline .form-check-input {
    position: static;
    margin-top: 0;
    margin-right: 0.3125rem;
    margin-left: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #28a745; }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: .5rem;
  margin-top: .1rem;
  font-size: .875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.8);
  border-radius: .2rem; }

.was-validated .form-control:valid, .form-control.is-valid, .was-validated
.custom-select:valid,
.custom-select.is-valid {
  border-color: #28a745; }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus, .was-validated
  .custom-select:valid:focus,
  .custom-select.is-valid:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }
  .was-validated .form-control:valid ~ .valid-feedback,
  .was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
  .form-control.is-valid ~ .valid-tooltip, .was-validated
  .custom-select:valid ~ .valid-feedback,
  .was-validated
  .custom-select:valid ~ .valid-tooltip,
  .custom-select.is-valid ~ .valid-feedback,
  .custom-select.is-valid ~ .valid-tooltip {
    display: block; }

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28a745; }

.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745; }
  .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
    background-color: #71dd8a; }

.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  background-color: #34ce57; }

.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745; }
  .was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {
    border-color: inherit; }

.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545; }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: .5rem;
  margin-top: .1rem;
  font-size: .875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.8);
  border-radius: .2rem; }

.was-validated .form-control:invalid, .form-control.is-invalid, .was-validated
.custom-select:invalid,
.custom-select.is-invalid {
  border-color: #dc3545; }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus, .was-validated
  .custom-select:invalid:focus,
  .custom-select.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }
  .was-validated .form-control:invalid ~ .invalid-feedback,
  .was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
  .form-control.is-invalid ~ .invalid-tooltip, .was-validated
  .custom-select:invalid ~ .invalid-feedback,
  .was-validated
  .custom-select:invalid ~ .invalid-tooltip,
  .custom-select.is-invalid ~ .invalid-feedback,
  .custom-select.is-invalid ~ .invalid-tooltip {
    display: block; }

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545; }

.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545; }
  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
    background-color: #efa2a9; }

.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  background-color: #e4606d; }

.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545; }
  .was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {
    border-color: inherit; }

.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center; }
  .form-inline .form-check {
    width: 100%; }
  @media (min-width: 576px) {
    .form-inline label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0; }
    .form-inline .form-group {
      display: flex;
      flex: 0 0 auto;
      flex-flow: row wrap;
      align-items: center;
      margin-bottom: 0; }
    .form-inline .form-control {
      display: inline-block;
      width: auto;
      vertical-align: middle; }
    .form-inline .form-control-plaintext {
      display: inline-block; }
    .form-inline .input-group {
      width: auto; }
    .form-inline .form-check {
      display: flex;
      align-items: center;
      justify-content: center;
      width: auto;
      padding-left: 0; }
    .form-inline .form-check-input {
      position: relative;
      margin-top: 0;
      margin-right: 0.25rem;
      margin-left: 0; }
    .form-inline .custom-control {
      align-items: center;
      justify-content: center; }
    .form-inline .custom-control-label {
      margin-bottom: 0; } }

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 13px;
  line-height: 1.2;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  .btn:hover, .btn:focus {
    text-decoration: none; }
  .btn:focus, .btn.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .btn.disabled, .btn:disabled {
    opacity: 0.65;
    box-shadow: none; }
  .btn:not(:disabled):not(.disabled) {
    cursor: pointer; }
  .btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
    background-image: none;
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }
    .btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25), inset 0 3px 5px rgba(0, 0, 0, 0.125); }

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none; }

.btn-primary {
  color: #fff;
  background-color: #3f51b5;
  border-color: #3f51b5;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075); }
  .btn-primary:hover {
    color: #fff;
    background-color: #354499;
    border-color: #32408f; }
  .btn-primary:focus, .btn-primary.focus {
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(63, 81, 181, 0.5); }
  .btn-primary.disabled, .btn-primary:disabled {
    color: #fff;
    background-color: #3f51b5;
    border-color: #3f51b5; }
  .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
  .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #32408f;
    border-color: #2f3c86; }
    .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-primary.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(63, 81, 181, 0.5); }

.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075); }
  .btn-secondary:hover {
    color: #fff;
    background-color: #cd1453;
    border-color: #c1134e; }
  .btn-secondary:focus, .btn-secondary.focus {
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5); }
  .btn-secondary.disabled, .btn-secondary:disabled {
    color: #fff;
    background-color: #E91E63;
    border-color: #E91E63; }
  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: #c1134e;
    border-color: #b61249; }
    .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-secondary.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5); }

.btn-success {
  color: #fff;
  background-color: #4caf50;
  border-color: #4caf50;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075); }
  .btn-success:hover {
    color: #fff;
    background-color: #409444;
    border-color: #3d8b40; }
  .btn-success:focus, .btn-success.focus {
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(76, 175, 80, 0.5); }
  .btn-success.disabled, .btn-success:disabled {
    color: #fff;
    background-color: #4caf50;
    border-color: #4caf50; }
  .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,
  .show > .btn-success.dropdown-toggle {
    color: #fff;
    background-color: #3d8b40;
    border-color: #39833c; }
    .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,
    .show > .btn-success.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(76, 175, 80, 0.5); }

.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075); }
  .btn-info:hover {
    color: #fff;
    background-color: #009aae;
    border-color: #008fa1; }
  .btn-info:focus, .btn-info.focus {
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5); }
  .btn-info.disabled, .btn-info:disabled {
    color: #fff;
    background-color: #00bcd4;
    border-color: #00bcd4; }
  .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,
  .show > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #008fa1;
    border-color: #008394; }
    .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,
    .show > .btn-info.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5); }

.btn-warning {
  color: #212529;
  background-color: #ff9800;
  border-color: #ff9800;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075); }
  .btn-warning:hover {
    color: #fff;
    background-color: #d98100;
    border-color: #cc7a00; }
  .btn-warning:focus, .btn-warning.focus {
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(255, 152, 0, 0.5); }
  .btn-warning.disabled, .btn-warning:disabled {
    color: #212529;
    background-color: #ff9800;
    border-color: #ff9800; }
  .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,
  .show > .btn-warning.dropdown-toggle {
    color: #fff;
    background-color: #cc7a00;
    border-color: #bf7200; }
    .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,
    .show > .btn-warning.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(255, 152, 0, 0.5); }

.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075); }
  .btn-danger:hover {
    color: #fff;
    background-color: #f22112;
    border-color: #ea1c0d; }
  .btn-danger:focus, .btn-danger.focus {
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5); }
  .btn-danger.disabled, .btn-danger:disabled {
    color: #fff;
    background-color: #f44336;
    border-color: #f44336; }
  .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,
  .show > .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #ea1c0d;
    border-color: #de1b0c; }
    .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,
    .show > .btn-danger.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5); }

.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075); }
  .btn-light:hover {
    color: #212529;
    background-color: #cdd1eb;
    border-color: #c3c9e8; }
  .btn-light:focus, .btn-light.focus {
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5); }
  .btn-light.disabled, .btn-light:disabled {
    color: #212529;
    background-color: #e8eaf6;
    border-color: #e8eaf6; }
  .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,
  .show > .btn-light.dropdown-toggle {
    color: #212529;
    background-color: #c3c9e8;
    border-color: #bac0e4; }
    .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,
    .show > .btn-light.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5); }

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075); }
  .btn-dark:hover {
    color: #fff;
    background-color: #23272b;
    border-color: #1d2124; }
  .btn-dark:focus, .btn-dark.focus {
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }
  .btn-dark.disabled, .btn-dark:disabled {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
  .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,
  .show > .btn-dark.dropdown-toggle {
    color: #fff;
    background-color: #1d2124;
    border-color: #171a1d; }
    .btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,
    .show > .btn-dark.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }

.btn-outline-primary {
  color: #3f51b5;
  background-color: transparent;
  background-image: none;
  border-color: #3f51b5; }
  .btn-outline-primary:hover {
    color: #fff;
    background-color: #3f51b5;
    border-color: #3f51b5; }
  .btn-outline-primary:focus, .btn-outline-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(63, 81, 181, 0.5); }
  .btn-outline-primary.disabled, .btn-outline-primary:disabled {
    color: #3f51b5;
    background-color: transparent; }
  .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,
  .show > .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #3f51b5;
    border-color: #3f51b5; }
    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-primary.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(63, 81, 181, 0.5); }

.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63; }
  .btn-outline-secondary:hover {
    color: #fff;
    background-color: #E91E63;
    border-color: #E91E63; }
  .btn-outline-secondary:focus, .btn-outline-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5); }
  .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
    color: #E91E63;
    background-color: transparent; }
  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-outline-secondary.dropdown-toggle {
    color: #fff;
    background-color: #E91E63;
    border-color: #E91E63; }
    .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-secondary.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5); }

.btn-outline-success {
  color: #4caf50;
  background-color: transparent;
  background-image: none;
  border-color: #4caf50; }
  .btn-outline-success:hover {
    color: #fff;
    background-color: #4caf50;
    border-color: #4caf50; }
  .btn-outline-success:focus, .btn-outline-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.5); }
  .btn-outline-success.disabled, .btn-outline-success:disabled {
    color: #4caf50;
    background-color: transparent; }
  .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,
  .show > .btn-outline-success.dropdown-toggle {
    color: #fff;
    background-color: #4caf50;
    border-color: #4caf50; }
    .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-success.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(76, 175, 80, 0.5); }

.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4; }
  .btn-outline-info:hover {
    color: #fff;
    background-color: #00bcd4;
    border-color: #00bcd4; }
  .btn-outline-info:focus, .btn-outline-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5); }
  .btn-outline-info.disabled, .btn-outline-info:disabled {
    color: #00bcd4;
    background-color: transparent; }
  .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,
  .show > .btn-outline-info.dropdown-toggle {
    color: #fff;
    background-color: #00bcd4;
    border-color: #00bcd4; }
    .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-info.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5); }

.btn-outline-warning {
  color: #ff9800;
  background-color: transparent;
  background-image: none;
  border-color: #ff9800; }
  .btn-outline-warning:hover {
    color: #212529;
    background-color: #ff9800;
    border-color: #ff9800; }
  .btn-outline-warning:focus, .btn-outline-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 152, 0, 0.5); }
  .btn-outline-warning.disabled, .btn-outline-warning:disabled {
    color: #ff9800;
    background-color: transparent; }
  .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,
  .show > .btn-outline-warning.dropdown-toggle {
    color: #212529;
    background-color: #ff9800;
    border-color: #ff9800; }
    .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-warning.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(255, 152, 0, 0.5); }

.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336; }
  .btn-outline-danger:hover {
    color: #fff;
    background-color: #f44336;
    border-color: #f44336; }
  .btn-outline-danger:focus, .btn-outline-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5); }
  .btn-outline-danger.disabled, .btn-outline-danger:disabled {
    color: #f44336;
    background-color: transparent; }
  .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,
  .show > .btn-outline-danger.dropdown-toggle {
    color: #fff;
    background-color: #f44336;
    border-color: #f44336; }
    .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-danger.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5); }

.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6; }
  .btn-outline-light:hover {
    color: #212529;
    background-color: #e8eaf6;
    border-color: #e8eaf6; }
  .btn-outline-light:focus, .btn-outline-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5); }
  .btn-outline-light.disabled, .btn-outline-light:disabled {
    color: #e8eaf6;
    background-color: transparent; }
  .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,
  .show > .btn-outline-light.dropdown-toggle {
    color: #212529;
    background-color: #e8eaf6;
    border-color: #e8eaf6; }
    .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-light.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5); }

.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40; }
  .btn-outline-dark:hover {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
  .btn-outline-dark:focus, .btn-outline-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }
  .btn-outline-dark.disabled, .btn-outline-dark:disabled {
    color: #343a40;
    background-color: transparent; }
  .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,
  .show > .btn-outline-dark.dropdown-toggle {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
    .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-dark.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }

.btn-link {
  font-weight: 400;
  color: #3f51b5;
  background-color: transparent; }
  .btn-link:hover {
    color: #32408f;
    text-decoration: underline;
    background-color: transparent;
    border-color: transparent; }
  .btn-link:focus, .btn-link.focus {
    text-decoration: underline;
    border-color: transparent;
    box-shadow: none; }
  .btn-link:disabled, .btn-link.disabled {
    color: #6c757d; }

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 17px;
  line-height: 1.5;
  border-radius: 0.3rem; }

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 13px;
  line-height: 1.5;
  border-radius: 0.2rem; }

.btn-block {
  display: block;
  width: 100%; }
  .btn-block + .btn-block {
    margin-top: 0.5rem; }

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%; }

.fade {
  opacity: 0;
  transition: opacity 0.15s linear; }
  .fade.show {
    opacity: 1; }

.collapse {
  display: none; }
  .collapse.show {
    display: block; }

tr.collapse.show {
  display: table-row; }

tbody.collapse.show {
  display: table-row-group; }

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }

.dropup,
.dropdown {
  position: relative; }

.dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent; }

.dropdown-toggle:empty::after {
  margin-left: 0; }

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 13px;
  color: #5c5c5c;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175); }

.dropup .dropdown-menu {
  margin-top: 0;
  margin-bottom: 0.125rem; }

.dropup .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent; }

.dropup .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropright .dropdown-menu {
  margin-top: 0;
  margin-left: 0.125rem; }

.dropright .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid; }

.dropright .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropright .dropdown-toggle::after {
  vertical-align: 0; }

.dropleft .dropdown-menu {
  margin-top: 0;
  margin-right: 0.125rem; }

.dropleft .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: ""; }

.dropleft .dropdown-toggle::after {
  display: none; }

.dropleft .dropdown-toggle::before {
  display: inline-block;
  width: 0;
  height: 0;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent; }

.dropleft .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropleft .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0; }
  .dropdown-item:hover, .dropdown-item:focus {
    color: #16181b;
    text-decoration: none;
    background-color: #f8f9fa; }
  .dropdown-item.active, .dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color: #007bff; }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: #6c757d;
    background-color: transparent; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 13px;
  color: #6c757d;
  white-space: nowrap; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 0 1 auto; }
    .btn-group > .btn:hover,
    .btn-group-vertical > .btn:hover {
      z-index: 1; }
    .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
    .btn-group-vertical > .btn:focus,
    .btn-group-vertical > .btn:active,
    .btn-group-vertical > .btn.active {
      z-index: 1; }
  .btn-group .btn + .btn,
  .btn-group .btn + .btn-group,
  .btn-group .btn-group + .btn,
  .btn-group .btn-group + .btn-group,
  .btn-group-vertical .btn + .btn,
  .btn-group-vertical .btn + .btn-group,
  .btn-group-vertical .btn-group + .btn,
  .btn-group-vertical .btn-group + .btn-group {
    margin-left: -1px; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group > .btn:first-child {
  margin-left: 0; }

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  .dropdown-toggle-split::after {
    margin-left: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group.show .dropdown-toggle {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }
  .btn-group.show .dropdown-toggle.btn-link {
    box-shadow: none; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical .btn,
  .btn-group-vertical .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn + .btn,
  .btn-group-vertical > .btn + .btn-group,
  .btn-group-vertical > .btn-group + .btn,
  .btn-group-vertical > .btn-group + .btn-group {
    margin-top: -1px;
    margin-left: 0; }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0; }
  .btn-group-toggle > .btn input[type="radio"],
  .btn-group-toggle > .btn input[type="checkbox"],
  .btn-group-toggle > .btn-group > .btn input[type="radio"],
  .btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none; }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .custom-select,
  .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0; }
    .input-group > .form-control:focus,
    .input-group > .custom-select:focus,
    .input-group > .custom-file:focus {
      z-index: 3; }
    .input-group > .form-control + .form-control,
    .input-group > .form-control + .custom-select,
    .input-group > .form-control + .custom-file,
    .input-group > .custom-select + .form-control,
    .input-group > .custom-select + .custom-select,
    .input-group > .custom-select + .custom-file,
    .input-group > .custom-file + .form-control,
    .input-group > .custom-file + .custom-select,
    .input-group > .custom-file + .custom-file {
      margin-left: -1px; }
  .input-group > .form-control:not(:last-child),
  .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .input-group > .form-control:not(:first-child),
  .input-group > .custom-select:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }
  .input-group > .custom-file {
    display: flex;
    align-items: center; }
    .input-group > .custom-file:not(:last-child) .custom-file-label,
    .input-group > .custom-file:not(:last-child) .custom-file-label::before {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0; }
    .input-group > .custom-file:not(:first-child) .custom-file-label,
    .input-group > .custom-file:not(:first-child) .custom-file-label::before {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0; }

.input-group-prepend,
.input-group-append {
  display: flex; }
  .input-group-prepend .btn,
  .input-group-append .btn {
    position: relative;
    z-index: 2; }
  .input-group-prepend .btn + .btn,
  .input-group-prepend .btn + .input-group-text,
  .input-group-prepend .input-group-text + .input-group-text,
  .input-group-prepend .input-group-text + .btn,
  .input-group-append .btn + .btn,
  .input-group-append .btn + .input-group-text,
  .input-group-append .input-group-text + .input-group-text,
  .input-group-append .input-group-text + .btn {
    margin-left: -1px; }

.input-group-prepend {
  margin-right: -1px; }

.input-group-append {
  margin-left: -1px; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem; }
  .input-group-text input[type="radio"],
  .input-group-text input[type="checkbox"] {
    margin-top: 0; }

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem; }

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem; }

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0; }
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    background-color: #007bff;
    box-shadow: none; }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .custom-control-input:active ~ .custom-control-label::before {
    color: #fff;
    background-color: #b3d7ff;
    box-shadow: none; }
  .custom-control-input:disabled ~ .custom-control-label {
    color: #6c757d; }
    .custom-control-input:disabled ~ .custom-control-label::before {
      background-color: #e9ecef; }

.custom-control-label {
  margin-bottom: 0; }
  .custom-control-label::before {
    position: absolute;
    top: 0.25rem;
    left: 0;
    display: block;
    width: 1rem;
    height: 1rem;
    pointer-events: none;
    content: "";
    user-select: none;
    background-color: #dee2e6;
    box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1); }
  .custom-control-label::after {
    position: absolute;
    top: 0.25rem;
    left: 0;
    display: block;
    width: 1rem;
    height: 1rem;
    content: "";
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50% 50%; }

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem; }

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff; }

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  background-color: #007bff;
  box-shadow: none; }

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5); }

.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5); }

.custom-radio .custom-control-label::before {
  border-radius: 50%; }

.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff; }

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5); }

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat right 0.75rem center;
  background-size: 8px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none; }
  .custom-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 5px rgba(128, 189, 255, 0.5); }
    .custom-select:focus::-ms-value {
      color: #495057;
      background-color: #fff; }
  .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: 0.75rem;
    background-image: none; }
  .custom-select:disabled {
    color: #6c757d;
    background-color: #e9ecef; }
  .custom-select::-ms-expand {
    opacity: 0; }

.custom-select-sm {
  height: calc(1.8125rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 75%; }

.custom-select-lg {
  height: calc(2.875rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 125%; }

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(2.25rem + 2px);
  margin-bottom: 0; }

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(2.25rem + 2px);
  margin: 0;
  opacity: 0; }
  .custom-file-input:focus ~ .custom-file-control {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .custom-file-input:focus ~ .custom-file-control::before {
      border-color: #80bdff; }
  .custom-file-input:lang(en) ~ .custom-file-label::after {
    content: "Browse"; }

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }
  .custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(calc(2.25rem + 2px) - 1px * 2);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;
    content: "Browse";
    background-color: #e9ecef;
    border-left: 1px solid #ced4da;
    border-radius: 0 0.25rem 0.25rem 0; }

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }

.nav-link {
  display: block;
  padding: 0.5rem 1rem; }
  .nav-link:hover, .nav-link:focus {
    text-decoration: none; }
  .nav-link.disabled {
    color: #6c757d; }

.nav-tabs {
  border-bottom: 1px solid #dee2e6; }
  .nav-tabs .nav-item {
    margin-bottom: -1px; }
  .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem; }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      border-color: #e9ecef #e9ecef #dee2e6; }
    .nav-tabs .nav-link.disabled {
      color: #6c757d;
      background-color: transparent;
      border-color: transparent; }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff; }
  .nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills .nav-link {
  border-radius: 0.25rem; }

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #007bff; }

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem; }
  .navbar > .container,
  .navbar > .container-fluid {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    text-decoration: none; }

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  .navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0; }
  .navbar-nav .dropdown-menu {
    position: static;
    float: none; }

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem; }

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center; }

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem; }
  .navbar-toggler:hover, .navbar-toggler:focus {
    text-decoration: none; }
  .navbar-toggler:not(:disabled):not(.disabled) {
    cursor: pointer; }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%; }

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .dropdown-menu-right {
        right: 0;
        left: auto; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-sm > .container,
    .navbar-expand-sm > .container-fluid {
      flex-wrap: nowrap; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; }
    .navbar-expand-sm .dropup .dropdown-menu {
      top: auto;
      bottom: 100%; } }

@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .dropdown-menu-right {
        right: 0;
        left: auto; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-md > .container,
    .navbar-expand-md > .container-fluid {
      flex-wrap: nowrap; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; }
    .navbar-expand-md .dropup .dropdown-menu {
      top: auto;
      bottom: 100%; } }

@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .dropdown-menu-right {
        right: 0;
        left: auto; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-lg > .container,
    .navbar-expand-lg > .container-fluid {
      flex-wrap: nowrap; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; }
    .navbar-expand-lg .dropup .dropdown-menu {
      top: auto;
      bottom: 100%; } }

@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .dropdown-menu-right {
        right: 0;
        left: auto; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-xl > .container,
    .navbar-expand-xl > .container-fluid {
      flex-wrap: nowrap; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; }
    .navbar-expand-xl .dropup .dropdown-menu {
      top: auto;
      bottom: 100%; } }

.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid {
    padding-right: 0;
    padding-left: 0; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .dropdown-menu-right {
      right: 0;
      left: auto; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: 0.5rem;
      padding-left: 0.5rem; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid {
    flex-wrap: nowrap; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }
  .navbar-expand .dropup .dropdown-menu {
    top: auto;
    bottom: 100%; }

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9); }
  .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
    color: rgba(0, 0, 0, 0.9); }

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5); }
  .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
    color: rgba(0, 0, 0, 0.7); }
  .navbar-light .navbar-nav .nav-link.disabled {
    color: rgba(0, 0, 0, 0.3); }

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9); }

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1); }

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5); }
  .navbar-light .navbar-text a {
    color: rgba(0, 0, 0, 0.9); }
    .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
      color: rgba(0, 0, 0, 0.9); }

.navbar-dark .navbar-brand {
  color: #fff; }
  .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
    color: #fff; }

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5); }
  .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.75); }
  .navbar-dark .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25); }

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff; }

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1); }

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5); }
  .navbar-dark .navbar-text a {
    color: #fff; }
    .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
      color: #fff; }

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #dee2e6;
  border-radius: 8px; }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group:first-child .list-group-item:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px; }
  .card > .list-group:last-child .list-group-item:last-child {
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px; }

.card-body {
  flex: 1 1 auto;
  padding: 30px; }

.card-title {
  margin-bottom: 24px; }

.card-subtitle {
  margin-top: -12px;
  margin-bottom: 0; }

.card-text:last-child {
  margin-bottom: 0; }

.card-link:hover {
  text-decoration: none; }

.card-link + .card-link {
  margin-left: 30px; }

.card-header {
  padding: 24px 30px;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #dee2e6; }
  .card-header:first-child {
    border-radius: 8px 8px 0 0; }
  .card-header + .list-group .list-group-item:first-child {
    border-top: 0; }

.card-footer {
  padding: 24px 30px;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid #dee2e6; }
  .card-footer:last-child {
    border-radius: 0 0 8px 8px; }

.card-header-tabs {
  margin-right: -15px;
  margin-bottom: -24px;
  margin-left: -15px;
  border-bottom: 0; }

.card-header-pills {
  margin-right: -15px;
  margin-left: -15px; }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem; }

.card-img {
  width: 100%;
  border-radius: 8px; }

.card-img-top {
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px; }

.card-img-bottom {
  width: 100%;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px; }

.card-deck {
  display: flex;
  flex-direction: column; }
  .card-deck .card {
    margin-bottom: 15px; }
  @media (min-width: 576px) {
    .card-deck {
      flex-flow: row wrap;
      margin-right: -15px;
      margin-left: -15px; }
      .card-deck .card {
        display: flex;
        flex: 1 0 0%;
        flex-direction: column;
        margin-right: 15px;
        margin-bottom: 0;
        margin-left: 15px; } }

.card-group {
  display: flex;
  flex-direction: column; }
  .card-group > .card {
    margin-bottom: 15px; }
  @media (min-width: 576px) {
    .card-group {
      flex-flow: row wrap; }
      .card-group > .card {
        flex: 1 0 0%;
        margin-bottom: 0; }
        .card-group > .card + .card {
          margin-left: 0;
          border-left: 0; }
        .card-group > .card:first-child {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0; }
          .card-group > .card:first-child .card-img-top,
          .card-group > .card:first-child .card-header {
            border-top-right-radius: 0; }
          .card-group > .card:first-child .card-img-bottom,
          .card-group > .card:first-child .card-footer {
            border-bottom-right-radius: 0; }
        .card-group > .card:last-child {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0; }
          .card-group > .card:last-child .card-img-top,
          .card-group > .card:last-child .card-header {
            border-top-left-radius: 0; }
          .card-group > .card:last-child .card-img-bottom,
          .card-group > .card:last-child .card-footer {
            border-bottom-left-radius: 0; }
        .card-group > .card:only-child {
          border-radius: 8px; }
          .card-group > .card:only-child .card-img-top,
          .card-group > .card:only-child .card-header {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px; }
          .card-group > .card:only-child .card-img-bottom,
          .card-group > .card:only-child .card-footer {
            border-bottom-right-radius: 8px;
            border-bottom-left-radius: 8px; }
        .card-group > .card:not(:first-child):not(:last-child):not(:only-child) {
          border-radius: 0; }
          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,
          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,
          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-header,
          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-footer {
            border-radius: 0; } }

.card-columns .card {
  margin-bottom: 0.75rem; }

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem; }
    .card-columns .card {
      display: inline-block;
      width: 100%; } }

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 4px; }

.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: #6c757d;
  content: "/"; }

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline; }

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none; }

.breadcrumb-item.active {
  color: #6c757d; }

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 4px; }

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6; }
  .page-link:hover {
    color: #0056b3;
    text-decoration: none;
    background-color: #e9ecef;
    border-color: #dee2e6; }
  .page-link:focus {
    z-index: 2;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .page-link:not(:disabled):not(.disabled) {
    cursor: pointer; }

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px; }

.page-item:last-child .page-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px; }

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff; }

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6; }

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 17px;
  line-height: 1.5; }

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px; }

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px; }

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 13px;
  line-height: 1.5; }

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px; }

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px; }

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem; }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem; }

.badge-primary {
  color: #fff;
  background-color: #3f51b5; }
  .badge-primary[href]:hover, .badge-primary[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #32408f; }

.badge-secondary {
  color: #fff;
  background-color: #E91E63; }
  .badge-secondary[href]:hover, .badge-secondary[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #c1134e; }

.badge-success {
  color: #fff;
  background-color: #4caf50; }
  .badge-success[href]:hover, .badge-success[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #3d8b40; }

.badge-info {
  color: #fff;
  background-color: #00bcd4; }
  .badge-info[href]:hover, .badge-info[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #008fa1; }

.badge-warning {
  color: #212529;
  background-color: #ff9800; }
  .badge-warning[href]:hover, .badge-warning[href]:focus {
    color: #212529;
    text-decoration: none;
    background-color: #cc7a00; }

.badge-danger {
  color: #fff;
  background-color: #f44336; }
  .badge-danger[href]:hover, .badge-danger[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #ea1c0d; }

.badge-light {
  color: #212529;
  background-color: #e8eaf6; }
  .badge-light[href]:hover, .badge-light[href]:focus {
    color: #212529;
    text-decoration: none;
    background-color: #c3c9e8; }

.badge-dark {
  color: #fff;
  background-color: #343a40; }
  .badge-dark[href]:hover, .badge-dark[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #1d2124; }

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 8px; }
  @media (min-width: 576px) {
    .jumbotron {
      padding: 4rem 2rem; } }

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0; }

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem; }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 700; }

.alert-dismissible {
  padding-right: 4rem; }
  .alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.75rem 1.25rem;
    color: inherit; }

.alert-primary {
  color: #212a5e;
  background-color: #d9dcf0;
  border-color: #c9ceea; }
  .alert-primary hr {
    border-top-color: #b7bde3; }
  .alert-primary .alert-link {
    color: #141938; }

.alert-secondary {
  color: #791033;
  background-color: #fbd2e0;
  border-color: #f9c0d3; }
  .alert-secondary hr {
    border-top-color: #f7a9c3; }
  .alert-secondary .alert-link {
    color: #4c0a20; }

.alert-success {
  color: #285b2a;
  background-color: #dbefdc;
  border-color: #cde9ce; }
  .alert-success hr {
    border-top-color: #bbe1bd; }
  .alert-success .alert-link {
    color: #18381a; }

.alert-info {
  color: #00626e;
  background-color: #ccf2f6;
  border-color: #b8ecf3; }
  .alert-info hr {
    border-top-color: #a2e6ef; }
  .alert-info .alert-link {
    color: #00353b; }

.alert-warning {
  color: #854f00;
  background-color: #ffeacc;
  border-color: #ffe2b8; }
  .alert-warning hr {
    border-top-color: #ffd89f; }
  .alert-warning .alert-link {
    color: #523100; }

.alert-danger {
  color: #7f231c;
  background-color: #fdd9d7;
  border-color: #fccac7; }
  .alert-danger hr {
    border-top-color: #fbb3af; }
  .alert-danger .alert-link {
    color: #551713; }

.alert-light {
  color: #797a80;
  background-color: #fafbfd;
  border-color: #f9f9fc; }
  .alert-light hr {
    border-top-color: #e8e8f4; }
  .alert-light .alert-link {
    color: #606166; }

.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca; }
  .alert-dark hr {
    border-top-color: #b9bbbe; }
  .alert-dark .alert-link {
    color: #040505; }

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0; }
  to {
    background-position: 0 0; } }

.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1); }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  text-align: center;
  background-color: #007bff;
  transition: width 0.6s ease; }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem; }

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite; }

.media {
  display: flex;
  align-items: flex-start; }

.media-body {
  flex: 1; }

.social-list-line:not(:last-child) {
  padding-bottom: 25px; }

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0; }

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit; }
  .list-group-item-action:hover, .list-group-item-action:focus {
    color: #495057;
    text-decoration: none;
    background-color: #f8f9fa; }
  .list-group-item-action:active {
    color: #212529;
    background-color: #e9ecef; }

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125); }
  .list-group-item:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px; }
  .list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px; }
  .list-group-item:hover, .list-group-item:focus {
    z-index: 1;
    text-decoration: none; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: #6c757d;
    background-color: #fff; }
  .list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }

.list-group-flush .list-group-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0; }

.list-group-flush:first-child .list-group-item:first-child {
  border-top: 0; }

.list-group-flush:last-child .list-group-item:last-child {
  border-bottom: 0; }

.list-group-item-primary {
  color: #212a5e;
  background-color: #c9ceea; }
  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
    color: #212a5e;
    background-color: #b7bde3; }
  .list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #212a5e;
    border-color: #212a5e; }

.list-group-item-secondary {
  color: #791033;
  background-color: #f9c0d3; }
  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
    color: #791033;
    background-color: #f7a9c3; }
  .list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #791033;
    border-color: #791033; }

.list-group-item-success {
  color: #285b2a;
  background-color: #cde9ce; }
  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
    color: #285b2a;
    background-color: #bbe1bd; }
  .list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #285b2a;
    border-color: #285b2a; }

.list-group-item-info {
  color: #00626e;
  background-color: #b8ecf3; }
  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
    color: #00626e;
    background-color: #a2e6ef; }
  .list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #00626e;
    border-color: #00626e; }

.list-group-item-warning {
  color: #854f00;
  background-color: #ffe2b8; }
  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
    color: #854f00;
    background-color: #ffd89f; }
  .list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #854f00;
    border-color: #854f00; }

.list-group-item-danger {
  color: #7f231c;
  background-color: #fccac7; }
  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
    color: #7f231c;
    background-color: #fbb3af; }
  .list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #7f231c;
    border-color: #7f231c; }

.list-group-item-light {
  color: #797a80;
  background-color: #f9f9fc; }
  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
    color: #797a80;
    background-color: #e8e8f4; }
  .list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #797a80;
    border-color: #797a80; }

.list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca; }
  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
    color: #1b1e21;
    background-color: #b9bbbe; }
  .list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #1b1e21;
    border-color: #1b1e21; }

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  opacity: .5; }
  .close:hover, .close:focus {
    text-decoration: none;
    opacity: .75; }
  .close:not(:disabled):not(.disabled) {
    cursor: pointer; }

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  -webkit-appearance: none; }

.modal-open {
  overflow: hidden; }

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  outline: 0; }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -25%); }
  .modal.show .modal-dialog {
    transform: translate(0, 0); }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - (0.5rem * 2)); }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.5);
  outline: 0; }

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000; }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: 0.5; }

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px; }
  .modal-header .close {
    padding: 1rem;
    margin: -1rem -1rem -1rem auto; }

.modal-title {
  margin-bottom: 0;
  line-height: 1.5; }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem; }

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #e9ecef; }
  .modal-footer > :not(:first-child) {
    margin-left: .25rem; }
  .modal-footer > :not(:last-child) {
    margin-right: .25rem; }

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll; }

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto; }
  .modal-dialog-centered {
    min-height: calc(100% - (1.75rem * 2)); }
  .modal-content {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5); }
  .modal-sm {
    max-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg {
    max-width: 800px; } }

.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: 0.9; }
  .tooltip .arrow {
    position: absolute;
    display: block;
    width: 0.8rem;
    height: 0.4rem; }
    .tooltip .arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top, .bs-tooltip-auto[x-placement^="top"] {
  padding: 0.4rem 0; }
  .bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^="top"] .arrow {
    bottom: 0; }
    .bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
      top: 0;
      border-width: 0.4rem 0.4rem 0;
      border-top-color: #000; }

.bs-tooltip-right, .bs-tooltip-auto[x-placement^="right"] {
  padding: 0 0.4rem; }
  .bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^="right"] .arrow {
    left: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
      right: 0;
      border-width: 0.4rem 0.4rem 0.4rem 0;
      border-right-color: #000; }

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^="bottom"] {
  padding: 0.4rem 0; }
  .bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^="bottom"] .arrow {
    top: 0; }
    .bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
      bottom: 0;
      border-width: 0 0.4rem 0.4rem;
      border-bottom-color: #000; }

.bs-tooltip-left, .bs-tooltip-auto[x-placement^="left"] {
  padding: 0 0.4rem; }
  .bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^="left"] .arrow {
    right: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^="left"] .arrow::before {
      left: 0;
      border-width: 0.4rem 0 0.4rem 0.4rem;
      border-left-color: #000; }

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem; }

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2); }
  .popover .arrow {
    position: absolute;
    display: block;
    width: 1rem;
    height: 0.5rem;
    margin: 0 8px; }
    .popover .arrow::before, .popover .arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-popover-top, .bs-popover-auto[x-placement^="top"] {
  margin-bottom: 0.5rem; }
  .bs-popover-top .arrow, .bs-popover-auto[x-placement^="top"] .arrow {
    bottom: calc((0.5rem + 1px) * -1); }
  .bs-popover-top .arrow::before, .bs-popover-auto[x-placement^="top"] .arrow::before,
  .bs-popover-top .arrow::after,
  .bs-popover-auto[x-placement^="top"] .arrow::after {
    border-width: 0.5rem 0.5rem 0; }
  .bs-popover-top .arrow::before, .bs-popover-auto[x-placement^="top"] .arrow::before {
    bottom: 0;
    border-top-color: rgba(0, 0, 0, 0.25); }
  
  .bs-popover-top .arrow::after,
  .bs-popover-auto[x-placement^="top"] .arrow::after {
    bottom: 1px;
    border-top-color: #fff; }

.bs-popover-right, .bs-popover-auto[x-placement^="right"] {
  margin-left: 0.5rem; }
  .bs-popover-right .arrow, .bs-popover-auto[x-placement^="right"] .arrow {
    left: calc((0.5rem + 1px) * -1);
    width: 0.5rem;
    height: 1rem;
    margin: 8px 0; }
  .bs-popover-right .arrow::before, .bs-popover-auto[x-placement^="right"] .arrow::before,
  .bs-popover-right .arrow::after,
  .bs-popover-auto[x-placement^="right"] .arrow::after {
    border-width: 0.5rem 0.5rem 0.5rem 0; }
  .bs-popover-right .arrow::before, .bs-popover-auto[x-placement^="right"] .arrow::before {
    left: 0;
    border-right-color: rgba(0, 0, 0, 0.25); }
  
  .bs-popover-right .arrow::after,
  .bs-popover-auto[x-placement^="right"] .arrow::after {
    left: 1px;
    border-right-color: #fff; }

.bs-popover-bottom, .bs-popover-auto[x-placement^="bottom"] {
  margin-top: 0.5rem; }
  .bs-popover-bottom .arrow, .bs-popover-auto[x-placement^="bottom"] .arrow {
    top: calc((0.5rem + 1px) * -1); }
  .bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^="bottom"] .arrow::before,
  .bs-popover-bottom .arrow::after,
  .bs-popover-auto[x-placement^="bottom"] .arrow::after {
    border-width: 0 0.5rem 0.5rem 0.5rem; }
  .bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^="bottom"] .arrow::before {
    top: 0;
    border-bottom-color: rgba(0, 0, 0, 0.25); }
  
  .bs-popover-bottom .arrow::after,
  .bs-popover-auto[x-placement^="bottom"] .arrow::after {
    top: 1px;
    border-bottom-color: #fff; }
  .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^="bottom"] .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: 1rem;
    margin-left: -0.5rem;
    content: "";
    border-bottom: 1px solid #f7f7f7; }

.bs-popover-left, .bs-popover-auto[x-placement^="left"] {
  margin-right: 0.5rem; }
  .bs-popover-left .arrow, .bs-popover-auto[x-placement^="left"] .arrow {
    right: calc((0.5rem + 1px) * -1);
    width: 0.5rem;
    height: 1rem;
    margin: 8px 0; }
  .bs-popover-left .arrow::before, .bs-popover-auto[x-placement^="left"] .arrow::before,
  .bs-popover-left .arrow::after,
  .bs-popover-auto[x-placement^="left"] .arrow::after {
    border-width: 0.5rem 0 0.5rem 0.5rem; }
  .bs-popover-left .arrow::before, .bs-popover-auto[x-placement^="left"] .arrow::before {
    right: 0;
    border-left-color: rgba(0, 0, 0, 0.25); }
  
  .bs-popover-left .arrow::after,
  .bs-popover-auto[x-placement^="left"] .arrow::after {
    right: 1px;
    border-left-color: #fff; }

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 13px;
  color: inherit;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(8px - 1px);
  border-top-right-radius: calc(8px - 1px); }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529; }

.carousel {
  position: relative; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }

.carousel-item {
  position: relative;
  display: none;
  align-items: center;
  width: 100%;
  transition: transform 0.6s ease;
  backface-visibility: hidden;
  perspective: 1000px; }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next,
.carousel-item-prev {
  position: absolute;
  top: 0; }

.carousel-item-next.carousel-item-left,
.carousel-item-prev.carousel-item-right {
  transform: translateX(0); }
  @supports (transform-style: preserve-3d) {
    .carousel-item-next.carousel-item-left,
    .carousel-item-prev.carousel-item-right {
      transform: translate3d(0, 0, 0); } }

.carousel-item-next,
.active.carousel-item-right {
  transform: translateX(100%); }
  @supports (transform-style: preserve-3d) {
    .carousel-item-next,
    .active.carousel-item-right {
      transform: translate3d(100%, 0, 0); } }

.carousel-item-prev,
.active.carousel-item-left {
  transform: translateX(-100%); }
  @supports (transform-style: preserve-3d) {
    .carousel-item-prev,
    .active.carousel-item-left {
      transform: translate3d(-100%, 0, 0); } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5; }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: .9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: transparent no-repeat center center;
  background-size: 100% 100%; }

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 10px;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none; }
  .carousel-indicators li {
    position: relative;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    background-color: rgba(255, 255, 255, 0.5); }
    .carousel-indicators li::before {
      position: absolute;
      top: -10px;
      left: 0;
      display: inline-block;
      width: 100%;
      height: 10px;
      content: ""; }
    .carousel-indicators li::after {
      position: absolute;
      bottom: -10px;
      left: 0;
      display: inline-block;
      width: 100%;
      height: 10px;
      content: ""; }
  .carousel-indicators .active {
    background-color: #fff; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.bg-primary {
  background-color: #3f51b5 !important; }

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #32408f !important; }

.bg-secondary {
  background-color: #E91E63 !important; }

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #c1134e !important; }

.bg-success {
  background-color: #4caf50 !important; }

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #3d8b40 !important; }

.bg-info {
  background-color: #00bcd4 !important; }

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #008fa1 !important; }

.bg-warning {
  background-color: #ff9800 !important; }

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #cc7a00 !important; }

.bg-danger {
  background-color: #f44336 !important; }

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #ea1c0d !important; }

.bg-light {
  background-color: #e8eaf6 !important; }

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #c3c9e8 !important; }

.bg-dark {
  background-color: #343a40 !important; }

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #1d2124 !important; }

.bg-white {
  background-color: #fff !important; }

.bg-transparent {
  background-color: transparent !important; }

.border {
  border: 1px solid #dee2e6 !important; }

.border-top {
  border-top: 1px solid #dee2e6 !important; }

.border-right {
  border-right: 1px solid #dee2e6 !important; }

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important; }

.border-left {
  border-left: 1px solid #dee2e6 !important; }

.border-0 {
  border: 0 !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-right-0 {
  border-right: 0 !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-left-0 {
  border-left: 0 !important; }

.border-primary {
  border-color: #3f51b5 !important; }

.border-secondary {
  border-color: #E91E63 !important; }

.border-success {
  border-color: #4caf50 !important; }

.border-info {
  border-color: #00bcd4 !important; }

.border-warning {
  border-color: #ff9800 !important; }

.border-danger {
  border-color: #f44336 !important; }

.border-light {
  border-color: #e8eaf6 !important; }

.border-dark {
  border-color: #343a40 !important; }

.border-white {
  border-color: #fff !important; }

.rounded {
  border-radius: 4px !important; }

.rounded-top {
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important; }

.rounded-right {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important; }

.rounded-bottom {
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 4px !important; }

.rounded-left {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-0 {
  border-radius: 0 !important; }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.d-none {
  display: none !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 768px) {
  .d-md-none {
    display: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; } }

@media print {
  .d-print-none {
    display: none !important; }
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; } }

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden; }
  .embed-responsive::before {
    display: block;
    content: ""; }
  .embed-responsive .embed-responsive-item,
  .embed-responsive iframe,
  .embed-responsive embed,
  .embed-responsive object,
  .embed-responsive video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0; }

.embed-responsive-21by9::before {
  padding-top: 42.85714%; }

.embed-responsive-16by9::before {
  padding-top: 56.25%; }

.embed-responsive-4by3::before {
  padding-top: 75%; }

.embed-responsive-1by1::before {
  padding-top: 100%; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; } }

@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; } }

@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; } }

@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; } }

.float-left {
  float: left !important; }

.float-right {
  float: right !important; }

.float-none {
  float: none !important; }

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important; }
  .float-sm-right {
    float: right !important; }
  .float-sm-none {
    float: none !important; } }

@media (min-width: 768px) {
  .float-md-left {
    float: left !important; }
  .float-md-right {
    float: right !important; }
  .float-md-none {
    float: none !important; } }

@media (min-width: 992px) {
  .float-lg-left {
    float: left !important; }
  .float-lg-right {
    float: right !important; }
  .float-lg-none {
    float: none !important; } }

@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important; }
  .float-xl-right {
    float: right !important; }
  .float-xl-none {
    float: none !important; } }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: sticky !important; }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020; } }

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  clip-path: inset(50%);
  border: 0; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
  clip-path: none; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.mw-100 {
  max-width: 100% !important; }

.mh-100 {
  max-height: 100% !important; }

.m-0 {
  margin: 0 !important; }

.mt-0,
.my-0 {
  margin-top: 0 !important; }

.mr-0,
.mx-0 {
  margin-right: 0 !important; }

.mb-0,
.my-0 {
  margin-bottom: 0 !important; }

.ml-0,
.mx-0 {
  margin-left: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.mt-1,
.my-1 {
  margin-top: 0.25rem !important; }

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important; }

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important; }

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.mt-2,
.my-2 {
  margin-top: 0.5rem !important; }

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important; }

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important; }

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.mt-3,
.my-3 {
  margin-top: 1rem !important; }

.mr-3,
.mx-3 {
  margin-right: 1rem !important; }

.mb-3,
.my-3 {
  margin-bottom: 1rem !important; }

.ml-3,
.mx-3 {
  margin-left: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.mt-4,
.my-4 {
  margin-top: 1.5rem !important; }

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important; }

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important; }

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.mt-5,
.my-5 {
  margin-top: 3rem !important; }

.mr-5,
.mx-5 {
  margin-right: 3rem !important; }

.mb-5,
.my-5 {
  margin-bottom: 3rem !important; }

.ml-5,
.mx-5 {
  margin-left: 3rem !important; }

.p-0 {
  padding: 0 !important; }

.pt-0,
.py-0 {
  padding-top: 0 !important; }

.pr-0,
.px-0 {
  padding-right: 0 !important; }

.pb-0,
.py-0 {
  padding-bottom: 0 !important; }

.pl-0,
.px-0 {
  padding-left: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.pt-1,
.py-1 {
  padding-top: 0.25rem !important; }

.pr-1,
.px-1 {
  padding-right: 0.25rem !important; }

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important; }

.pl-1,
.px-1 {
  padding-left: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.pt-2,
.py-2 {
  padding-top: 0.5rem !important; }

.pr-2,
.px-2 {
  padding-right: 0.5rem !important; }

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important; }

.pl-2,
.px-2 {
  padding-left: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.pt-3,
.py-3 {
  padding-top: 1rem !important; }

.pr-3,
.px-3 {
  padding-right: 1rem !important; }

.pb-3,
.py-3 {
  padding-bottom: 1rem !important; }

.pl-3,
.px-3 {
  padding-left: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.pt-4,
.py-4 {
  padding-top: 1.5rem !important; }

.pr-4,
.px-4 {
  padding-right: 1.5rem !important; }

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important; }

.pl-4,
.px-4 {
  padding-left: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.pt-5,
.py-5 {
  padding-top: 3rem !important; }

.pr-5,
.px-5 {
  padding-right: 3rem !important; }

.pb-5,
.py-5 {
  padding-bottom: 3rem !important; }

.pl-5,
.px-5 {
  padding-left: 3rem !important; }

.m-auto {
  margin: auto !important; }

.mt-auto,
.my-auto {
  margin-top: auto !important; }

.mr-auto,
.mx-auto {
  margin-right: auto !important; }

.mb-auto,
.my-auto {
  margin-bottom: auto !important; }

.ml-auto,
.mx-auto {
  margin-left: auto !important; }

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important; }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important; }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important; }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important; }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important; }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important; }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important; }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important; }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important; }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important; }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important; }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important; }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important; }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important; }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important; }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important; }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important; }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important; }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important; }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important; }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important; }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important; }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important; }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important; }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important; }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important; }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important; }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important; }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important; }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important; }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important; }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important; }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important; }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important; }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important; }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important; }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important; }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important; } }

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important; }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important; }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important; }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important; }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important; }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important; }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important; }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important; }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important; }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important; }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important; }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important; }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important; }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important; }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important; }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important; }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important; }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important; }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important; }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important; }
  .p-md-0 {
    padding: 0 !important; }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important; }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important; }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important; }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important; }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important; }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important; }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important; }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important; }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important; }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important; }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important; }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important; }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important; }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important; }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important; }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important; }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important; }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important; }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important; }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important; }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important; }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important; } }

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important; }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important; }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important; }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important; }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important; }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important; }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important; }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important; }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important; }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important; }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important; }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important; }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important; }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important; }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important; }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important; }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important; }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important; }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important; }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important; }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important; }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important; }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important; }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important; }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important; }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important; }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important; }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important; }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important; }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important; }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important; }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important; }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important; }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important; }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important; }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important; }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important; }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important; } }

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important; }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important; }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important; }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important; }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important; }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important; }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important; }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important; }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important; }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important; }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important; }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important; }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important; }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important; }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important; }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important; }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important; }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important; }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important; }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important; }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important; }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important; }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important; }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important; }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important; }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important; }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important; }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important; }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important; }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important; }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important; }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important; }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important; }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important; }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important; }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important; }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important; }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important; } }

.text-justify {
  text-align: justify !important; }

.text-nowrap {
  white-space: nowrap !important; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.text-left {
  text-align: left !important; }

.text-right {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important; }
  .text-sm-right {
    text-align: right !important; }
  .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important; }
  .text-md-right {
    text-align: right !important; }
  .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important; }
  .text-lg-right {
    text-align: right !important; }
  .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important; }
  .text-xl-right {
    text-align: right !important; }
  .text-xl-center {
    text-align: center !important; } }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.font-weight-light {
  font-weight: 300 !important; }

.font-weight-normal {
  font-weight: 400 !important; }

.font-weight-bold {
  font-weight: 700 !important; }

.font-italic {
  font-style: italic !important; }

.text-white {
  color: #fff !important; }

.text-primary {
  color: #3f51b5 !important; }

a.text-primary:hover, a.text-primary:focus {
  color: #32408f !important; }

.text-secondary {
  color: #E91E63 !important; }

a.text-secondary:hover, a.text-secondary:focus {
  color: #c1134e !important; }

.text-success {
  color: #4caf50 !important; }

a.text-success:hover, a.text-success:focus {
  color: #3d8b40 !important; }

.text-info {
  color: #00bcd4 !important; }

a.text-info:hover, a.text-info:focus {
  color: #008fa1 !important; }

.text-warning {
  color: #ff9800 !important; }

a.text-warning:hover, a.text-warning:focus {
  color: #cc7a00 !important; }

.text-danger {
  color: #f44336 !important; }

a.text-danger:hover, a.text-danger:focus {
  color: #ea1c0d !important; }

.text-light {
  color: #e8eaf6 !important; }

a.text-light:hover, a.text-light:focus {
  color: #c3c9e8 !important; }

.text-dark {
  color: #343a40 !important; }

a.text-dark:hover, a.text-dark:focus {
  color: #1d2124 !important; }

.text-muted {
  color: #6c757d !important; }

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important; }
  a:not(.btn) {
    text-decoration: underline; }
  abbr[title]::after {
    content: " (" attr(title) ")"; }
  pre {
    white-space: pre-wrap !important; }
  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid; }
  thead {
    display: table-header-group; }
  tr,
  img {
    page-break-inside: avoid; }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3; }
  h2,
  h3 {
    page-break-after: avoid; }
  @page {
    size: a3; }
  body {
    min-width: 992px !important; }
  .container {
    min-width: 992px !important; }
  .navbar {
    display: none; }
  .badge {
    border: 1px solid #000; }
  .table {
    border-collapse: collapse !important; }
    .table td,
    .table th {
      background-color: #fff !important; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #ddd !important; } }
`, "",{"version":3,"sources":["webpack://./styles/bootstrap/bootstrap.scss","webpack://./styles/bootstrap.scss","webpack://./styles/bootstrap/_root.scss","webpack://./styles/bootstrap/_reboot.scss","webpack://./styles/global/_variables.scss","webpack://./styles/bootstrap/_variables.scss","webpack://./styles/bootstrap/mixins/_hover.scss","webpack://./styles/bootstrap/_type.scss","webpack://./styles/bootstrap/mixins/_lists.scss","webpack://./styles/bootstrap/_images.scss","webpack://./styles/bootstrap/mixins/_image.scss","webpack://./styles/bootstrap/mixins/_border-radius.scss","webpack://./styles/bootstrap/mixins/_box-shadow.scss","webpack://./styles/bootstrap/_code.scss","webpack://./styles/bootstrap/_grid.scss","webpack://./styles/bootstrap/mixins/_grid.scss","webpack://./styles/bootstrap/mixins/_breakpoints.scss","webpack://./styles/bootstrap/mixins/_grid-framework.scss","webpack://./styles/bootstrap/_tables.scss","webpack://./styles/bootstrap/mixins/_table-row.scss","webpack://./styles/bootstrap/_functions.scss","webpack://./styles/bootstrap/_forms.scss","webpack://./styles/bootstrap/mixins/_transition.scss","webpack://./styles/bootstrap/mixins/_forms.scss","webpack://./styles/bootstrap/mixins/_gradients.scss","webpack://./styles/bootstrap/_buttons.scss","webpack://./styles/bootstrap/mixins/_buttons.scss","webpack://./styles/bootstrap/_transitions.scss","webpack://./styles/bootstrap/_dropdown.scss","webpack://./styles/bootstrap/mixins/_caret.scss","webpack://./styles/bootstrap/mixins/_nav-divider.scss","webpack://./styles/bootstrap/_button-group.scss","webpack://./styles/bootstrap/_input-group.scss","webpack://./styles/bootstrap/_custom-forms.scss","webpack://./styles/bootstrap/_nav.scss","webpack://./styles/bootstrap/_navbar.scss","webpack://./styles/bootstrap/_card.scss","webpack://./styles/bootstrap/_breadcrumb.scss","webpack://./styles/bootstrap/_pagination.scss","webpack://./styles/bootstrap/mixins/_pagination.scss","webpack://./styles/bootstrap/_badge.scss","webpack://./styles/bootstrap/mixins/_badge.scss","webpack://./styles/bootstrap/_jumbotron.scss","webpack://./styles/bootstrap/_alert.scss","webpack://./styles/bootstrap/mixins/_alert.scss","webpack://./styles/bootstrap/_progress.scss","webpack://./styles/bootstrap/_media.scss","webpack://./styles/bootstrap/_list-group.scss","webpack://./styles/bootstrap/mixins/_list-group.scss","webpack://./styles/bootstrap/_close.scss","webpack://./styles/bootstrap/_modal.scss","webpack://./styles/bootstrap/_tooltip.scss","webpack://./styles/bootstrap/mixins/_reset-text.scss","webpack://./styles/bootstrap/_popover.scss","webpack://./styles/bootstrap/_carousel.scss","webpack://./styles/bootstrap/utilities/_align.scss","webpack://./styles/bootstrap/mixins/_background-variant.scss","webpack://./styles/bootstrap/utilities/_background.scss","webpack://./styles/bootstrap/utilities/_borders.scss","webpack://./styles/bootstrap/mixins/_clearfix.scss","webpack://./styles/bootstrap/utilities/_display.scss","webpack://./styles/bootstrap/utilities/_embed.scss","webpack://./styles/bootstrap/utilities/_flex.scss","webpack://./styles/bootstrap/utilities/_float.scss","webpack://./styles/bootstrap/mixins/_float.scss","webpack://./styles/bootstrap/utilities/_position.scss","webpack://./styles/bootstrap/utilities/_screenreaders.scss","webpack://./styles/bootstrap/mixins/_screen-reader.scss","webpack://./styles/bootstrap/utilities/_sizing.scss","webpack://./styles/bootstrap/utilities/_spacing.scss","webpack://./styles/bootstrap/utilities/_text.scss","webpack://./styles/bootstrap/mixins/_text-truncate.scss","webpack://./styles/bootstrap/mixins/_text-emphasis.scss","webpack://./styles/bootstrap/mixins/_text-hide.scss","webpack://./styles/bootstrap/utilities/_visibility.scss","webpack://./styles/bootstrap/mixins/_visibility.scss","webpack://./styles/bootstrap/_print.scss"],"names":[],"mappings":"AAAA;;;;;ECQE;ACRF;EAGI,eAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,eAAc;EAAd,cAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,eAAc;EAAd,oBAAc;EAId,kBAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd,eAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,eAAc;EAId,kBAAiC;EAAjC,sBAAiC;EAAjC,sBAAiC;EAAjC,sBAAiC;EAAjC,uBAAiC;EAKnC,8CAAyB;EACzB,6GAAwB,EAAA;;ACE1B;;;EAGE,sBAAsB,EAAA;;AAGxB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,6CAA6C,EAAA;;AAK7C;EACE,mBAAmB,EAAA;;AAMvB;EACE,cAAc,EAAA;;AAYhB;EACE,SAAS;EACT,iCC1C2C;ED2C3C,eCvCmB;EDwCnB,gBE4KsB;EF3KtB,gBE+KoB;EF9KpB,cCiCkB;EDhClB,gBAAgB;EAChB,sBC8BY,EAAA;;AH1Bd;EEKE,qBAAqB,EAAA;;AAQvB;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB,EAAA;;AAYnB;EACE,aAAa;EACb,mBCnE0C,EAAA;;AD4E5C;EACE,aAAa;EACb,mBE+C4B,EAAA;;AFrC9B;;EAEE,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB;;;EAGE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;;;EAIE,gBAAgB,EAAA;;AAGlB;EACE,gBEqFoB,EAAA;;AFlFtB;EACE,oBAAoB;EACpB,cAAc,EAAA;;AAGhB;EACE,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB,EAAA;;AAIpB;;EAEE,mBAAmB,EAAA;;AAKrB;EACE,cAAc,EAAA;;AAQhB;;EAEE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EACE,cAAc,EAAA;;AAGhB;EACE,UAAU,EAAA;;AAOZ;EACE,cChJmB;EDiJnB,qBEvDoB;EFwDpB,6BAA6B;EAC7B,qCAAqC,EAAA;EG/LrC;IHkME,cC3HwC;ID4HxC,0BE3D6B,EAAA;;AFqEjC;EACE,cAAc;EACd,qBAAqB,EAAA;EGzMrB;IH4ME,cAAc;IACd,qBAAqB,EAAA;EANzB;IAUI,UAAU,EAAA;;AASd;;;;EAIE,iCAAiC;EACjC,cAAc,EAAA;;AAKhB;EAEE,aAAa;EAEb,mBAAmB;EAEnB,cAAc;EAGd,6BAA6B,EAAA;;AAO/B;EAEE,gBAAgB,EAAA;;AAOlB;EACE,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB,EAAA;;AAOlB;EACE,yBAAyB,EAAA;;AAG3B;EACE,oBECyB;EFAzB,uBEAyB;EFCzB,cErRgB;EFsRhB,gBAAgB;EAChB,oBAAoB,EAAA;;AAGtB;EAGE,mBAAmB,EAAA;;AAOrB;EAEE,qBAAqB;EACrB,oBAAoB,EAAA;;AAMtB;EACE,gBAAgB,EAAA;;AAOlB;EACE,mBAAmB;EACnB,0CAA0C,EAAA;;AAG5C;;;;;EAKE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB;;EAEE,iBAAiB,EAAA;;AAGnB;;EAEE,oBAAoB,EAAA;;AAMtB;;;;EAIE,0BAA0B,EAAA;;AAI5B;;;;EAIE,UAAU;EACV,kBAAkB,EAAA;;AAGpB;;EAEE,sBAAsB;EACtB,UAAU,EAAA;;AAGZ;;;;EASE,2BAA2B,EAAA;;AAG7B;EACE,cAAc;EAEd,gBAAgB,EAAA;;AAGlB;EAME,YAAY;EAEZ,UAAU;EACV,SAAS;EACT,SAAS,EAAA;;AAKX;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB,EAAA;;AFtJ1B;;EE4JE,YAAY,EAAA;;AFxJd;EEgKE,oBAAoB;EACpB,wBAAwB,EAAA;;AF7J1B;;EEsKE,wBAAwB,EAAA;;AAQ1B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAO5B;EACE,qBAAqB,EAAA;;AAGvB;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,aAAa,EAAA;;AF/Kf;EEqLE,wBAAwB,EAAA;;AIzd1B;;EAEE,mBHuB0C;EGtB1C,oBHuB4B;EGtB5B,gBHuBwB;EGtBxB,gBHuBwB;EGtBxB,cHuBsB,EAAA;;AGpBxB;EACE,eHQiB,EAAA;;AGLnB;EACE,eHKiB,EAAA;;AGFnB;EACE,eHEiB,EAAA;;AGCnB;EACE,eHDiB,EAAA;;AGInB;EACE,eHJiB,EAAA;;AGOnB;EACE,eHPiB,EAAA;;AGUnB;EACE,kBF8NuC;EE7NvC,gBF8NoB,EAAA;;AE1NtB;EACE,eF6MkB;EE5MlB,gBFiNmB;EEhNnB,gBFwMwB,EAAA;;AErM1B;EACE,iBFwMoB;EEvMpB,gBF4MmB;EE3MnB,gBFkMwB,EAAA;;AE/L1B;EACE,iBFmMoB;EElMpB,gBFuMmB;EEtMnB,gBF4LwB,EAAA;;AEzL1B;EACE,iBF8LoB;EE7LpB,gBFkMmB;EEjMnB,gBFsLwB,EAAA;;AFvK1B;EIPE,gBFyCW;EExCX,mBFwCW;EEvCX,SAAS;EACT,wCFzDU,EAAA;;AEgEZ;;EAEE,cFmLmB;EElLnB,gBFiJsB,EAAA;;AE9IxB;;EAEE,cFuLiB;EEtLjB,yBF+Le,EAAA;;AExLjB;EChGE,eAAe;EACf,gBAAgB,EAAA;;ADoGlB;ECrGE,eAAe;EACf,gBAAgB,EAAA;;ADwGlB;EACE,qBAAqB,EAAA;EADvB;IAII,oBFyKuB,EAAA;;AEhK3B;EACE,cAAc;EACd,yBAAyB,EAAA;;AAI3B;EACE,mBFdW;EEeX,kBF4I6C,EAAA;;AEzI/C;EACE,cAAc;EACd,cAAc;EACd,cFxHgB,EAAA;EEqHlB;IAMI,sBAAsB,EAAA;;AEpI1B;ECGE,eAAe;EAGf,YAAY,EAAA;;ADDd;EACE,gBJgxBwB;EI/wBxB,sBJJU;EIKV,yBJFgB;EMTd,sBNwMkB;EO1MlB,0CPkBQ;EKVV,eAAe;EAGf,YAAY,EAAA;;ADcd;EAEE,qBAAqB,EAAA;;AAGvB;EACE,qBAA4B;EAC5B,cAAc,EAAA;;AAGhB;EACE,cJgwB4B;EI/vB5B,cJvBgB,EAAA;;AQflB;;;;EAIE,iGR0N0G,EAAA;;AQtN5G;EACE,gBR00BoB;EQz0BpB,cR2BY;EQ1BZ,sBAAsB,EAAA;EAGtB;IACE,cAAc,EAAA;;AAKlB;EACE,sBRk0BmB;EQj0BnB,gBR6zBoB;EQ5zBpB,WRdU;EQeV,yBRNgB;EMfd,kBPkCkB;EQpClB,iDPkBQ,EAAA;EQCZ;IASI,UAAU;IACV,eAAe;IACf,gBRyMkB;IOvOlB,gBC+BwB,EAAA;;AVuN5B;EUjNE,cAAc;EACd,gBR4yBoB;EQ3yBpB,cRtBgB,EAAA;EQmBlB;IAOI,kBAAkB;IAClB,cAAc;IACd,kBAAkB,EAAA;;AAKtB;EACE,iBRyyB+B;EQxyB/B,kBAAkB,EAAA;;ACjDlB;ECAA,WAAW;EACX,mBAAuC;EACvC,kBAAsC;EACtC,kBAAkB;EAClB,iBAAiB,EAAA;ECmDf;IFvDF;MCWI,gBVmKW,EAAA,ES3Kd;EEoDC;IFvDF;MCWI,gBVoKW,EAAA,ES5Kd;EEoDC;IFvDF;MCWI,gBVqKW,EAAA,ES7Kd;EEoDC;IFvDF;MCWI,iBVsKY,EAAA,ES9Kf;;AASD;ECZA,WAAW;EACX,mBAAuC;EACvC,kBAAsC;EACtC,kBAAkB;EAClB,iBAAiB,EAAA;;ADkBjB;ECLA,aAAa;EACb,eAAe;EACf,mBAAuC;EACvC,kBAAsC,EAAA;;ADQtC;EACE,eAAe;EACf,cAAc,EAAA;EAFhB;;IAMI,gBAAgB;IAChB,eAAe,EAAA;;AGjCnB;;;;;;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAA4B;EAC5B,kBAA2B,EAAA;;AAmBzB;EACE,aAAa;EACb,YAAY;EACZ,eAAe,EAAA;;AAEjB;EACE,cAAc;EACd,WAAW;EACX,eAAe,EAAA;;AAIf;EFHN,kBAAsC;EAItC,mBAAuC,EAAA;;AEDjC;EFHN,mBAAsC;EAItC,oBAAuC,EAAA;;AEDjC;EFHN,aAAsC;EAItC,cAAuC,EAAA;;AEDjC;EFHN,mBAAsC;EAItC,oBAAuC,EAAA;;AEDjC;EFHN,mBAAsC;EAItC,oBAAuC,EAAA;;AEDjC;EFHN,aAAsC;EAItC,cAAuC,EAAA;;AEDjC;EFHN,mBAAsC;EAItC,oBAAuC,EAAA;;AEDjC;EFHN,mBAAsC;EAItC,oBAAuC,EAAA;;AEDjC;EFHN,aAAsC;EAItC,cAAuC,EAAA;;AEDjC;EFHN,mBAAsC;EAItC,oBAAuC,EAAA;;AEDjC;EFHN,mBAAsC;EAItC,oBAAuC,EAAA;;AEDjC;EFHN,cAAsC;EAItC,eAAuC,EAAA;;AEInC;EACE,SAAS,EAAA;;AAGX;EACE,SZ0IS,EAAA;;AYtIT;EACE,QAFU,EAAA;;AACZ;EACE,QAFU,EAAA;;AACZ;EACE,QAFU,EAAA;;AACZ;EACE,QAFU,EAAA;;AACZ;EACE,QAFU,EAAA;;AACZ;EACE,QAFU,EAAA;;AACZ;EACE,QAFU,EAAA;;AACZ;EACE,QAFU,EAAA;;AACZ;EACE,QAFU,EAAA;;AACZ;EACE,QAFU,EAAA;;AACZ;EACE,SAFU,EAAA;;AACZ;EACE,SAFU,EAAA;;AACZ;EACE,SAFU,EAAA;;AASV;EFhBR,qBAA8C,EAAA;;AEgBtC;EFhBR,sBAA8C,EAAA;;AEgBtC;EFhBR,gBAA8C,EAAA;;AEgBtC;EFhBR,sBAA8C,EAAA;;AEgBtC;EFhBR,sBAA8C,EAAA;;AEgBtC;EFhBR,gBAA8C,EAAA;;AEgBtC;EFhBR,sBAA8C,EAAA;;AEgBtC;EFhBR,sBAA8C,EAAA;;AEgBtC;EFhBR,gBAA8C,EAAA;;AEgBtC;EFhBR,sBAA8C,EAAA;;AEgBtC;EFhBR,sBAA8C,EAAA;;ACW5C;EC7BE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAA;EAEjB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EAIf;IFHN,kBAAsC;IAItC,mBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,cAAsC;IAItC,eAAuC,EAAA;EEInC;IACE,SAAS,EAAA;EAGX;IACE,SZ0IS,EAAA;EYtIT;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,SAFU,EAAA;EACZ;IACE,SAFU,EAAA;EACZ;IACE,SAFU,EAAA;EASV;IFhBR,cAA4B,EAAA;EEgBpB;IFhBR,qBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA,EEkBrC;;ADPP;EC7BE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAA;EAEjB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EAIf;IFHN,kBAAsC;IAItC,mBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,cAAsC;IAItC,eAAuC,EAAA;EEInC;IACE,SAAS,EAAA;EAGX;IACE,SZ0IS,EAAA;EYtIT;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,SAFU,EAAA;EACZ;IACE,SAFU,EAAA;EACZ;IACE,SAFU,EAAA;EASV;IFhBR,cAA4B,EAAA;EEgBpB;IFhBR,qBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA,EEkBrC;;ADPP;EC7BE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAA;EAEjB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EAIf;IFHN,kBAAsC;IAItC,mBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,cAAsC;IAItC,eAAuC,EAAA;EEInC;IACE,SAAS,EAAA;EAGX;IACE,SZ0IS,EAAA;EYtIT;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,SAFU,EAAA;EACZ;IACE,SAFU,EAAA;EACZ;IACE,SAFU,EAAA;EASV;IFhBR,cAA4B,EAAA;EEgBpB;IFhBR,qBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA,EEkBrC;;ADPP;EC7BE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAA;EAEjB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EAIf;IFHN,kBAAsC;IAItC,mBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,aAAsC;IAItC,cAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,mBAAsC;IAItC,oBAAuC,EAAA;EEDjC;IFHN,cAAsC;IAItC,eAAuC,EAAA;EEInC;IACE,SAAS,EAAA;EAGX;IACE,SZ0IS,EAAA;EYtIT;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,QAFU,EAAA;EACZ;IACE,SAFU,EAAA;EACZ;IACE,SAFU,EAAA;EACZ;IACE,SAFU,EAAA;EASV;IFhBR,cAA4B,EAAA;EEgBpB;IFhBR,qBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,gBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA;EEgBtC;IFhBR,sBAA8C,EAAA,EEkBrC;;AC/DX;EACE,WAAW;EACX,eAAe;EACf,mBb4GW;Ea3GX,6Bb+RoB,EAAA;EanStB;;IAQI,gBbwRuB;IavRvB,mBAAmB;IACnB,6BbDc,EAAA;EaTlB;IAcI,sBAAsB;IACtB,gCbNc,EAAA;EaTlB;IAmBI,6BbVc,EAAA;EaTlB;IAuBI,sBdmEU,EAAA;;Ac3Dd;;EAGI,eb+PyB,EAAA;;AavP7B;EACE,yBblCgB,EAAA;EaiClB;;IAKI,yBbtCc,EAAA;EaiClB;;IAWM,wBAA8C,EAAA;;AASpD;EAEI,qCbhDQ,EAAA;;ACNV;EYiEI,sCb3DM,EAAA;;AcfV;;;EAII,yBC2E4D,EAAA;;AdtEhE;EaMM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AAX5C;;;EAII,yBC2E4D,EAAA;;AdtEhE;EaMM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AAX5C;;;EAII,yBC2E4D,EAAA;;AdtEhE;EaMM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AAX5C;;;EAII,yBC2E4D,EAAA;;AdtEhE;EaMM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AAX5C;;;EAII,yBC2E4D,EAAA;;AdtEhE;EaMM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AAX5C;;;EAII,yBC2E4D,EAAA;;AdtEhE;EaMM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AAX5C;;;EAII,yBC2E4D,EAAA;;AdtEhE;EaMM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AAX5C;;;EAII,yBC2E4D,EAAA;;AdtEhE;EaMM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AAX5C;;;EAII,sCdWM,EAAA;;ACNV;EaMM,sCAJsC,EAAA;EAD5C;;IASQ,sCARoC,EAAA;;ADoF9C;EAGM,Wb7FM;Ea8FN,yBbrFY;EasFZ,qBb4M4C,EAAA;;AajNlD;EAWM,cb9FY;Ea+FZ,yBbpGY;EaqGZ,qBbpGY,EAAA;;AayGlB;EACE,Wb7GU;Ea8GV,yBbrGgB,EAAA;EamGlB;;;IAOI,qBbwL8C,EAAA;Ea/LlD;IAWI,SAAS,EAAA;EAXb;IAgBM,2Cb5HM,EAAA;ECIV;IY+HM,4CbnII,EAAA;;AW+DR;EEoFA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C,EAAA;IAN/C;MAUK,SAAS,EAAA,EACV;;AF/FL;EEoFA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C,EAAA;IAN/C;MAUK,SAAS,EAAA,EACV;;AF/FL;EEoFA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C,EAAA;IAN/C;MAUK,SAAS,EAAA,EACV;;AF/FL;EEoFA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C,EAAA;IAN/C;MAUK,SAAS,EAAA,EACV;;AAhBT;EAOQ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,4CAA4C,EAAA;EAXpD;IAeU,SAAS,EAAA;;AAOnB;;EAEE,sBAAsB,EAAA;;AG1KxB;EACE,cAAc;EACd,WAAW;EACX,yBhBoT0B;EgBnT1B,ejBUmB;EiBTnB,gBhBiOoB;EgBhOpB,chBKgB;EgBJhB,sBhBHU;EgBIV,4BAA4B;EAC5B,yBhBDgB;EgBMd,sBhBwLkB;EO1MlB,gDPkBQ;EiBfN,wEjB0ZuE,EAAA;EgBzZ7E;IAyBI,6BAA6B;IAC7B,SAAS,EAAA;EEnBX;IACE,clBGc;IkBFd,sBlBLQ;IkBMR,qBlB6XyD;IkB5XzD,UAAU;IAGR,sFlBeQ,EAAA;EgB7Bd;IAkCI,chBxBc;IgB0Bd,UAAU,EAAA;EApCd;IA8CI,yBhBxCc;IgB0Cd,UAAU,EAAA;;AAId;EAEI,2BhB2ViE,EAAA;;AgB7VrE;EAWI,chBpDc;EgBqDd,sBhB5DQ,EAAA;;AgBiEZ;;EAEE,cAAc;EACd,WAAW,EAAA;;AASb;EACE,iCAA+D;EAC/D,oCAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,gBhBgJoB,EAAA;;AgB7ItB;EACE,+BAAkE;EAClE,kCAAqE;EACrE,ejB7EkC;EiB8ElC,gBhBmGkB,EAAA;;AgBhGpB;EACE,gCAAkE;EAClE,mCAAqE;EACrE,ejBrFmB;EiBsFnB,gBhB6FkB,EAAA;;AgBrFpB;EACE,cAAc;EACd,WAAW;EACX,qBhBuM2B;EgBtM3B,wBhBsM2B;EgBrM3B,gBAAgB;EAChB,gBhBoHoB;EgBnHpB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmC,EAAA;EATrC;;;;;;;;;IAaI,gBAAgB;IAChB,eAAe,EAAA;;AAYnB;;;;;EACE,uBhBwL4B;EgBvL5B,ejB1HmB;EiB2HnB,gBhBwDkB;EMnMhB,qBN0MoB,EAAA;;AgB3DxB;;;;;EAEI,6BhBqQuE,EAAA;;AgBjQ3E;;;;;EACE,oBhB+K2B;EgB9K3B,ejBtIkC;EiBuIlC,gBhB0CkB;EMlMhB,qBNyMoB,EAAA;;AgB7CxB;;;;;EAEI,4BhB2PuE,EAAA;;AgBlP3E;EACE,mBhB8P6B,EAAA;;AgB3P/B;EACE,cAAc;EACd,mBhBgP2B,EAAA;;AgBzO7B;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB,EAAA;EAJnB;;IAQI,kBAAkB;IAClB,iBAAiB,EAAA;;AAQrB;EACE,kBAAkB;EAClB,cAAc;EACd,qBhBuN+B,EAAA;;AgBpNjC;EACE,kBAAkB;EAClB,kBhBmN+B;EgBlN/B,qBhBiN+B,EAAA;EgBpNjC;IAMI,chBrMc,EAAA;;AgByMlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,qBhBsMiC,EAAA;EgB1MnC;IAQI,gBAAgB;IAChB,aAAa;IACb,uBhBiMuC;IgBhMvC,cAAc,EAAA;;AE5MhB;EACE,aAAa;EACb,WAAW;EACX,mBlBkYyB;EkBjYzB,clByOiB;EkBxOjB,clBSW,EAAA;;AkBNb;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,wClBLW;EkBMX,oBAAoB,EAAA;;AAKpB;;;EAEE,qBlBbS,EAAA;EkBWX;;;IAKI,qBlBhBO;IkBiBP,gDlBjBO,EAAA;EkBWX;;;;;;;;IAWI,cAAc,EAAA;;AAMlB;EAGI,clB/BO,EAAA;;AkB4BX;;;EAQI,cAAc,EAAA;;AAMlB;EAGI,clB7CO,EAAA;EkB0CX;IAMM,yBAAsC,EAAA;;AAN5C;;;EAYI,cAAc,EAAA;;AAZlB;EC9EA,yBD+F+C,EAAA;;AAjB/C;EAuBM,gElBjEK,EAAA;;AkByEX;EAGI,qBlB5EO,EAAA;EkByEX;IAMM,qBAAqB,EAAA;;AAN3B;;;EAYI,cAAc,EAAA;;AAZlB;EAiBM,gDlB1FK,EAAA;;AkBdb;EACE,aAAa;EACb,WAAW;EACX,mBlBkYyB;EkBjYzB,clByOiB;EkBxOjB,clBMS,EAAA;;AkBHX;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,wClBRS;EkBST,oBAAoB,EAAA;;AAKpB;;;EAEE,qBlBhBO,EAAA;EkBcT;;;IAKI,qBlBnBK;IkBoBL,gDlBpBK,EAAA;EkBcT;;;;;;;;IAWI,cAAc,EAAA;;AAMlB;EAGI,clBlCK,EAAA;;AkB+BT;;;EAQI,cAAc,EAAA;;AAMlB;EAGI,clBhDK,EAAA;EkB6CT;IAMM,yBAAsC,EAAA;;AAN5C;;;EAYI,cAAc,EAAA;;AAZlB;EC9EA,yBD+F+C,EAAA;;AAjB/C;EAuBM,gElBpEG,EAAA;;AkB4ET;EAGI,qBlB/EK,EAAA;EkB4ET;IAMM,qBAAqB,EAAA;;AAN3B;;;EAYI,cAAc,EAAA;;AAZlB;EAiBM,gDlB7FG,EAAA;;AgBwNb;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAA;EAHrB;IASI,WAAW,EAAA;EL5MX;IKmMJ;MAeM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB,EAAA;IAlBtB;MAuBM,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB,EAAA;IA3BtB;MAgCM,qBAAqB;MACrB,WAAW;MACX,sBAAsB,EAAA;IAlC5B;MAuCM,qBAAqB,EAAA;IAvC3B;MA2CM,WAAW,EAAA;IA3CjB;MAiDM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,eAAe,EAAA;IArDrB;MAwDM,kBAAkB;MAClB,aAAa;MACb,qBhB4G4B;MgB3G5B,cAAc,EAAA;IA3DpB;MA+DM,mBAAmB;MACnB,uBAAuB,EAAA;IAhE7B;MAmEM,gBAAgB,EAAA,EACjB;;AI7TL;EACE,qBAAqB;EACrB,gBpBgOsB;EoB/NtB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,6BAA2C;ECsF3C,yBrB0N0B;EqBzN1B,etBhFmB;EsBiFnB,gBtBgDmB;EsB7CjB,sBrBoGkB;EiBvMhB,qIjB2WgI,EAAA;EC5VpI;ImBDE,qBAAqB,EAAA;EAbzB;IAkBI,UAAU;IACV,gDpBUU,EAAA;EoB7Bd;IAyBI,apBqUsB;IOlWtB,gBa8BwB,EAAA;EA1B5B;IA+BI,eAAe,EAAA;EA/BnB;IAoCI,sBAAsB;IbxCtB,gDPkBQ,EAAA;IoBdZ;MbJI,sFPkBQ,EAAA;;AoBgCZ;;EAEE,oBAAoB,EAAA;;AAQpB;ECxDA,WrBIU;EmBJR,yBpBoDiB;EsBlDnB,qBtBkDmB;EQxDjB,mFPkBQ,EAAA;ECNV;IoBFE,WrBFQ;ImBJR,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAII,wHtBqCe,EAAA;EsB9BnB;IAEE,WrBpBQ;IqBqBR,yBtB2BiB;IsB1BjB,qBtB0BiB,EAAA;EsBvBnB;;IAGE,WrB5BQ;IqB6BR,yBAlCuK;IAsCvK,qBAtC+M,EAAA;IAwC/M;;MAGI,qFtBUa,EAAA;;AqBInB;ECxDA,WrBIU;EmBJR,yBpBsDe;EsBpDjB,qBtBoDiB;EQ1Df,mFPkBQ,EAAA;ECNV;IoBFE,WrBFQ;ImBJR,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAII,wHtBuCa,EAAA;EsBhCjB;IAEE,WrBpBQ;IqBqBR,yBtB6Be;IsB5Bf,qBtB4Be,EAAA;EsBzBjB;;IAGE,WrB5BQ;IqB6BR,yBAlCuK;IAsCvK,qBAtC+M,EAAA;IAwC/M;;MAGI,qFtBYW,EAAA;;AqBEjB;ECxDA,WrBIU;EmBJR,yBpBkFa;EsBhFf,qBtBgFe;EQtFb,mFPkBQ,EAAA;ECNV;IoBFE,WrBFQ;ImBJR,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAII,wHtBmEW,EAAA;EsB5Df;IAEE,WrBpBQ;IqBqBR,yBtByDa;IsBxDb,qBtBwDa,EAAA;EsBrDf;;IAGE,WrB5BQ;IqB6BR,yBAlCuK;IAsCvK,qBAtC+M,EAAA;IAwC/M;;MAGI,qFtBwCS,EAAA;;AqB1Bf;ECxDA,WrBIU;EmBJR,yBpBmFU;EsBjFZ,qBtBiFY;EQvFV,mFPkBQ,EAAA;ECNV;IoBFE,WrBFQ;ImBJR,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAII,wHtBoEQ,EAAA;EsB7DZ;IAEE,WrBpBQ;IqBqBR,yBtB0DU;IsBzDV,qBtByDU,EAAA;EsBtDZ;;IAGE,WrB5BQ;IqB6BR,yBAlCuK;IAsCvK,qBAtC+M,EAAA;IAwC/M;;MAGI,qFtByCM,EAAA;;AqB3BZ;ECxDA,crBagB;EmBbd,yBpBoFa;EsBlFf,qBtBkFe;EQxFb,mFPkBQ,EAAA;ECNV;IoBFE,WrBFQ;ImBJR,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAII,wHtBqEW,EAAA;EsB9Df;IAEE,crBXc;IqBYd,yBtB2Da;IsB1Db,qBtB0Da,EAAA;EsBvDf;;IAGE,WrB5BQ;IqB6BR,yBAlCuK;IAsCvK,qBAtC+M,EAAA;IAwC/M;;MAGI,qFtB0CS,EAAA;;AqB5Bf;ECxDA,WrBIU;EmBJR,yBpBqFY;EsBnFd,qBtBmFc;EQzFZ,mFPkBQ,EAAA;ECNV;IoBFE,WrBFQ;ImBJR,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAII,wHtBsEU,EAAA;EsB/Dd;IAEE,WrBpBQ;IqBqBR,yBtB4DY;IsB3DZ,qBtB2DY,EAAA;EsBxDd;;IAGE,WrB5BQ;IqB6BR,yBAlCuK;IAsCvK,qBAtC+M,EAAA;IAwC/M;;MAGI,qFtB2CQ,EAAA;;AqB7Bd;ECxDA,crBagB;EmBbd,yBpBsFW;EsBpFb,qBtBoFa;EQ1FX,mFPkBQ,EAAA;ECNV;IoBFE,crBOc;ImBbd,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAII,0HtBuES,EAAA;EsBhEb;IAEE,crBXc;IqBYd,yBtB6DW;IsB5DX,qBtB4DW,EAAA;EsBzDb;;IAGE,crBnBc;IqBoBd,yBAlCuK;IAsCvK,qBAtC+M,EAAA;IAwC/M;;MAGI,uFtB4CO,EAAA;;AqB9Bb;ECxDA,WrBIU;EmBJR,yBnBYc;EqBVhB,qBrBUgB;EOhBd,mFPkBQ,EAAA;ECNV;IoBFE,WrBFQ;ImBJR,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAII,uHrBHY,EAAA;EqBUhB;IAEE,WrBpBQ;IqBqBR,yBrBbc;IqBcd,qBrBdc,EAAA;EqBiBhB;;IAGE,WrB5BQ;IqB6BR,yBAlCuK;IAsCvK,qBAtC+M,EAAA;IAwC/M;;MAGI,oFrB9BU,EAAA;;AoBkDhB;ECXA,ctBCmB;EsBAnB,6BAA6B;EAC7B,sBAAsB;EACtB,qBtBFmB,EAAA;EsBInB;IACE,WrBrDQ;IqBsDR,yBtBNiB;IsBOjB,qBtBPiB,EAAA;EsBUnB;IAEE,+CtBZiB,EAAA;EsBenB;IAEE,ctBjBiB;IsBkBjB,6BAA6B,EAAA;EAG/B;;IAGE,WrBxEQ;IqByER,yBtBzBiB;IsB0BjB,qBtB1BiB,EAAA;IsB4BjB;;MAGI,qFtB/Ba,EAAA;;AqBUnB;ECXA,ctBGiB;EsBFjB,6BAA6B;EAC7B,sBAAsB;EACtB,qBtBAiB,EAAA;EsBEjB;IACE,WrBrDQ;IqBsDR,yBtBJe;IsBKf,qBtBLe,EAAA;EsBQjB;IAEE,+CtBVe,EAAA;EsBajB;IAEE,ctBfe;IsBgBf,6BAA6B,EAAA;EAG/B;;IAGE,WrBxEQ;IqByER,yBtBvBe;IsBwBf,qBtBxBe,EAAA;IsB0Bf;;MAGI,qFtB7BW,EAAA;;AqBQjB;ECXA,ctB+Be;EsB9Bf,6BAA6B;EAC7B,sBAAsB;EACtB,qBtB4Be,EAAA;EsB1Bf;IACE,WrBrDQ;IqBsDR,yBtBwBa;IsBvBb,qBtBuBa,EAAA;EsBpBf;IAEE,+CtBkBa,EAAA;EsBff;IAEE,ctBaa;IsBZb,6BAA6B,EAAA;EAG/B;;IAGE,WrBxEQ;IqByER,yBtBKa;IsBJb,qBtBIa,EAAA;IsBFb;;MAGI,qFtBDS,EAAA;;AqBpBf;ECXA,ctBgCY;EsB/BZ,6BAA6B;EAC7B,sBAAsB;EACtB,qBtB6BY,EAAA;EsB3BZ;IACE,WrBrDQ;IqBsDR,yBtByBU;IsBxBV,qBtBwBU,EAAA;EsBrBZ;IAEE,+CtBmBU,EAAA;EsBhBZ;IAEE,ctBcU;IsBbV,6BAA6B,EAAA;EAG/B;;IAGE,WrBxEQ;IqByER,yBtBMU;IsBLV,qBtBKU,EAAA;IsBHV;;MAGI,qFtBAM,EAAA;;AqBrBZ;ECXA,ctBiCe;EsBhCf,6BAA6B;EAC7B,sBAAsB;EACtB,qBtB8Be,EAAA;EsB5Bf;IACE,crB5Cc;IqB6Cd,yBtB0Ba;IsBzBb,qBtByBa,EAAA;EsBtBf;IAEE,+CtBoBa,EAAA;EsBjBf;IAEE,ctBea;IsBdb,6BAA6B,EAAA;EAG/B;;IAGE,crB/Dc;IqBgEd,yBtBOa;IsBNb,qBtBMa,EAAA;IsBJb;;MAGI,qFtBCS,EAAA;;AqBtBf;ECXA,ctBkCc;EsBjCd,6BAA6B;EAC7B,sBAAsB;EACtB,qBtB+Bc,EAAA;EsB7Bd;IACE,WrBrDQ;IqBsDR,yBtB2BY;IsB1BZ,qBtB0BY,EAAA;EsBvBd;IAEE,+CtBqBY,EAAA;EsBlBd;IAEE,ctBgBY;IsBfZ,6BAA6B,EAAA;EAG/B;;IAGE,WrBxEQ;IqByER,yBtBQY;IsBPZ,qBtBOY,EAAA;IsBLZ;;MAGI,qFtBEQ,EAAA;;AqBvBd;ECXA,ctBmCa;EsBlCb,6BAA6B;EAC7B,sBAAsB;EACtB,qBtBgCa,EAAA;EsB9Bb;IACE,crB5Cc;IqB6Cd,yBtB4BW;IsB3BX,qBtB2BW,EAAA;EsBxBb;IAEE,iDtBsBW,EAAA;EsBnBb;IAEE,ctBiBW;IsBhBX,6BAA6B,EAAA;EAG/B;;IAGE,crB/Dc;IqBgEd,yBtBSW;IsBRX,qBtBQW,EAAA;IsBNX;;MAGI,uFtBGO,EAAA;;AqBxBb;ECXA,crBvCgB;EqBwChB,6BAA6B;EAC7B,sBAAsB;EACtB,qBrB1CgB,EAAA;EqB4ChB;IACE,WrBrDQ;IqBsDR,yBrB9Cc;IqB+Cd,qBrB/Cc,EAAA;EqBkDhB;IAEE,8CrBpDc,EAAA;EqBuDhB;IAEE,crBzDc;IqB0Dd,6BAA6B,EAAA;EAG/B;;IAGE,WrBxEQ;IqByER,yBrBjEc;IqBkEd,qBrBlEc,EAAA;IqBoEd;;MAGI,oFrBvEU,EAAA;;AoB4DlB;EACE,gBpByJsB;EoBxJtB,crBtBmB;EqBuBnB,6BAA6B,EAAA;EnBnE7B;ImBsEE,crBCwC;IqBAxC,0BpBiE6B;IoBhE7B,6BAA6B;IAC7B,yBAAyB,EAAA;EAT7B;IAcI,0BpB0D6B;IoBzD7B,yBAAyB;IACzB,gBAAgB,EAAA;EAhBpB;IAqBI,cpBnFc,EAAA;;AoB6FlB;ECVE,oBrBsO2B;EqBrO3B,etB/EkC;EsBgFlC,gBrBiGkB;EqB9FhB,qBrBqGoB,EAAA;;AoB5FxB;ECdE,uBrBkO4B;EqBjO5B,etBhFmB;EsBiFnB,gBrBkGkB;EqB/FhB,qBrBsGoB,EAAA;;AoBrFxB;EACE,cAAc;EACd,WAAW,EAAA;EAFb;IAMI,kBpB0OuB,EAAA;;AoBrO3B;;;EAII,WAAW,EAAA;;AEtIf;EACE,UAAU;ELEN,gCjBiN+B,EAAA;EsBpNrC;IAKI,UAAU,EAAA;;AAId;EACE,aAAa,EAAA;EADf;IAGI,cAAc,EAAA;;AAIlB;EAEI,kBAAkB,EAAA;;AAItB;EAEI,wBAAwB,EAAA;;AAI5B;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EL5BZ,6BjBkNgC,EAAA;;AuBtNtC;;EAEE,kBAAkB,EAAA;;ACyBhB;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,oBAA+B;EAC/B,uBAAkC;EAClC,WAAW;EAjCf,uBAA8B;EAC9B,qCAA4C;EAC5C,gBAAgB;EAChB,oCAA2C,EAAA;;AAwDzC;EACE,cAAc,EAAA;;ADjDpB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,avBohBoB;EuBnhBpB,aAAa;EACb,WAAW;EACX,gBvBofwB;EuBnfxB,iBAA8B;EAC9B,oBAA4B;EAC5B,exBFmB;EwBGnB,cxBwEkB;EwBvElB,gBAAgB;EAChB,gBAAgB;EAChB,sBvBhBU;EuBiBV,4BAA4B;EAC5B,qCvBRU;EMhBR,sBNwMkB;EO1MlB,8CPkBQ,EAAA;;AuBeZ;EAEI,aAAa;EACb,uBvBmeqB,EAAA;;AwB7erB;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,oBAA+B;EAC/B,uBAAkC;EAClC,WAAW;EA1Bf,aAAa;EACb,qCAA4C;EAC5C,0BAAiC;EACjC,oCAA2C,EAAA;;AAiDzC;EACE,cAAc,EAAA;;ADfpB;EAEI,aAAa;EACb,qBvBwdqB,EAAA;;AwB7erB;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,oBAA+B;EAC/B,uBAAkC;EAClC,WAAW;EAnBf,mCAA0C;EAC1C,sCAA6C;EAC7C,wBAA+B,EAAA;;AA2C7B;EACE,cAAc,EAAA;;AAjChB;ED2BE,iBAAiB,EAAA;;AAKvB;EAEI,aAAa;EACb,sBvB0cqB,EAAA;;AwB7erB;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,oBAA+B;EAC/B,uBAAkC;EAClC,WAAW,EAAA;;AANb;EAkBI,aAAa,EAAA;;AAGf;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,qBAAgC;EAChC,uBAAkC;EAClC,WAAW;EAlCjB,mCAA0C;EAC1C,yBAAgC;EAChC,sCAA6C,EAAA;;AAqC3C;EACE,cAAc,EAAA;;AAZd;EDoBA,iBAAiB,EAAA;;AAMvB;EEtEE,SAAS;EACT,gBAAuB;EACvB,gBAAgB;EAChB,6BzBIgB,EAAA;;AuBsElB;EACE,cAAc;EACd,WAAW;EACX,uBvBsc8B;EuBrc9B,WAAW;EACX,gBvBiJsB;EuBhJtB,cvBrEgB;EuBsEhB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS,EAAA;EtBxET;IsB2EE,cvBmb6C;IuBlb7C,qBAAqB;IJ1FrB,yBnBKc,EAAA;EuBuElB;IAoBI,WvB5FQ;IuB6FR,qBAAqB;IJjGrB,yBnB6BU,EAAA;EuB+Cd;IA2BI,cvB7Fc;IuB8Fd,6BAA6B,EAAA;;AAQjC;EACE,cAAc,EAAA;;AAIhB;EACE,cAAc;EACd,sBvB8Z8B;EuB7Z9B,gBAAgB;EAChB,exB3GmB;EwB4GnB,cvBhHgB;EuBiHhB,mBAAmB,EAAA;;AG9HrB;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc,EAAA;IzBGhB;;MyBEI,UAAU,EAAA;IAbhB;;;;MAkBM,UAAU,EAAA;EAlBhB;;;;;;;;IA2BI,iB1B2Kc,EAAA;;A0BtKlB;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AAIf;EAEI,cAAc,EAAA;;AAFlB;;EpB5BI,0BoBoC8B;EpBnC9B,6BoBmC8B,EAAA;;AARlC;;EpBdI,yBoB2B6B;EpB1B7B,4BoB0B6B,EAAA;;AAoBjC;EACE,wBAAmC;EACnC,uBAAkC,EAAA;EAFpC;IAKI,cAAc,EAAA;;AAIlB;EACE,uBAAsC;EACtC,sBAAqC,EAAA;;AAGvC;EACE,sBAAsC;EACtC,qBAAqC,EAAA;;AAKvC;EnBjGI,gDPkBQ,EAAA;E0B+EZ;InBjGI,gBmBsGwB,EAAA;;AAQ5B;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;;;IAcI,gB1B2Ec;I0B1Ed,cAAc,EAAA;EAflB;;IpBxFI,6BoB6G+B;IpB5G/B,4BoB4G+B,EAAA;EArBnC;;IpBtGI,yBoBgI4B;IpB/H5B,0BoB+H4B,EAAA;;AAgBhC;;EAGI,gBAAgB,EAAA;EAHpB;;;;IAOM,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB,EAAA;;AC7J1B;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;EALb;;;IAUI,kBAAkB;IAClB,cAAc;IAGd,SAAS;IACT,gBAAgB,EAAA;IAfpB;;;MAmBM,UAAU,EAAA;IAnBhB;;;;;;;;;MAyBM,iB3B0KY,EAAA;E2BnMlB;;IrBWI,0BqBqBgC;IrBpBhC,6BqBoBgC,EAAA;EAhCpC;;IrByBI,yBqBU+B;IrBT/B,4BqBS+B,EAAA;EAnCnC;IA0CI,aAAa;IACb,mBAAmB,EAAA;IA3CvB;;MrBWI,0BqBoCgC;MrBnChC,6BqBmCgC,EAAA;IA/CpC;;MrByBI,yBqB0B+B;MrBzB/B,4BqByB+B,EAAA;;AAWnC;;EAEE,aAAa,EAAA;EAFf;;IAQI,kBAAkB;IAClB,UAAU,EAAA;EATd;;;;;;;;IAgBI,iB3BqHc,EAAA;;A2BjHlB;EACE,kB3BgHgB,EAAA;;A2B7GlB;EACE,iB3B4GgB,EAAA;;A2BpGlB;EACE,aAAa;EACb,mBAAmB;EACnB,yB3BqN0B;E2BpN1B,gBAAgB;EAChB,e5BtFmB;E4BuFnB,gB3B6HsB;E2B5HtB,gB3BgIoB;E2B/HpB,c3B5FgB;E2B6FhB,kBAAkB;EAClB,mBAAmB;EACnB,yB3BpGgB;E2BqGhB,yB3BnGgB;EMVd,sBNwMkB,EAAA;E2BvGtB;;IAkBI,aAAa,EAAA;;AA+BjB;;;;;;ErBrII,0BqB2I4B;ErB1I5B,6BqB0I4B,EAAA;;AAGhC;;;;;;ErBhII,yBqBsI2B;ErBrI3B,4BqBqI2B,EAAA;;AC7J/B;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAsC;EACtC,oB5Boa4B,EAAA;;A4Bja9B;EACE,oBAAoB;EACpB,kB5Bga4B,EAAA;;A4B7Z9B;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;EAHZ;IAMI,W5BhBQ;ImBJR,yBnB6BU;IOjCV,gBP4b8C,EAAA;E4B1alD;IAaI,gE5BEU,EAAA;E4Bfd;IAiBI,W5B3BQ;I4B4BR,yB5B6ZmE;IOjcnE,gBPkc6C,EAAA;E4BhbjD;IAwBM,c5B5BY,EAAA;I4BIlB;MA2BQ,yB5BnCU,EAAA;;A4B6ClB;EACE,gBAAgB,EAAA;EADlB;IAKI,kBAAkB;IAClB,YAA+D;IAC/D,OAAO;IACP,cAAc;IACd,W5BiXgC;I4BhXhC,Y5BgXgC;I4B/WhC,oBAAoB;IACpB,WAAW;IACX,iBAAiB;IACjB,yB5B1Dc;IOXd,sDPkBQ,EAAA;E4BqCZ;IAoBI,kBAAkB;IAClB,YAA+D;IAC/D,OAAO;IACP,cAAc;IACd,W5BkWgC;I4BjWhC,Y5BiWgC;I4BhWhC,WAAW;IACX,4BAA4B;IAC5B,kCAAkC;IAClC,wB5B+VsC,EAAA;;A4BvV1C;EtB1FI,sBNwMkB,EAAA;;A4B9GtB;ETxFI,yBnB6BU,EAAA;;A4B2Dd;EAUM,yDb5DqI,EAAA;;AakD3I;ETxFI,yBnB6BU;EOjCV,gBP0cqD,EAAA;;A4B9WzD;EAoBM,yDbtEqI,EAAA;;AakD3I;EA0BM,wC5BrFQ,EAAA;;A4B2Dd;EA6BM,wC5BxFQ,EAAA;;A4BiGd;EAEI,kB5BwUsC,EAAA;;A4B1U1C;ET9HI,yBnB6BU,EAAA;;A4BiGd;EAUM,yDblGqI,EAAA;;AawF3I;EAgBM,wC5BjHQ,EAAA;;A4B4Hd;EACE,qBAAqB;EACrB,WAAW;EACX,2B5BqPmE;E4BpPnE,0C5B+S8B;E4B9S9B,gB5BwEoB;E4BvEpB,c5BpJgB;E4BqJhB,sBAAsB;EACtB,uFAAsG;EACtG,yB5BkT8B;E4BjT9B,yB5B3JgB;E4B6Jd,sB5BiCkB;E4B7BpB,gBAAgB,EAAA;EAhBlB;IAmBI,qB5B2NyD;I4B1NzD,UAAU;IACV,kF5ByNyD,EAAA;I4B9O7D;MA6BM,c5B3KY;M4B4KZ,sB5BnLM,EAAA;E4BqJZ;IAoCI,YAAY;IACZ,sB5B8Q4B;I4B7Q5B,sBAAsB,EAAA;EAtC1B;IA0CI,c5BzLc;I4B0Ld,yB5B9Lc,EAAA;E4BmJlB;IAgDI,UAAU,EAAA;;AAId;EACE,6B5BsMyE;E4BrMzE,qB5B4P+B;E4B3P/B,wB5B2P+B;E4B1P/B,c5B6Q8B,EAAA;;A4B1QhC;EACE,4B5BkMyE;E4BjMzE,qB5BqP+B;E4BpP/B,wB5BoP+B;E4BnP/B,e5ByQ+B,EAAA;;A4BlQjC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,2B5B8KmE;E4B7KnE,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,2B5BsKmE;E4BrKnE,SAAS;EACT,UAAU,EAAA;EANZ;IASI,qB5BuJyD;I4BtJzD,gD5BpNU,EAAA;I4B0Md;MAaM,qB5BmJuD,EAAA;E4BhK7D;IAmBM,iB5B0Pc,EAAA;;A4BrPpB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,2B5B4ImE;E4B3InE,yB5BiD0B;E4BhD1B,gB5BjCoB;E4BkCpB,c5B7PgB;E4B8PhB,sB5BrQU;E4BsQV,yB5BlQgB;EMVd,sBNwMkB;EO1MlB,gDPkBQ,EAAA;E4BiPZ;IAgBI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,cAAc;IACd,2CAAuE;IACvE,yB5BiCwB;I4BhCxB,gB5BjDkB;I4BkDlB,c5B7Qc;I4B8Qd,iBAAiB;ITzRjB,yBnBMc;I4BqRd,8B5BnRc;IMVd,kCsB8RgF,EAAA;;AC7RpF;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,oB7BgiBuB,EAAA;EC3hBvB;I4BFE,qBAAqB,EAAA;EALzB;IAUI,c7BPc,EAAA;;A6BelB;EACE,gC7BnBgB,EAAA;E6BkBlB;IAII,mB7BsKc,EAAA;E6B1KlB;IAQI,6BAAgD;IvB7BhD,+BNkMkB;IMjMlB,gCNiMkB,EAAA;ICxLpB;M4BuBI,qC7B9BY,EAAA;I6BkBlB;MAgBM,c7B/BY;M6BgCZ,6BAA6B;MAC7B,yBAAyB,EAAA;EAlB/B;;IAwBI,c7BtCc;I6BuCd,sB7B9CQ;I6B+CR,kC7B/CQ,EAAA;E6BqBZ;IA+BI,gB7B2Ic;IM/Ld,yBuBsD4B;IvBrD5B,0BuBqD4B,EAAA;;AAQhC;EvBpEI,sBNwMkB,EAAA;;A6BpItB;;EAOI,W7BrEQ;E6BsER,yB7B7CU,EAAA;;A6BqDd;EAEI,cAAc;EACd,kBAAkB,EAAA;;AAItB;EAEI,aAAa;EACb,YAAY;EACZ,kBAAkB,EAAA;;AAQtB;EAEI,aAAa,EAAA;;AAFjB;EAKI,cAAc,EAAA;;AChGlB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,oB9B6FW,EAAA;E8BnGb;;IAYI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B,EAAA;;AAQlC;EACE,qBAAqB;EACrB,sB9BgiBoE;E8B/hBpE,yB9B+hBoE;E8B9hBpE,kB9BwEW;E8BvEX,kB9BwLqC;E8BvLrC,oBAAoB;EACpB,mBAAmB,EAAA;E7B1BnB;I6B6BE,qBAAqB,EAAA;;AAQzB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EALlB;IAQI,gBAAgB;IAChB,eAAe,EAAA;EATnB;IAaI,gBAAgB;IAChB,WAAW,EAAA;;AAQf;EACE,qBAAqB;EACrB,mB9B6dwB;E8B5dxB,sB9B4dwB,EAAA;;A8Bjd1B;EACE,gBAAgB;EAChB,YAAY;EAGZ,mBAAmB,EAAA;;AAIrB;EACE,wB9Bqe+B;E8Bpe/B,kB9B4HqC;E8B3HrC,cAAc;EACd,6BAA6B;EAC7B,6BAAuC;ExBvGrC,sBNwMkB,EAAA;ECxLpB;I6B2FE,qBAAqB,EAAA;EATzB;IAcI,eAAe,EAAA;;AAMnB;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,0BAA0B,EAAA;;AnBxDxB;EmBkEC;;IAIK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;AnBrFL;EmB+EA;IAUI,qBAAqB;IACrB,2BAA2B,EAAA;IAX9B;MAcK,mBAAmB,EAAA;MAdxB;QAiBO,kBAAkB,EAAA;MAjBzB;QAqBO,QAAQ;QACR,UAAU,EAAA;MAtBjB;QA0BO,qB9B8ZqB;Q8B7ZrB,oB9B6ZqB,EAAA;I8Bxb5B;;MAkCK,iBAAiB,EAAA;IAlCtB;MAsCK,wBAAwB;MAGxB,gBAAgB,EAAA;IAzCrB;MA6CK,aAAa,EAAA;IA7ClB;MAkDO,SAAS;MACT,YAAY,EAAA,EACb;;AnBtHP;EmBkEC;;IAIK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;AnBrFL;EmB+EA;IAUI,qBAAqB;IACrB,2BAA2B,EAAA;IAX9B;MAcK,mBAAmB,EAAA;MAdxB;QAiBO,kBAAkB,EAAA;MAjBzB;QAqBO,QAAQ;QACR,UAAU,EAAA;MAtBjB;QA0BO,qB9B8ZqB;Q8B7ZrB,oB9B6ZqB,EAAA;I8Bxb5B;;MAkCK,iBAAiB,EAAA;IAlCtB;MAsCK,wBAAwB;MAGxB,gBAAgB,EAAA;IAzCrB;MA6CK,aAAa,EAAA;IA7ClB;MAkDO,SAAS;MACT,YAAY,EAAA,EACb;;AnBtHP;EmBkEC;;IAIK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;AnBrFL;EmB+EA;IAUI,qBAAqB;IACrB,2BAA2B,EAAA;IAX9B;MAcK,mBAAmB,EAAA;MAdxB;QAiBO,kBAAkB,EAAA;MAjBzB;QAqBO,QAAQ;QACR,UAAU,EAAA;MAtBjB;QA0BO,qB9B8ZqB;Q8B7ZrB,oB9B6ZqB,EAAA;I8Bxb5B;;MAkCK,iBAAiB,EAAA;IAlCtB;MAsCK,wBAAwB;MAGxB,gBAAgB,EAAA;IAzCrB;MA6CK,aAAa,EAAA;IA7ClB;MAkDO,SAAS;MACT,YAAY,EAAA,EACb;;AnBtHP;EmBkEC;;IAIK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;AnBrFL;EmB+EA;IAUI,qBAAqB;IACrB,2BAA2B,EAAA;IAX9B;MAcK,mBAAmB,EAAA;MAdxB;QAiBO,kBAAkB,EAAA;MAjBzB;QAqBO,QAAQ;QACR,UAAU,EAAA;MAtBjB;QA0BO,qB9B8ZqB;Q8B7ZrB,oB9B6ZqB,EAAA;I8Bxb5B;;MAkCK,iBAAiB,EAAA;IAlCtB;MAsCK,wBAAwB;MAGxB,gBAAgB,EAAA;IAzCrB;MA6CK,aAAa,EAAA;IA7ClB;MAkDO,SAAS;MACT,YAAY,EAAA,EACb;;AAzDX;EAeQ,qBAAqB;EACrB,2BAA2B,EAAA;EAhBnC;;IASU,gBAAgB;IAChB,eAAe,EAAA;EAVzB;IAmBU,mBAAmB,EAAA;IAnB7B;MAsBY,kBAAkB,EAAA;IAtB9B;MA0BY,QAAQ;MACR,UAAU,EAAA;IA3BtB;MA+BY,qB9B8ZqB;M8B7ZrB,oB9B6ZqB,EAAA;E8B7bjC;;IAuCU,iBAAiB,EAAA;EAvC3B;IA2CU,wBAAwB;IAGxB,gBAAgB,EAAA;EA9C1B;IAkDU,aAAa,EAAA;EAlDvB;IAuDY,SAAS;IACT,YAAY,EAAA;;AAaxB;EAEI,yB9BzLQ,EAAA;ECAV;I6B4LI,yB9B5LM,EAAA;;A8BuLZ;EAWM,yB9BlMM,EAAA;ECAV;I6BqMM,yB9BrMI,EAAA;E8BuLZ;IAkBQ,yB9BzMI,EAAA;;A8BuLZ;;;;EA0BM,yB9BjNM,EAAA;;A8BuLZ;EA+BI,yB9BtNQ;E8BuNR,gC9BvNQ,EAAA;;A8BuLZ;EAoCI,yD9B4W8R,EAAA;;A8BhZlS;EAwCI,yB9B/NQ,EAAA;E8BuLZ;IA0CM,yB9BjOM,EAAA;ICAV;M6BoOM,yB9BpOI,EAAA;;A8B2OZ;EAEI,W9BvPQ,EAAA;ECUV;I6BgPI,W9B1PM,EAAA;;A8BqPZ;EAWM,+B9BhQM,EAAA;ECUV;I6ByPM,gC9BnQI,EAAA;E8BqPZ;IAkBQ,gC9BvQI,EAAA;;A8BqPZ;;;;EA0BM,W9B/QM,EAAA;;A8BqPZ;EA+BI,+B9BpRQ;E8BqRR,sC9BrRQ,EAAA;;A8BqPZ;EAoCI,yD9BiT4R,EAAA;;A8BrVhS;EAwCI,+B9B7RQ,EAAA;E8BqPZ;IA0CM,W9B/RM,EAAA;ICUV;M6BwRM,W9BlSI,EAAA;;A+BNZ;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sB/BAU;E+BCV,2BAA2B;EAC3B,yB/BCgB;EMTd,kBPoCkB,EAAA;EgCpCtB;IAYI,eAAe;IACf,cAAc,EAAA;EAblB;IzBMI,2BP8BkB;IO7BlB,4BP6BkB,EAAA;EgCpCtB;IzBoBI,+BPgBkB;IOflB,8BPekB,EAAA;;AgCPtB;EAGE,cAAc;EACd,ahCSkB,EAAA;;AgCNpB;EACE,mBhCIkB,EAAA;;AgCDpB;EACE,iBAAgC;EAChC,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;A9BpChB;E8ByCE,qBAAqB,EAAA;;AAFzB;EAMI,iBhCbgB,EAAA;;AgCqBpB;EACE,kBhCtBkB;EgCuBlB,gBAAgB;EAChB,qC/BlDU;E+BmDV,gC/B1DgB,EAAA;E+BsDlB;IzB/DI,0ByBsE8E,EAAA;EAPlF;IAYM,aAAa,EAAA;;AAKnB;EACE,kBhCvCkB;EgCwClB,qC/BlEU;E+BmEV,6B/B1EgB,EAAA;E+BuElB;IzBhFI,0BPoCkB,EAAA;;AgC0DtB;EACE,mBAAkC;EAClC,oBhCvDkB;EgCwDlB,kBAAiC;EACjC,gBAAgB,EAAA;;AAGlB;EACE,mBAAkC;EAClC,kBAAiC,EAAA;;AAInC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gB/BshBgC,EAAA;;A+BnhBlC;EACE,WAAW;EzBrHT,kBPoCkB,EAAA;;AgCsFtB;EACE,WAAW;EzBrHT,2BP8BkB;EO7BlB,4BP6BkB,EAAA;;AgC2FtB;EACE,WAAW;EzB5GT,+BPgBkB;EOflB,8BPekB,EAAA;;AgCkGtB;EACE,aAAa;EACb,sBAAsB,EAAA;EAFxB;IAKI,mB/B8fwC,EAAA;EWjlBxC;IoB8EJ;MASI,mBAAmB;MACnB,mB/ByfwC;M+BxfxC,kB/BwfwC,EAAA;M+BngB5C;QAcM,aAAa;QAEb,YAAY;QACZ,sBAAsB;QACtB,kB/BifsC;Q+BhftC,gBAAgB;QAChB,iB/B+esC,EAAA,E+B9evC;;AAQL;EACE,aAAa;EACb,sBAAsB,EAAA;EAFxB;IAOI,mB/B+dwC,EAAA;EWjlBxC;IoB2GJ;MAWI,mBAAmB,EAAA;MAXvB;QAgBM,YAAY;QACZ,gBAAgB,EAAA;QAjBtB;UAoBQ,cAAc;UACd,cAAc,EAAA;QArBtB;UzBtJI,0ByBiLoC;UzBhLpC,6ByBgLoC,EAAA;UA3BxC;;YA+BY,0BAA0B,EAAA;UA/BtC;;YAmCY,6BAA6B,EAAA;QAnCzC;UzBxII,yByBgLmC;UzB/KnC,4ByB+KmC,EAAA;UAxCvC;;YA4CY,yBAAyB,EAAA;UA5CrC;;YAgDY,4BAA4B,EAAA;QAhDxC;UzBnKI,kBPoCkB,EAAA;UgC+HtB;;YzB7JI,2BP8BkB;YO7BlB,4BP6BkB,EAAA;UgC+HtB;;YzB/II,+BPgBkB;YOflB,8BPekB,EAAA;QgC+HtB;UzBnKI,gByBqO8B,EAAA;UAlElC;;;;YzBnKI,gByB2OgC,EAAA,EACzB;;AAWX;EAEI,sB/BqYkB,EAAA;;AWtkBlB;EoB+LJ;IAMI,e/B+YkB;I+B9YlB,mB/B+YsB,EAAA;I+BtZ1B;MAUM,qBAAqB;MACrB,WAAW,EAAA,EACZ;;ACvQL;EACE,aAAa;EACb,eAAe;EACf,qBhCyyByB;EgCxyBzB,mBhC2yB6B;EgC1yB7B,gBAAgB;EAChB,yBhCMgB;EMRd,kBPmCe,EAAA;;AiC7BnB;EAGI,qBAAqB;EACrB,qBhC+xB2B;EgC9xB3B,oBhC8xB2B;EgC7xB3B,chCAc;EgCCd,YAAiC,EAAA;;AAPrC;EAiBI,0BAA0B,EAAA;;AAjB9B;EAqBI,qBAAqB,EAAA;;AArBzB;EAyBI,chCnBc,EAAA;;AiChBlB;EACE,aAAa;E9BGb,eAAe;EACf,gBAAgB;EGDd,kBPmCe,EAAA;;AkCjCnB;EACE,kBAAkB;EAClB,cAAc;EACd,uBjCwlB2B;EiCvlB3B,iBjC+LgB;EiC9LhB,iBjC2lB2B;EiC1lB3B,cjCuBY;EiCtBZ,sBjCHU;EiCIV,yBjCDgB,EAAA;EiCPlB;IAWI,cjCoIuC;IiCnIvC,qBAAqB;IACrB,yBjCPc;IiCQd,qBjCPc,EAAA;EiCPlB;IAkBI,UAAU;IACV,UAAU;IACV,gDjCSU,EAAA;EiC7Bd;IAyBI,eAAe,EAAA;;AAInB;EAGM,cAAc;E3BPhB,2BPQe;EOPf,8BPOe,EAAA;;AkCJnB;E3BlBI,4BPsBe;EOrBf,+BPqBe,EAAA;;AkCJnB;EAcI,UAAU;EACV,WjCxCQ;EiCyCR,yBjChBU;EiCiBV,qBjCjBU,EAAA;;AiCAd;EAqBI,cjCxCc;EiCyCd,oBAAoB;EAEpB,YAAY;EACZ,sBjClDQ;EiCmDR,qBjChDc,EAAA;;AkCVhB;EACE,uBlCimB4B;EkChmB5B,enCgBgC;EmCfhC,gBlCgMgB,EAAA;;AkC3Ld;E5BoBF,2BPSkB;EORlB,8BPQkB,EAAA;;AmCxBhB;E5BCF,4BPuBkB;EOtBlB,+BPsBkB,EAAA;;AmCrCpB;EACE,uBlC+lB2B;EkC9lB3B,enCeiB;EmCdjB,gBlCiMgB,EAAA;;AkC5Ld;E5BoBF,2BPOkB;EONlB,8BPMkB,EAAA;;AmCtBhB;E5BCF,4BPqBkB;EOpBlB,+BPoBkB,EAAA;;AoCjCtB;EACE,qBAAqB;EACrB,qBnC2rBoB;EmC1rBpB,cnCurBmB;EmCtrBnB,gBnCgOoB;EmC/NpB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;E7BTtB,sBNwMkB,EAAA;EmCvMtB;IAaI,aAAa,EAAA;;AAKjB;EACE,kBAAkB;EAClB,SAAS,EAAA;;AAOX;EACE,oBnCoqByB;EmCnqBzB,mBnCmqByB;EMjsBvB,oBNosB4B,EAAA;;AmC7pB9B;EC1CA,WpCSU;EoCRV,yBrCwDmB,EAAA;EEtCnB;ImCdI,WpCIM;IoCHN,qBAAqB;IACrB,yBAAkC,EAAA;;ADmCtC;EC1CA,WpCSU;EoCRV,yBrC0DiB,EAAA;EExCjB;ImCdI,WpCIM;IoCHN,qBAAqB;IACrB,yBAAkC,EAAA;;ADmCtC;EC1CA,WpCSU;EoCRV,yBrCsFe,EAAA;EEpEf;ImCdI,WpCIM;IoCHN,qBAAqB;IACrB,yBAAkC,EAAA;;ADmCtC;EC1CA,WpCSU;EoCRV,yBrCuFY,EAAA;EErEZ;ImCdI,WpCIM;IoCHN,qBAAqB;IACrB,yBAAkC,EAAA;;ADmCtC;EC1CA,cpCkBgB;EoCjBhB,yBrCwFe,EAAA;EEtEf;ImCdI,cpCaY;IoCZZ,qBAAqB;IACrB,yBAAkC,EAAA;;ADmCtC;EC1CA,WpCSU;EoCRV,yBrCyFc,EAAA;EEvEd;ImCdI,WpCIM;IoCHN,qBAAqB;IACrB,yBAAkC,EAAA;;ADmCtC;EC1CA,cpCkBgB;EoCjBhB,yBrC0Fa,EAAA;EExEb;ImCdI,cpCaY;IoCZZ,qBAAqB;IACrB,yBAAkC,EAAA;;ADmCtC;EC1CA,WpCSU;EoCRV,yBpCgBgB,EAAA;ECEhB;ImCdI,WpCIM;IoCHN,qBAAqB;IACrB,yBAAkC,EAAA;;ACRxC;EACE,kBAAoD;EACpD,mBrC2nBsB;EqC1nBtB,yBrCSgB;EMRd,kBPoCkB,EAAA;EYoBlB;I0B5DJ;MAOI,kBrCsnBoB,EAAA,EqCpnBvB;;AAED;EACE,gBAAgB;EAChB,eAAe;E/BTb,gB+BUsB,EAAA;;ACV1B;EACE,kBAAkB;EAClB,wBtCuuBuB;EsCtuBvB,mBtCuuBwB;EsCtuBxB,6BAA6C;EhCJ3C,sBNwMkB,EAAA;;AsC/LtB;EAEE,cAAc,EAAA;;AAIhB;EACE,gBtCqNoB,EAAA;;AsC9MtB;EACE,mBAAwD,EAAA;EAD1D;IAKI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,wBtC0sBqB;IsCzsBrB,cAAc,EAAA;;AAShB;EC5CA,cxBmFgE;EI9E9D,yBJ8E8D;EwBjFhE,qBxBiFgE,EAAA;EwB/EhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADmC5B;EC5CA,cxBmFgE;EI9E9D,yBJ8E8D;EwBjFhE,qBxBiFgE,EAAA;EwB/EhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADmC5B;EC5CA,cxBmFgE;EI9E9D,yBJ8E8D;EwBjFhE,qBxBiFgE,EAAA;EwB/EhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADmC5B;EC5CA,cxBmFgE;EI9E9D,yBJ8E8D;EwBjFhE,qBxBiFgE,EAAA;EwB/EhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADmC5B;EC5CA,cxBmFgE;EI9E9D,yBJ8E8D;EwBjFhE,qBxBiFgE,EAAA;EwB/EhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADmC5B;EC5CA,cxBmFgE;EI9E9D,yBJ8E8D;EwBjFhE,qBxBiFgE,EAAA;EwB/EhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADmC5B;EC5CA,cxBmFgE;EI9E9D,yBJ8E8D;EwBjFhE,qBxBiFgE,EAAA;EwB/EhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADmC5B;EC5CA,cxBmFgE;EI9E9D,yBJ8E8D;EwBjFhE,qBxBiFgE,EAAA;EwB/EhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ACV9B;EACE;IACE,2BAAuC,EAAA;EAEzC;IACE,wBAAwB,EAAA,EAAA;;AAI5B;EACE,aAAa;EACb,YxC8uBoB;EwC7uBpB,gBAAgB;EAChB,kBxC6uB0C;EwC5uB1C,yBxCFgB;EMRd,sBNwMkB;EO1MlB,oDPkBQ,EAAA;;AwCDZ;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WxCbU;EwCcV,kBAAkB;EAClB,yBxCUY;EiB9BR,2BjB4vBkC,EAAA;;AwCpuBxC;ErBkBE,qMAA6I;EqBhB7I,0BxC0tBoB,EAAA;;AwCvtBtB;EACE,kDxC6tBgD,EAAA;;AyChwBlD;EACE,aAAa;EACb,uBAAuB,EAAA;;AAGzB;EACE,OAAO,EAAA;;AAGT;EACE,oBAAoB,EAAA;;ACNtB;EACE,aAAa;EACb,sBAAsB;EAGtB,eAAe;EACf,gBAAgB,EAAA;;AAQlB;EACE,WAAW;EACX,c1CHgB;E0CIhB,mBAAmB,EAAA;EzCDnB;IyCKE,c1CRc;I0CSd,qBAAqB;IACrB,yB1ChBc,EAAA;E0COlB;IAaI,c1CZc;I0Cad,yB1CpBc,EAAA;;A0C4BlB;EACE,kBAAkB;EAClB,cAAc;EACd,wB1CguBiC;E0C9tBjC,mB1C4JgB;E0C3JhB,sB1CpCU;E0CqCV,sC1C3BU,EAAA;E0CoBZ;IpC9BI,2BP8BkB;IO7BlB,4BP6BkB,EAAA;E2CAtB;IAcI,gBAAgB;IpC9BhB,+BPgBkB;IOflB,8BPekB,EAAA;EEpBpB;IyCuCE,UAAU;IACV,qBAAqB,EAAA;EApBzB;IAyBI,c1CjDc;I0CkDd,sB1CxDQ,EAAA;E0C8BZ;IA+BI,UAAU;IACV,W1C9DQ;I0C+DR,yB1CtCU;I0CuCV,qB1CvCU,EAAA;;A0CgDd;EAEI,eAAe;EACf,cAAc;EpClFd,gBoCmFwB,EAAA;;AAJ5B;EASM,aAAa,EAAA;;AATnB;EAeM,gBAAgB,EAAA;;AC/FpB;EACE,c5BgF8D;E4B/E9D,yB5B+E8D,EAAA;EdhEhE;I0CXM,c5B2E0D;I4B1E1D,yBAAyC,EAAA;EAP/C;IAWM,WAAW;IACX,yB5BqE0D;I4BpE1D,qB5BoE0D,EAAA;;A4BjFhE;EACE,c5BgF8D;E4B/E9D,yB5B+E8D,EAAA;EdhEhE;I0CXM,c5B2E0D;I4B1E1D,yBAAyC,EAAA;EAP/C;IAWM,WAAW;IACX,yB5BqE0D;I4BpE1D,qB5BoE0D,EAAA;;A4BjFhE;EACE,c5BgF8D;E4B/E9D,yB5B+E8D,EAAA;EdhEhE;I0CXM,c5B2E0D;I4B1E1D,yBAAyC,EAAA;EAP/C;IAWM,WAAW;IACX,yB5BqE0D;I4BpE1D,qB5BoE0D,EAAA;;A4BjFhE;EACE,c5BgF8D;E4B/E9D,yB5B+E8D,EAAA;EdhEhE;I0CXM,c5B2E0D;I4B1E1D,yBAAyC,EAAA;EAP/C;IAWM,WAAW;IACX,yB5BqE0D;I4BpE1D,qB5BoE0D,EAAA;;A4BjFhE;EACE,c5BgF8D;E4B/E9D,yB5B+E8D,EAAA;EdhEhE;I0CXM,c5B2E0D;I4B1E1D,yBAAyC,EAAA;EAP/C;IAWM,WAAW;IACX,yB5BqE0D;I4BpE1D,qB5BoE0D,EAAA;;A4BjFhE;EACE,c5BgF8D;E4B/E9D,yB5B+E8D,EAAA;EdhEhE;I0CXM,c5B2E0D;I4B1E1D,yBAAyC,EAAA;EAP/C;IAWM,WAAW;IACX,yB5BqE0D;I4BpE1D,qB5BoE0D,EAAA;;A4BjFhE;EACE,c5BgF8D;E4B/E9D,yB5B+E8D,EAAA;EdhEhE;I0CXM,c5B2E0D;I4B1E1D,yBAAyC,EAAA;EAP/C;IAWM,WAAW;IACX,yB5BqE0D;I4BpE1D,qB5BoE0D,EAAA;;A4BjFhE;EACE,c5BgF8D;E4B/E9D,yB5B+E8D,EAAA;EdhEhE;I0CXM,c5B2E0D;I4B1E1D,yBAAyC,EAAA;EAP/C;IAWM,WAAW;IACX,yB5BqE0D;I4BpE1D,qB5BoE0D,EAAA;;A6BpFlE;EACE,YAAY;EACZ,iB5C20BqC;E4C10BrC,gB5CsOoB;E4CrOpB,cAAc;EAGd,WAAW,EAAA;E3CaX;I2CTE,qBAAqB;IACrB,YAAY,EAAA;EAZhB;IAiBI,eAAe,EAAA;;AAUnB;EACE,UAAU;EACV,6BAA6B;EAC7B,SAAS;EACT,wBAAwB,EAAA;;ACzB1B;EACE,gBAAgB,EAAA;;AAIlB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a7CuhBiB;E6CthBjB,aAAa;EACb,gBAAgB;EAGhB,UAAU,EAAA;EAKV;IACE,kBAAkB;IAClB,gBAAgB,EAAA;;AAKpB;EACE,kBAAkB;EAClB,WAAW;EACX,c7C0qByB;E6CxqBzB,oBAAoB,EAAA;EAGpB;I5BrCI,mCjBiuBmC;I6C1rBrC,6BAA6B,EAAA;EAE/B;IACE,0BAA0B,EAAA;;AAI9B;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAsD,EAAA;;AAIxD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EAEX,oBAAoB;EACpB,sB7CvDU;E6CwDV,4BAA4B;EAC5B,oC7C/CU;EMhBR,kBPoCkB;EQtClB,+CPkBQ;E6CmDV,UAAU,EAAA;;AAIZ;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a7Csd0B;E6Crd1B,sB7C9DU,EAAA;E6CuDZ;IAWI,UAAU,EAAA;EAXd;IAcI,Y7CkoBuB,EAAA;;A6C5nB3B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,a7C6nByB;E6C5nBzB,gC7CxFgB;EMFd,2BP8BkB;EO7BlB,4BP6BkB,EAAA;E8CuDtB;IASI,a7CwnBuB;I6CtnBvB,8BAAuF,EAAA;;AAK3F;EACE,gBAAgB;EAChB,gB7C2HoB,EAAA;;A6CtHtB;EACE,kBAAkB;EAGlB,cAAc;EACd,a7CklBwB,EAAA;;A6C9kB1B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,a7C0kBwB;E6CzkBxB,6B7CxHgB,EAAA;E6CmHlB;IASI,mBAAmB,EAAA;EATvB;IAYI,oBAAoB,EAAA;;AAKxB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAA;;AlCzFd;EkC1BJ;IA0HI,gB7CukBY;I6CtkBZ,oBAAyC,EAAA;EA1G7C;IA8GI,sCAA8D,EAAA;EAvGlE;ItCxDI,4CPkBQ,EAAA;E6CoJV;IACE,gB7C2jBY,EAAA,E6C1jBb;;AlC9GC;EkCmHF;IACE,gB7CkjBY,EAAA,E6CjjBb;;AChLH;EACE,kBAAkB;EAClB,a9CuiBmB;E8CtiBnB,cAAc;EACd,S9CypBgB;E+C7pBhB,iChDe2C;EgDb3C,kBAAkB;EAClB,gB/CoOsB;E+CnOtB,gB/CuOoB;E+CtOpB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EDNhB,mB9C4NqC;E8C1NrC,qBAAqB;EACrB,UAAU,EAAA;EAXZ;IAcI,Y9C4oBgB,EAAA;E8C1pBpB;IAkBI,kBAAkB;IAClB,cAAc;IACd,a9C2oBuB;I8C1oBvB,c9C2oBwB,EAAA;I8ChqB5B;MAwBM,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,iBAAgC,EAAA;EADlC;IAII,SAAS,EAAA;IAJb;MAOM,MAAM;MACN,6BAAgE;MAChE,sB9CtBM,EAAA;;A8C2BZ;EACE,iB9CinB0B,EAAA;E8ClnB5B;IAII,OAAO;IACP,a9C6mBwB;I8C5mBxB,c9C2mBuB,EAAA;I8CjnB3B;MASM,QAAQ;MACR,oCAA2F;MAC3F,wB9CtCM,EAAA;;A8C2CZ;EACE,iBAAgC,EAAA;EADlC;IAII,MAAM,EAAA;IAJV;MAOM,SAAS;MACT,6B9C0lBsB;M8CzlBtB,yB9CpDM,EAAA;;A8CyDZ;EACE,iB9CmlB0B,EAAA;E8CplB5B;IAII,QAAQ;IACR,a9C+kBwB;I8C9kBxB,c9C6kBuB,EAAA;I8CnlB3B;MASM,OAAO;MACP,oC9C0kBsB;M8CzkBtB,uB9CpEM,EAAA;;A8CyFZ;EACE,gB9CyiBuB;E8CxiBvB,uB9C8iBuB;E8C7iBvB,W9CtGU;E8CuGV,kBAAkB;EAClB,sB9C9FU;EMhBR,sBNwMkB,EAAA;;AgD5MtB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,ahDqiBmB;EgDpiBnB,cAAc;EACd,gBhDkqBuB;E+CvqBvB,iChDe2C;EgDb3C,kBAAkB;EAClB,gB/CoOsB;E+CnOtB,gB/CuOoB;E+CtOpB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;ECLhB,mBhD2NqC;EgDzNrC,qBAAqB;EACrB,sBhDHU;EgDIV,4BAA4B;EAC5B,oChDKU;EMhBR,qBNyMoB;EO3MpB,+CPkBQ,EAAA;EgDpBZ;IAoBI,kBAAkB;IAClB,cAAc;IACd,WhDiqBsB;IgDhqBtB,chDiqBwB;IgDhqBxB,ajDgBkB,EAAA;IiDxCtB;MA4BM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,qBhDkpB0B,EAAA;EgDnpB5B;IAII,iCAAwE,EAAA;EAJ5E;;;IASI,6BAAgE,EAAA;EATpE;IAaI,SAAS;IACT,qChDwoB2D,EAAA;;EgDtpB/D;;IAkBI,WhDkJc;IgDjJd,sBhD9CQ,EAAA;;AgDkDZ;EACE,mBhD2nB0B,EAAA;EgD5nB5B;IAII,+BAAsE;IACtE,ahDunBwB;IgDtnBxB,YhDqnBsB;IgDpnBtB,aAA2B,EAAA;EAP/B;;;IAYI,oCAA2F,EAAA;EAZ/F;IAgBI,OAAO;IACP,uChD8mB2D,EAAA;;EgD/nB/D;;IAqBI,ShDwHc;IgDvHd,wBhDxEQ,EAAA;;AgD4EZ;EACE,kBhDimB0B,EAAA;EgDlmB5B;IAII,8BAAqE,EAAA;EAJzE;;;IASI,oCAA2F,EAAA;EAT/F;IAaI,MAAM;IACN,wChDulB2D,EAAA;;EgDrmB/D;;IAkBI,QhDiGc;IgDhGd,yBhD/FQ,EAAA;EgD4EZ;IAwBI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,WhDqkBsB;IgDpkBtB,oBAAwC;IACxC,WAAW;IACX,gChDyjBuC,EAAA;;AgDrjB3C;EACE,oBhD8jB0B,EAAA;EgD/jB5B;IAII,gCAAuE;IACvE,ahD0jBwB;IgDzjBxB,YhDwjBsB;IgDvjBtB,aAA2B,EAAA;EAP/B;;;IAYI,oChDmjBwB,EAAA;EgD/jB5B;IAgBI,QAAQ;IACR,sChDijB2D,EAAA;;EgDlkB/D;;IAqBI,UhD2Dc;IgD1Dd,uBhDrIQ,EAAA;;AgDyJZ;EACE,uBhD6gB+B;EgD5gB/B,gBAAgB;EAChB,ejDlJmB;EiDmJnB,chDkFsB;EgDjFtB,yBhDsgByC;EgDrgBzC,gCAAyE;E1C/JvE,uC0CgKyE;E1C/JzE,wC0C+JyE,EAAA;EAP7E;IAWI,aAAa,EAAA;;AAIjB;EACE,uBhD8f+B;EgD7f/B,chDjKgB,EAAA;;AiDlBlB;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EhCVP,+BjBo0BkC;EiDxzBtC,2BAA2B;EAC3B,mBAAmB,EAAA;;AAGrB;;;EAGE,cAAc,EAAA;;AAGhB;;EAEE,kBAAkB;EAClB,MAAM,EAAA;;AAIR;;EAEE,wBAAwB,EAAA;EAEgB;IAJ1C;;MAKI,+BAA+B,EAAA,EAElC;;AAED;;EAEE,2BAA2B,EAAA;EAEa;IAJ1C;;MAKI,kCAAkC,EAAA,EAErC;;AAED;;EAEE,4BAA4B,EAAA;EAEY;IAJ1C;;MAKI,mCAAmC,EAAA,EAEtC;;AAMD;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EAET,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UjD+uB0B;EiD9uB1B,WjDjEU;EiDkEV,kBAAkB;EAClB,YjD6uB2B,EAAA;ECtyB3B;;;IgD+DE,WjDzEQ;IiD0ER,qBAAqB;IACrB,UAAU;IACV,WAAW,EAAA;;AAIf;EACE,OAAO,EAAA;;AAMT;EACE,QAAQ,EAAA;;AAOV;;EAEE,qBAAqB;EACrB,WjDwtBgC;EiDvtBhC,YjDutBgC;EiDttBhC,+CAA+C;EAC/C,0BAA0B,EAAA;;AAG5B;EACE,yDlCvEyI,EAAA;;AkC0E3I;EACE,yDlC3EyI,EAAA;;AkCmF3I;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;EAEf,iBjDgrB0B;EiD/qB1B,gBjD+qB0B;EiD9qB1B,gBAAgB,EAAA;EAZlB;IAeI,kBAAkB;IAClB,cAAc;IACd,WjD4qB2B;IiD3qB3B,WjD4qB2B;IiD3qB3B,iBjD4qB2B;IiD3qB3B,gBjD2qB2B;IiD1qB3B,mBAAmB;IACnB,0CjD3IQ,EAAA;IiDqHZ;MA0BM,kBAAkB;MAClB,UAAU;MACV,OAAO;MACP,qBAAqB;MACrB,WAAW;MACX,YAAY;MACZ,WAAW,EAAA;IAhCjB;MAmCM,kBAAkB;MAClB,aAAa;MACb,OAAO;MACP,qBAAqB;MACrB,WAAW;MACX,YAAY;MACZ,WAAW,EAAA;EAzCjB;IA8CI,sBjDnKQ,EAAA;;AiD2KZ;EACE,kBAAkB;EAClB,UAA6C;EAC7C,YAAY;EACZ,SAA4C;EAC5C,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WjDnLU;EiDoLV,kBAAkB,EAAA;;AC5LpB;EACE,mCAAmC,EAAA;;AAIrC;EACE,8BAA8B,EAAA;;AAGhC;EACE,iCAAiC,EAAA;;AAGnC;EACE,iCAAiC,EAAA;;AAGnC;EACE,sCAAsC,EAAA;;AAGxC;EACE,mCAAmC,EAAA;;ACnBnC;EACE,oCAAmC,EAAA;;AlDcrC;;;EkDTI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;AlDcrC;;;EkDTI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;AlDcrC;;;EkDTI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;AlDcrC;;;EkDTI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;AlDcrC;;;EkDTI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;AlDcrC;;;EkDTI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;AlDcrC;;;EkDTI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;AlDcrC;;;EkDTI,oCAAgD,EAAA;;ACCtD;EACE,iCAAmC,EAAA;;AAGrC;EACE,wCAAwC,EAAA;;ACX1C;EACE,oCAAoD,EAAA;;AAGtD;EACE,wCAAwD,EAAA;;AAG1D;EACE,0CAA0D,EAAA;;AAG5D;EACE,2CAA2D,EAAA;;AAG7D;EACE,yCAAyD,EAAA;;AAG3D;EACE,oBAAoB,EAAA;;AAGtB;EACE,wBAAwB,EAAA;;AAG1B;EACE,0BAA0B,EAAA;;AAG5B;EACE,2BAA2B,EAAA;;AAG7B;EACE,yBAAyB,EAAA;;AAIzB;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AAInC;EACE,6BAA+B,EAAA;;AAOjC;EACE,6BAAwC,EAAA;;AAG1C;EACE,sCAAiD;EACjD,uCAAkD,EAAA;;AAGpD;EACE,uCAAkD;EAClD,0CAAqD,EAAA;;AAGvD;EACE,0CAAqD;EACrD,yCAAoD,EAAA;;AAGtD;EACE,sCAAiD;EACjD,yCAAoD,EAAA;;AAGtD;EACE,6BAA6B,EAAA;;AAG/B;EACE,2BAA2B,EAAA;;ACxF3B;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAA;;ACMX;EACE,wBAAwB,EAAA;;AAE1B;EACE,0BAA0B,EAAA;;AAE5B;EACE,gCAAgC,EAAA;;AAElC;EACE,yBAAyB,EAAA;;AAE3B;EACE,yBAAyB,EAAA;;AAE3B;EACE,6BAA6B,EAAA;;AAE/B;EACE,8BAA8B,EAAA;;AAEhC;EACE,wBAAwB,EAAA;;AAE1B;EACE,+BAA+B,EAAA;;A5CyBjC;E4ClDA;IACE,wBAAwB,EAAA;EAE1B;IACE,0BAA0B,EAAA;EAE5B;IACE,gCAAgC,EAAA;EAElC;IACE,yBAAyB,EAAA;EAE3B;IACE,yBAAyB,EAAA;EAE3B;IACE,6BAA6B,EAAA;EAE/B;IACE,8BAA8B,EAAA;EAEhC;IACE,wBAAwB,EAAA;EAE1B;IACE,+BAA+B,EAAA,EAChC;;A5CwBD;E4ClDA;IACE,wBAAwB,EAAA;EAE1B;IACE,0BAA0B,EAAA;EAE5B;IACE,gCAAgC,EAAA;EAElC;IACE,yBAAyB,EAAA;EAE3B;IACE,yBAAyB,EAAA;EAE3B;IACE,6BAA6B,EAAA;EAE/B;IACE,8BAA8B,EAAA;EAEhC;IACE,wBAAwB,EAAA;EAE1B;IACE,+BAA+B,EAAA,EAChC;;A5CwBD;E4ClDA;IACE,wBAAwB,EAAA;EAE1B;IACE,0BAA0B,EAAA;EAE5B;IACE,gCAAgC,EAAA;EAElC;IACE,yBAAyB,EAAA;EAE3B;IACE,yBAAyB,EAAA;EAE3B;IACE,6BAA6B,EAAA;EAE/B;IACE,8BAA8B,EAAA;EAEhC;IACE,wBAAwB,EAAA;EAE1B;IACE,+BAA+B,EAAA,EAChC;;A5CwBD;E4ClDA;IACE,wBAAwB,EAAA;EAE1B;IACE,0BAA0B,EAAA;EAE5B;IACE,gCAAgC,EAAA;EAElC;IACE,yBAAyB,EAAA;EAE3B;IACE,yBAAyB,EAAA;EAE3B;IACE,6BAA6B,EAAA;EAE/B;IACE,8BAA8B,EAAA;EAEhC;IACE,wBAAwB,EAAA;EAE1B;IACE,+BAA+B,EAAA,EAChC;;AAQL;EACE;IACE,wBAAwB,EAAA;EAE1B;IACE,0BAA0B,EAAA;EAE5B;IACE,gCAAgC,EAAA;EAElC;IACE,yBAAyB,EAAA;EAE3B;IACE,yBAAyB,EAAA;EAE3B;IACE,6BAA6B,EAAA;EAE/B;IACE,8BAA8B,EAAA;EAEhC;IACE,wBAAwB,EAAA;EAE1B;IACE,+BAA+B,EAAA,EAChC;;ACrEH;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB,EAAA;EALlB;IAQI,cAAc;IACd,WAAW,EAAA;EATf;;;;;IAiBI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,SAAS,EAAA;;AAIb;EAEI,sBAA+B,EAAA;;AAInC;EAEI,mBAA+B,EAAA;;AAInC;EAEI,gBAA8B,EAAA;;AAIlC;EAEI,iBAA8B,EAAA;;ACvC9B;EACE,8BAA8B,EAAA;;AAEhC;EACE,iCAAiC,EAAA;;AAEnC;EACE,sCAAsC,EAAA;;AAExC;EACE,yCAAyC,EAAA;;AAG3C;EACE,0BAA0B,EAAA;;AAE5B;EACE,4BAA4B,EAAA;;AAE9B;EACE,kCAAkC,EAAA;;AAGpC;EACE,sCAAsC,EAAA;;AAExC;EACE,oCAAoC,EAAA;;AAEtC;EACE,kCAAkC,EAAA;;AAEpC;EACE,yCAAyC,EAAA;;AAE3C;EACE,wCAAwC,EAAA;;AAG1C;EACE,kCAAkC,EAAA;;AAEpC;EACE,gCAAgC,EAAA;;AAElC;EACE,8BAA8B,EAAA;;AAEhC;EACE,gCAAgC,EAAA;;AAElC;EACE,+BAA+B,EAAA;;AAGjC;EACE,oCAAoC,EAAA;;AAEtC;EACE,kCAAkC,EAAA;;AAEpC;EACE,gCAAgC,EAAA;;AAElC;EACE,uCAAuC,EAAA;;AAEzC;EACE,sCAAsC,EAAA;;AAExC;EACE,iCAAiC,EAAA;;AAGnC;EACE,2BAA2B,EAAA;;AAE7B;EACE,iCAAiC,EAAA;;AAEnC;EACE,+BAA+B,EAAA;;AAEjC;EACE,6BAA6B,EAAA;;AAE/B;EACE,+BAA+B,EAAA;;AAEjC;EACE,8BAA8B,EAAA;;A9CxChC;E8ClDA;IACE,8BAA8B,EAAA;EAEhC;IACE,iCAAiC,EAAA;EAEnC;IACE,sCAAsC,EAAA;EAExC;IACE,yCAAyC,EAAA;EAG3C;IACE,0BAA0B,EAAA;EAE5B;IACE,4BAA4B,EAAA;EAE9B;IACE,kCAAkC,EAAA;EAGpC;IACE,sCAAsC,EAAA;EAExC;IACE,oCAAoC,EAAA;EAEtC;IACE,kCAAkC,EAAA;EAEpC;IACE,yCAAyC,EAAA;EAE3C;IACE,wCAAwC,EAAA;EAG1C;IACE,kCAAkC,EAAA;EAEpC;IACE,gCAAgC,EAAA;EAElC;IACE,8BAA8B,EAAA;EAEhC;IACE,gCAAgC,EAAA;EAElC;IACE,+BAA+B,EAAA;EAGjC;IACE,oCAAoC,EAAA;EAEtC;IACE,kCAAkC,EAAA;EAEpC;IACE,gCAAgC,EAAA;EAElC;IACE,uCAAuC,EAAA;EAEzC;IACE,sCAAsC,EAAA;EAExC;IACE,iCAAiC,EAAA;EAGnC;IACE,2BAA2B,EAAA;EAE7B;IACE,iCAAiC,EAAA;EAEnC;IACE,+BAA+B,EAAA;EAEjC;IACE,6BAA6B,EAAA;EAE/B;IACE,+BAA+B,EAAA;EAEjC;IACE,8BAA8B,EAAA,EAC/B;;A9CzCD;E8ClDA;IACE,8BAA8B,EAAA;EAEhC;IACE,iCAAiC,EAAA;EAEnC;IACE,sCAAsC,EAAA;EAExC;IACE,yCAAyC,EAAA;EAG3C;IACE,0BAA0B,EAAA;EAE5B;IACE,4BAA4B,EAAA;EAE9B;IACE,kCAAkC,EAAA;EAGpC;IACE,sCAAsC,EAAA;EAExC;IACE,oCAAoC,EAAA;EAEtC;IACE,kCAAkC,EAAA;EAEpC;IACE,yCAAyC,EAAA;EAE3C;IACE,wCAAwC,EAAA;EAG1C;IACE,kCAAkC,EAAA;EAEpC;IACE,gCAAgC,EAAA;EAElC;IACE,8BAA8B,EAAA;EAEhC;IACE,gCAAgC,EAAA;EAElC;IACE,+BAA+B,EAAA;EAGjC;IACE,oCAAoC,EAAA;EAEtC;IACE,kCAAkC,EAAA;EAEpC;IACE,gCAAgC,EAAA;EAElC;IACE,uCAAuC,EAAA;EAEzC;IACE,sCAAsC,EAAA;EAExC;IACE,iCAAiC,EAAA;EAGnC;IACE,2BAA2B,EAAA;EAE7B;IACE,iCAAiC,EAAA;EAEnC;IACE,+BAA+B,EAAA;EAEjC;IACE,6BAA6B,EAAA;EAE/B;IACE,+BAA+B,EAAA;EAEjC;IACE,8BAA8B,EAAA,EAC/B;;A9CzCD;E8ClDA;IACE,8BAA8B,EAAA;EAEhC;IACE,iCAAiC,EAAA;EAEnC;IACE,sCAAsC,EAAA;EAExC;IACE,yCAAyC,EAAA;EAG3C;IACE,0BAA0B,EAAA;EAE5B;IACE,4BAA4B,EAAA;EAE9B;IACE,kCAAkC,EAAA;EAGpC;IACE,sCAAsC,EAAA;EAExC;IACE,oCAAoC,EAAA;EAEtC;IACE,kCAAkC,EAAA;EAEpC;IACE,yCAAyC,EAAA;EAE3C;IACE,wCAAwC,EAAA;EAG1C;IACE,kCAAkC,EAAA;EAEpC;IACE,gCAAgC,EAAA;EAElC;IACE,8BAA8B,EAAA;EAEhC;IACE,gCAAgC,EAAA;EAElC;IACE,+BAA+B,EAAA;EAGjC;IACE,oCAAoC,EAAA;EAEtC;IACE,kCAAkC,EAAA;EAEpC;IACE,gCAAgC,EAAA;EAElC;IACE,uCAAuC,EAAA;EAEzC;IACE,sCAAsC,EAAA;EAExC;IACE,iCAAiC,EAAA;EAGnC;IACE,2BAA2B,EAAA;EAE7B;IACE,iCAAiC,EAAA;EAEnC;IACE,+BAA+B,EAAA;EAEjC;IACE,6BAA6B,EAAA;EAE/B;IACE,+BAA+B,EAAA;EAEjC;IACE,8BAA8B,EAAA,EAC/B;;A9CzCD;E8ClDA;IACE,8BAA8B,EAAA;EAEhC;IACE,iCAAiC,EAAA;EAEnC;IACE,sCAAsC,EAAA;EAExC;IACE,yCAAyC,EAAA;EAG3C;IACE,0BAA0B,EAAA;EAE5B;IACE,4BAA4B,EAAA;EAE9B;IACE,kCAAkC,EAAA;EAGpC;IACE,sCAAsC,EAAA;EAExC;IACE,oCAAoC,EAAA;EAEtC;IACE,kCAAkC,EAAA;EAEpC;IACE,yCAAyC,EAAA;EAE3C;IACE,wCAAwC,EAAA;EAG1C;IACE,kCAAkC,EAAA;EAEpC;IACE,gCAAgC,EAAA;EAElC;IACE,8BAA8B,EAAA;EAEhC;IACE,gCAAgC,EAAA;EAElC;IACE,+BAA+B,EAAA;EAGjC;IACE,oCAAoC,EAAA;EAEtC;IACE,kCAAkC,EAAA;EAEpC;IACE,gCAAgC,EAAA;EAElC;IACE,uCAAuC,EAAA;EAEzC;IACE,sCAAsC,EAAA;EAExC;IACE,iCAAiC,EAAA;EAGnC;IACE,2BAA2B,EAAA;EAE7B;IACE,iCAAiC,EAAA;EAEnC;IACE,+BAA+B,EAAA;EAEjC;IACE,6BAA6B,EAAA;EAE/B;IACE,+BAA+B,EAAA;EAEjC;IACE,8BAA8B,EAAA,EAC/B;;ACjGD;ECDF,sBAAsB,EAAA;;ADIpB;ECAF,uBAAuB,EAAA;;ADGrB;ECCF,sBAAsB,EAAA;;AhDiDpB;E+CxDA;ICDF,sBAAsB,EAAA;EDIpB;ICAF,uBAAuB,EAAA;EDGrB;ICCF,sBAAsB,EAAA,EDCnB;;A/CgDD;E+CxDA;ICDF,sBAAsB,EAAA;EDIpB;ICAF,uBAAuB,EAAA;EDGrB;ICCF,sBAAsB,EAAA,EDCnB;;A/CgDD;E+CxDA;ICDF,sBAAsB,EAAA;EDIpB;ICAF,uBAAuB,EAAA;EDGrB;ICCF,sBAAsB,EAAA,EDCnB;;A/CgDD;E+CxDA;ICDF,sBAAsB,EAAA;EDIpB;ICAF,uBAAuB,EAAA;EDGrB;ICCF,sBAAsB,EAAA,EDCnB;;AEJH;EACE,2BAA8B,EAAA;;AADhC;EACE,6BAA8B,EAAA;;AADhC;EACE,6BAA8B,EAAA;;AADhC;EACE,0BAA8B,EAAA;;AADhC;EACE,2BAA8B,EAAA;;AAMlC;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,a5DkhBiB,EAAA;;A4D/gBnB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a5D0gBiB,EAAA;;A4DtgBW;EAD9B;IAEI,gBAAgB;IAChB,MAAM;IACN,a5DkgBgB,EAAA,E4DhgBnB;;ACjCD;ECEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS,EAAA;;AAUT;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,eAAe,EAAA;;AC1Bf;EACE,qBAA4B,EAAA;;AAD9B;EACE,qBAA4B,EAAA;;AAD9B;EACE,qBAA4B,EAAA;;AAD9B;EACE,sBAA4B,EAAA;;AAD9B;EACE,sBAA4B,EAAA;;AAD9B;EACE,sBAA4B,EAAA;;AAD9B;EACE,sBAA4B,EAAA;;AAD9B;EACE,uBAA4B,EAAA;;AAKlC;EACE,0BAA0B,EAAA;;AAG5B;EACE,2BAA2B,EAAA;;ACNrB;EACE,oBAA4B,EAAA;;AAE9B;;EAEE,wBAAoC,EAAA;;AAEtC;;EAEE,0BAAwC,EAAA;;AAE1C;;EAEE,2BAA0C,EAAA;;AAE5C;;EAEE,yBAAsC,EAAA;;AAjBxC;EACE,0BAA4B,EAAA;;AAE9B;;EAEE,8BAAoC,EAAA;;AAEtC;;EAEE,gCAAwC,EAAA;;AAE1C;;EAEE,iCAA0C,EAAA;;AAE5C;;EAEE,+BAAsC,EAAA;;AAjBxC;EACE,yBAA4B,EAAA;;AAE9B;;EAEE,6BAAoC,EAAA;;AAEtC;;EAEE,+BAAwC,EAAA;;AAE1C;;EAEE,gCAA0C,EAAA;;AAE5C;;EAEE,8BAAsC,EAAA;;AAjBxC;EACE,uBAA4B,EAAA;;AAE9B;;EAEE,2BAAoC,EAAA;;AAEtC;;EAEE,6BAAwC,EAAA;;AAE1C;;EAEE,8BAA0C,EAAA;;AAE5C;;EAEE,4BAAsC,EAAA;;AAjBxC;EACE,yBAA4B,EAAA;;AAE9B;;EAEE,6BAAoC,EAAA;;AAEtC;;EAEE,+BAAwC,EAAA;;AAE1C;;EAEE,gCAA0C,EAAA;;AAE5C;;EAEE,8BAAsC,EAAA;;AAjBxC;EACE,uBAA4B,EAAA;;AAE9B;;EAEE,2BAAoC,EAAA;;AAEtC;;EAEE,6BAAwC,EAAA;;AAE1C;;EAEE,8BAA0C,EAAA;;AAE5C;;EAEE,4BAAsC,EAAA;;AAjBxC;EACE,qBAA4B,EAAA;;AAE9B;;EAEE,yBAAoC,EAAA;;AAEtC;;EAEE,2BAAwC,EAAA;;AAE1C;;EAEE,4BAA0C,EAAA;;AAE5C;;EAEE,0BAAsC,EAAA;;AAjBxC;EACE,2BAA4B,EAAA;;AAE9B;;EAEE,+BAAoC,EAAA;;AAEtC;;EAEE,iCAAwC,EAAA;;AAE1C;;EAEE,kCAA0C,EAAA;;AAE5C;;EAEE,gCAAsC,EAAA;;AAjBxC;EACE,0BAA4B,EAAA;;AAE9B;;EAEE,8BAAoC,EAAA;;AAEtC;;EAEE,gCAAwC,EAAA;;AAE1C;;EAEE,iCAA0C,EAAA;;AAE5C;;EAEE,+BAAsC,EAAA;;AAjBxC;EACE,wBAA4B,EAAA;;AAE9B;;EAEE,4BAAoC,EAAA;;AAEtC;;EAEE,8BAAwC,EAAA;;AAE1C;;EAEE,+BAA0C,EAAA;;AAE5C;;EAEE,6BAAsC,EAAA;;AAjBxC;EACE,0BAA4B,EAAA;;AAE9B;;EAEE,8BAAoC,EAAA;;AAEtC;;EAEE,gCAAwC,EAAA;;AAE1C;;EAEE,iCAA0C,EAAA;;AAE5C;;EAEE,+BAAsC,EAAA;;AAjBxC;EACE,wBAA4B,EAAA;;AAE9B;;EAEE,4BAAoC,EAAA;;AAEtC;;EAEE,8BAAwC,EAAA;;AAE1C;;EAEE,+BAA0C,EAAA;;AAE5C;;EAEE,6BAAsC,EAAA;;AAM5C;EACE,uBAAuB,EAAA;;AAEzB;;EAEE,2BAA2B,EAAA;;AAE7B;;EAEE,6BAA6B,EAAA;;AAE/B;;EAEE,8BAA8B,EAAA;;AAEhC;;EAEE,4BAA4B,EAAA;;ArDS9B;EqDjDI;IACE,oBAA4B,EAAA;EAE9B;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,yBAA4B,EAAA;EAE9B;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAjBxC;IACE,uBAA4B,EAAA;EAE9B;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAjBxC;IACE,yBAA4B,EAAA;EAE9B;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAjBxC;IACE,uBAA4B,EAAA;EAE9B;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAjBxC;IACE,qBAA4B,EAAA;EAE9B;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EAjBxC;IACE,2BAA4B,EAAA;EAE9B;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,wBAA4B,EAAA;EAE9B;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,wBAA4B,EAAA;EAE9B;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAM5C;IACE,uBAAuB,EAAA;EAEzB;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA,EAC7B;;ArDQD;EqDjDI;IACE,oBAA4B,EAAA;EAE9B;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,yBAA4B,EAAA;EAE9B;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAjBxC;IACE,uBAA4B,EAAA;EAE9B;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAjBxC;IACE,yBAA4B,EAAA;EAE9B;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAjBxC;IACE,uBAA4B,EAAA;EAE9B;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAjBxC;IACE,qBAA4B,EAAA;EAE9B;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EAjBxC;IACE,2BAA4B,EAAA;EAE9B;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,wBAA4B,EAAA;EAE9B;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,wBAA4B,EAAA;EAE9B;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAM5C;IACE,uBAAuB,EAAA;EAEzB;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA,EAC7B;;ArDQD;EqDjDI;IACE,oBAA4B,EAAA;EAE9B;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,yBAA4B,EAAA;EAE9B;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAjBxC;IACE,uBAA4B,EAAA;EAE9B;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAjBxC;IACE,yBAA4B,EAAA;EAE9B;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAjBxC;IACE,uBAA4B,EAAA;EAE9B;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAjBxC;IACE,qBAA4B,EAAA;EAE9B;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EAjBxC;IACE,2BAA4B,EAAA;EAE9B;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,wBAA4B,EAAA;EAE9B;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,wBAA4B,EAAA;EAE9B;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAM5C;IACE,uBAAuB,EAAA;EAEzB;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA,EAC7B;;ArDQD;EqDjDI;IACE,oBAA4B,EAAA;EAE9B;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,yBAA4B,EAAA;EAE9B;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAjBxC;IACE,uBAA4B,EAAA;EAE9B;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAjBxC;IACE,yBAA4B,EAAA;EAE9B;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAjBxC;IACE,uBAA4B,EAAA;EAE9B;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAjBxC;IACE,qBAA4B,EAAA;EAE9B;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EAjBxC;IACE,2BAA4B,EAAA;EAE9B;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,wBAA4B,EAAA;EAE9B;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAjBxC;IACE,0BAA4B,EAAA;EAE9B;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAjBxC;IACE,wBAA4B,EAAA;EAE9B;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAM5C;IACE,uBAAuB,EAAA;EAEzB;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA,EAC7B;;AC5CL;EACE,8BAA8B,EAAA;;AAGhC;EACE,8BAA8B,EAAA;;AAGhC;ECZE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;ADoBjB;EACE,2BAA2B,EAAA;;AAE7B;EACE,4BAA4B,EAAA;;AAE9B;EACE,6BAA6B,EAAA;;AtD2B/B;EsDlCA;IACE,2BAA2B,EAAA;EAE7B;IACE,4BAA4B,EAAA;EAE9B;IACE,6BAA6B,EAAA,EAC9B;;AtD0BD;EsDlCA;IACE,2BAA2B,EAAA;EAE7B;IACE,4BAA4B,EAAA;EAE9B;IACE,6BAA6B,EAAA,EAC9B;;AtD0BD;EsDlCA;IACE,2BAA2B,EAAA;EAE7B;IACE,4BAA4B,EAAA;EAE9B;IACE,6BAA6B,EAAA,EAC9B;;AtD0BD;EsDlCA;IACE,2BAA2B,EAAA;EAE7B;IACE,4BAA4B,EAAA;EAE9B;IACE,6BAA6B,EAAA,EAC9B;;AAML;EACE,oCAAoC,EAAA;;AAGtC;EACE,oCAAoC,EAAA;;AAGtC;EACE,qCAAqC,EAAA;;AAKvC;EACE,2BAA0C,EAAA;;AAG5C;EACE,2BAA2C,EAAA;;AAG7C;EACE,2BAAyC,EAAA;;AAG3C;EACE,6BAA6B,EAAA;;AAK/B;EACE,sBAAsB,EAAA;;AEpEtB;EACE,yBAAwB,EAAA;;AlEc1B;EkEVI,yBAAqC,EAAA;;AALzC;EACE,yBAAwB,EAAA;;AlEc1B;EkEVI,yBAAqC,EAAA;;AALzC;EACE,yBAAwB,EAAA;;AlEc1B;EkEVI,yBAAqC,EAAA;;AALzC;EACE,yBAAwB,EAAA;;AlEc1B;EkEVI,yBAAqC,EAAA;;AALzC;EACE,yBAAwB,EAAA;;AlEc1B;EkEVI,yBAAqC,EAAA;;AALzC;EACE,yBAAwB,EAAA;;AlEc1B;EkEVI,yBAAqC,EAAA;;AALzC;EACE,yBAAwB,EAAA;;AlEc1B;EkEVI,yBAAqC,EAAA;;AALzC;EACE,yBAAwB,EAAA;;AlEc1B;EkEVI,yBAAqC,EAAA;;AFsE3C;EACE,yBAA6B,EAAA;;AAK/B;EGnFE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS,EAAA;;ACHX;ECCE,8BAAkC,EAAA;;ADGpC;ECHE,6BAAkC,EAAA;;ACMlC;EzEQF;;;IyEFM,4BAA4B;IAE5B,2BAA2B,EAAA;EAG7B;IAEI,0BAA0B,EAAA;EAS9B;IACE,6BAA6B,EAAA;EzEsNnC;IyEvMM,gCAAgC,EAAA;EAElC;;IAEE,sBAAgC;IAChC,wBAAwB,EAAA;EAQ1B;IACE,2BAA2B,EAAA;EAG7B;;IAEE,wBAAwB,EAAA;EAG1B;;;IAGE,UAAU;IACV,SAAS,EAAA;EAGX;;IAEE,uBAAuB,EAAA;EAQzB;IACE,QvEwwBc,EAAA;EFzyBpB;IyEoCM,2BAA2C,EAAA;E9DvF/C;I8D0FI,2BAA2C,EAAA;EzC/EjD;IyCoFM,aAAa,EAAA;EpC/FnB;IoCkGM,sBAAgC,EAAA;E1DnGtC;I0DuGM,oCAAoC,EAAA;IADtC;;MAKI,iCAAiC,EAAA;E1DjEzC;;I0DuEQ,iCAAiC,EAAA,EAClC","sourcesContent":["/*!\r\n * Bootstrap v4.0.0 (https://getbootstrap.com)\r\n * Copyright 2011-2018 The Bootstrap Authors\r\n * Copyright 2011-2018 Twitter, Inc.\r\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\r\n */\r\n@import \"functions\";\r\n@import \"variables\";\r\n@import \"mixins\";\r\n@import \"root\";\r\n@import \"reboot\";\r\n@import \"type\";\r\n@import \"images\";\r\n@import \"code\";\r\n@import \"grid\";\r\n@import \"tables\";\r\n@import \"forms\";\r\n@import \"buttons\";\r\n@import \"transitions\";\r\n@import \"dropdown\";\r\n@import \"button-group\";\r\n@import \"input-group\";\r\n@import \"custom-forms\";\r\n@import \"nav\";\r\n@import \"navbar\";\r\n@import \"card\";\r\n@import \"breadcrumb\";\r\n@import \"pagination\";\r\n@import \"badge\";\r\n@import \"jumbotron\";\r\n@import \"alert\";\r\n@import \"progress\";\r\n@import \"media\";\r\n@import \"list-group\";\r\n@import \"close\";\r\n@import \"modal\";\r\n@import \"tooltip\";\r\n@import \"popover\";\r\n@import \"carousel\";\r\n@import \"utilities\";\r\n@import \"print\";\r\n","// The reason for doing so is to solve \"relative assets (images, fonts) fail to find\" issue\r\n// The only file changed is bootstrap/_bootstrap.scss\r\n@import \"global/variables\";\r\n@import \"bootstrap/bootstrap\";",":root {\r\n  // Custom variable values only support SassScript inside `#{}`.\r\n  @each $color, $value in $colors {\r\n    --#{$color}: #{$value};\r\n  }\r\n\r\n  @each $color, $value in $theme-colors {\r\n    --#{$color}: #{$value};\r\n  }\r\n\r\n  @each $bp, $value in $grid-breakpoints {\r\n    --breakpoint-#{$bp}: #{$value};\r\n  }\r\n\r\n  // Use `inspect` for lists so that quoted items keep the quotes.\r\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\r\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\r\n  --font-family-monospace: #{inspect($font-family-monospace)};\r\n}\r\n","// stylelint-disable at-rule-no-vendor-prefix, declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\r\n\r\n// Reboot\r\n//\r\n// Normalization of HTML elements, manually forked from Normalize.css to remove\r\n// styles targeting irrelevant browsers while applying new styles.\r\n//\r\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\r\n\r\n// Document\r\n//\r\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\r\n// 2. Change the default font family in all browsers.\r\n// 3. Correct the line height in all browsers.\r\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\r\n// 5. Setting @viewport causes scrollbars to overlap content in IE11 and Edge, so\r\n//    we force a non-overlapping, non-auto-hiding scrollbar to counteract.\r\n// 6. Change the default tap highlight to be completely transparent in iOS.\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box; // 1\r\n}\r\n\r\nhtml {\r\n  font-family: sans-serif; // 2\r\n  line-height: 1.15; // 3\r\n  -webkit-text-size-adjust: 100%; // 4\r\n  -ms-text-size-adjust: 100%; // 4\r\n  -ms-overflow-style: scrollbar; // 5\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); // 6\r\n}\r\n\r\n// IE10+ doesn't honor `<meta name=\"viewport\">` in some cases.\r\n@at-root {\r\n  @-ms-viewport {\r\n    width: device-width;\r\n  }\r\n}\r\n\r\n// stylelint-disable selector-list-comma-newline-after\r\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\r\narticle, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {\r\n  display: block;\r\n}\r\n\r\n// stylelint-enable selector-list-comma-newline-after\r\n\r\n// Body\r\n//\r\n// 1. Remove the margin in all browsers.\r\n// 2. As a best practice, apply a default `background-color`.\r\n// 3. Set an explicit initial text-align value so that we can later use the\r\n//    the `inherit` value on things like `<th>` elements.\r\n\r\nbody {\r\n  margin: 0; // 1\r\n  font-family: $font-family-base;\r\n  font-size: $font-size-base;\r\n  font-weight: $font-weight-base;\r\n  line-height: $line-height-base;\r\n  color: $body-color;\r\n  text-align: left; // 3\r\n  background-color: $body-bg; // 2\r\n}\r\n\r\n// Suppress the focus outline on elements that cannot be accessed via keyboard.\r\n// This prevents an unwanted focus outline from appearing around elements that\r\n// might still respond to pointer events.\r\n//\r\n// Credit: https://github.com/suitcss/base\r\n[tabindex=\"-1\"]:focus {\r\n  outline: 0 !important;\r\n}\r\n\r\n// Content grouping\r\n//\r\n// 1. Add the correct box sizing in Firefox.\r\n// 2. Show the overflow in Edge and IE.\r\n\r\nhr {\r\n  box-sizing: content-box; // 1\r\n  height: 0; // 1\r\n  overflow: visible; // 2\r\n}\r\n\r\n//\r\n// Typography\r\n//\r\n\r\n// Remove top margins from headings\r\n//\r\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\r\n// margin for easier control within type scales as it avoids margin collapsing.\r\n// stylelint-disable selector-list-comma-newline-after\r\nh1, h2, h3, h4, h5, h6 {\r\n  margin-top: 0;\r\n  margin-bottom: $headings-margin-bottom;\r\n}\r\n\r\n// stylelint-enable selector-list-comma-newline-after\r\n\r\n// Reset margins on paragraphs\r\n//\r\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\r\n// bottom margin to use `rem` units instead of `em`.\r\np {\r\n  margin-top: 0;\r\n  margin-bottom: $paragraph-margin-bottom;\r\n}\r\n\r\n// Abbreviations\r\n//\r\n// 1. Remove the bottom border in Firefox 39-.\r\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\r\n// 3. Add explicit cursor to indicate changed behavior.\r\n// 4. Duplicate behavior to the data-* attribute for our tooltip plugin\r\n\r\nabbr[title],\r\nabbr[data-original-title] { // 4\r\n  text-decoration: underline; // 2\r\n  text-decoration: underline dotted; // 2\r\n  cursor: help; // 3\r\n  border-bottom: 0; // 1\r\n}\r\n\r\naddress {\r\n  margin-bottom: 1rem;\r\n  font-style: normal;\r\n  line-height: inherit;\r\n}\r\n\r\nol,\r\nul,\r\ndl {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nol ol,\r\nul ul,\r\nol ul,\r\nul ol {\r\n  margin-bottom: 0;\r\n}\r\n\r\ndt {\r\n  font-weight: $dt-font-weight;\r\n}\r\n\r\ndd {\r\n  margin-bottom: .5rem;\r\n  margin-left: 0; // Undo browser default\r\n}\r\n\r\nblockquote {\r\n  margin: 0 0 1rem;\r\n}\r\n\r\ndfn {\r\n  font-style: italic; // Add the correct font style in Android 4.3-\r\n}\r\n\r\n// stylelint-disable font-weight-notation\r\nb,\r\nstrong {\r\n  font-weight: bolder; // Add the correct font weight in Chrome, Edge, and Safari\r\n}\r\n\r\n// stylelint-enable font-weight-notation\r\n\r\nsmall {\r\n  font-size: 80%; // Add the correct font size in all browsers\r\n}\r\n\r\n//\r\n// Prevent `sub` and `sup` elements from affecting the line height in\r\n// all browsers.\r\n//\r\n\r\nsub,\r\nsup {\r\n  position: relative;\r\n  font-size: 75%;\r\n  line-height: 0;\r\n  vertical-align: baseline;\r\n}\r\n\r\nsub {\r\n  bottom: -.25em;\r\n}\r\n\r\nsup {\r\n  top: -.5em;\r\n}\r\n\r\n//\r\n// Links\r\n//\r\n\r\na {\r\n  color: $link-color;\r\n  text-decoration: $link-decoration;\r\n  background-color: transparent; // Remove the gray background on active links in IE 10.\r\n  -webkit-text-decoration-skip: objects; // Remove gaps in links underline in iOS 8+ and Safari 8+.\r\n\r\n  @include hover {\r\n    color: $link-hover-color;\r\n    text-decoration: $link-hover-decoration;\r\n  }\r\n}\r\n\r\n// And undo these styles for placeholder links/named anchors (without href)\r\n// which have not been made explicitly keyboard-focusable (without tabindex).\r\n// It would be more straightforward to just use a[href] in previous block, but that\r\n// causes specificity issues in many other styles that are too complex to fix.\r\n// See https://github.com/twbs/bootstrap/issues/19402\r\n\r\na:not([href]):not([tabindex]) {\r\n  color: inherit;\r\n  text-decoration: none;\r\n\r\n  @include hover-focus {\r\n    color: inherit;\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus {\r\n    outline: 0;\r\n  }\r\n}\r\n\r\n//\r\n// Code\r\n//\r\n\r\n// stylelint-disable font-family-no-duplicate-names\r\npre,\r\ncode,\r\nkbd,\r\nsamp {\r\n  font-family: monospace, monospace; // Correct the inheritance and scaling of font size in all browsers.\r\n  font-size: 1em; // Correct the odd `em` font sizing in all browsers.\r\n}\r\n\r\n// stylelint-enable font-family-no-duplicate-names\r\n\r\npre {\r\n  // Remove browser default top margin\r\n  margin-top: 0;\r\n  // Reset browser default of `1em` to use `rem`s\r\n  margin-bottom: 1rem;\r\n  // Don't allow content to break outside\r\n  overflow: auto;\r\n  // We have @viewport set which causes scrollbars to overlap content in IE11 and Edge, so\r\n  // we force a non-overlapping, non-auto-hiding scrollbar to counteract.\r\n  -ms-overflow-style: scrollbar;\r\n}\r\n\r\n//\r\n// Figures\r\n//\r\n\r\nfigure {\r\n  // Apply a consistent margin strategy (matches our type styles).\r\n  margin: 0 0 1rem;\r\n}\r\n\r\n//\r\n// Images and content\r\n//\r\n\r\nimg {\r\n  vertical-align: middle;\r\n  border-style: none; // Remove the border on images inside links in IE 10-.\r\n}\r\n\r\nsvg:not(:root) {\r\n  overflow: hidden; // Hide the overflow in IE\r\n}\r\n\r\n//\r\n// Tables\r\n//\r\n\r\ntable {\r\n  border-collapse: collapse; // Prevent double borders\r\n}\r\n\r\ncaption {\r\n  padding-top: $table-cell-padding;\r\n  padding-bottom: $table-cell-padding;\r\n  color: $text-muted;\r\n  text-align: left;\r\n  caption-side: bottom;\r\n}\r\n\r\nth {\r\n  // Matches default `<td>` alignment by inheriting from the `<body>`, or the\r\n  // closest parent with a set `text-align`.\r\n  text-align: inherit;\r\n}\r\n\r\n//\r\n// Forms\r\n//\r\n\r\nlabel {\r\n  // Allow labels to use `margin` for spacing.\r\n  display: inline-block;\r\n  margin-bottom: .5rem;\r\n}\r\n\r\n// Remove the default `border-radius` that macOS Chrome adds.\r\n//\r\n// Details at https://github.com/twbs/bootstrap/issues/24093\r\nbutton {\r\n  border-radius: 0;\r\n}\r\n\r\n// Work around a Firefox/IE bug where the transparent `button` background\r\n// results in a loss of the default `button` focus styles.\r\n//\r\n// Credit: https://github.com/suitcss/base/\r\nbutton:focus {\r\n  outline: 1px dotted;\r\n  outline: 5px auto -webkit-focus-ring-color;\r\n}\r\n\r\ninput,\r\nbutton,\r\nselect,\r\noptgroup,\r\ntextarea {\r\n  margin: 0; // Remove the margin in Firefox and Safari\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n}\r\n\r\nbutton,\r\ninput {\r\n  overflow: visible; // Show the overflow in Edge\r\n}\r\n\r\nbutton,\r\nselect {\r\n  text-transform: none; // Remove the inheritance of text transform in Firefox\r\n}\r\n\r\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\r\n//    controls in Android 4.\r\n// 2. Correct the inability to style clickable types in iOS and Safari.\r\nbutton,\r\nhtml [type=\"button\"], // 1\r\n[type=\"reset\"],\r\n[type=\"submit\"] {\r\n  -webkit-appearance: button; // 2\r\n}\r\n\r\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\r\nbutton::-moz-focus-inner,\r\n[type=\"button\"]::-moz-focus-inner,\r\n[type=\"reset\"]::-moz-focus-inner,\r\n[type=\"submit\"]::-moz-focus-inner {\r\n  padding: 0;\r\n  border-style: none;\r\n}\r\n\r\ninput[type=\"radio\"],\r\ninput[type=\"checkbox\"] {\r\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\r\n  padding: 0; // 2. Remove the padding in IE 10-\r\n}\r\n\r\ninput[type=\"date\"],\r\ninput[type=\"time\"],\r\ninput[type=\"datetime-local\"],\r\ninput[type=\"month\"] {\r\n  // Remove the default appearance of temporal inputs to avoid a Mobile Safari\r\n  // bug where setting a custom line-height prevents text from being vertically\r\n  // centered within the input.\r\n  // See https://bugs.webkit.org/show_bug.cgi?id=139848\r\n  // and https://github.com/twbs/bootstrap/issues/11266\r\n  -webkit-appearance: listbox;\r\n}\r\n\r\ntextarea {\r\n  overflow: auto; // Remove the default vertical scrollbar in IE.\r\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\r\n  resize: vertical;\r\n}\r\n\r\nfieldset {\r\n  // Browsers set a default `min-width: min-content;` on fieldsets,\r\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\r\n  // So we reset that to ensure fieldsets behave more like a standard block element.\r\n  // See https://github.com/twbs/bootstrap/issues/12359\r\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\r\n  min-width: 0;\r\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\r\n  padding: 0;\r\n  margin: 0;\r\n  border: 0;\r\n}\r\n\r\n// 1. Correct the text wrapping in Edge and IE.\r\n// 2. Correct the color inheritance from `fieldset` elements in IE.\r\nlegend {\r\n  display: block;\r\n  width: 100%;\r\n  max-width: 100%; // 1\r\n  padding: 0;\r\n  margin-bottom: .5rem;\r\n  font-size: 1.5rem;\r\n  line-height: inherit;\r\n  color: inherit; // 2\r\n  white-space: normal; // 1\r\n}\r\n\r\nprogress {\r\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\r\n}\r\n\r\n// Correct the cursor style of increment and decrement buttons in Chrome.\r\n[type=\"number\"]::-webkit-inner-spin-button,\r\n[type=\"number\"]::-webkit-outer-spin-button {\r\n  height: auto;\r\n}\r\n\r\n[type=\"search\"] {\r\n  // This overrides the extra rounded corners on search inputs in iOS so that our\r\n  // `.form-control` class can properly style them. Note that this cannot simply\r\n  // be added to `.form-control` as it's not specific enough. For details, see\r\n  // https://github.com/twbs/bootstrap/issues/11586.\r\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\r\n  -webkit-appearance: none;\r\n}\r\n\r\n//\r\n// Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\r\n//\r\n\r\n[type=\"search\"]::-webkit-search-cancel-button,\r\n[type=\"search\"]::-webkit-search-decoration {\r\n  -webkit-appearance: none;\r\n}\r\n\r\n//\r\n// 1. Correct the inability to style clickable types in iOS and Safari.\r\n// 2. Change font properties to `inherit` in Safari.\r\n//\r\n\r\n::-webkit-file-upload-button {\r\n  font: inherit; // 2\r\n  -webkit-appearance: button; // 1\r\n}\r\n\r\n//\r\n// Correct element displays\r\n//\r\n\r\noutput {\r\n  display: inline-block;\r\n}\r\n\r\nsummary {\r\n  display: list-item; // Add the correct display in all browsers\r\n  cursor: pointer;\r\n}\r\n\r\ntemplate {\r\n  display: none; // Add the correct display in IE\r\n}\r\n\r\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\r\n// Needed for proper display in IE 10-.\r\n[hidden] {\r\n  display: none !important;\r\n}\r\n","@import \"../bootstrap/functions\";\r\n@import \"../bootstrap/variables\";\r\n@import \"../bootstrap/mixins\";\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n// @import url('https://fonts.googleapis.com/css?family=Nunito+Sans:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i');\r\n@import url(\"https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n\r\n//# sourceMappingURL=roboto.css.map\r\n\r\n// import material icons\r\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: 'Roboto', sans-serif;\r\n$font-family-base: $font-family-sans-serif;\r\n\r\n// stylelint-enable value-keyword-case\r\n$font-size-base: 13px; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base + 4);\r\n$font-size-sm: $font-size-base;\r\n\r\n$h1-font-size: 24px;\r\n$h2-font-size: 18px;\r\n$h3-font-size: 16px;\r\n$h4-font-size: 15px;\r\n$h5-font-size: 13px;\r\n$h6-font-size: 12px;\r\n\r\n$headings-margin-bottom: ($h1-font-size / 2);\r\n$headings-font-family: inherit;\r\n$headings-font-weight: 400;\r\n$headings-line-height: 1.2;\r\n$headings-color: inherit;\r\n\r\n//Border Radius\r\n$border-radius-sm: 2px;\r\n$border-radius: 4px;\r\n$border-radius-lg: 8px;\r\n$border-radius-xl: 10px !default;\r\n$border-radius-circle: 50% !default;\r\n\r\n//Bootstrap Card Variables\r\n$card-spacer-y: 24px;\r\n$card-spacer-x: 30px;\r\n$card-border-color: $border-color;\r\n$card-border-radius: $border-radius-lg;\r\n$card-inner-border-radius: $border-radius-lg;\r\n$list-group-border-radius: $border-radius-lg;\r\n\r\n//Grid Gutter Space Between\r\n$grid-gutter-width: 34px;\r\n\r\n//Mixin Values True and False\r\n$enable-shadows: true;\r\n\r\n$app-primary: #3f51b5 !default;\r\n$primary: $app-primary;\r\n$secondary: #E91E63;\r\n$gray-default: #808080 !default;\r\n\r\n$sidebar-bg: #f5f7f9 !default;\r\n$sidebar-text-color: #868e96 !default;\r\n$sidebar-bg-darken: darken($sidebar-bg, 3%);\r\n$sidebar-hover-color: $app-primary;\r\n\r\n$top-nav-bg: $app-primary !default;\r\n\r\n//Default shadow\r\n$shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\r\n$shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);\r\n$shadow-lg: 0 1px 8px -1px rgba(0, 0, 0, 0.20);\r\n$shadow-xl: 0 0 16px 0px rgba(0, 0, 0, 0.20);\r\n$avatar-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.50);\r\n\r\n//Custom Card Variables\r\n$jr-card-shadow: $shadow !default;\r\n$jr-card-margin: 34px !default;\r\n$jr-card-padding: 24px 30px !default;\r\n$jr-border: 1px solid $gray-400 !default;\r\n\r\n// Links\r\n$link-color: $app-primary;\r\n$link-hover-color: darken($app-primary, 10%);\r\n\r\n//Color Variables\r\n$success: #4caf50;\r\n$info: #00bcd4;\r\n$warning: #ff9800;\r\n$danger: #f44336;\r\n$light: #e8eaf6;\r\n$dark: $gray-800;\r\n$body-bg: #fff;\r\n$body-color: #5c5c5c;\r\n\r\n$theme-colors: (\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n);\r\n\r\n//Default Image Location\r\n$image_path: \"../assets/images\" !default;\r\n\r\n// Motion\r\n// https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves\r\n$transition-bezier: .05, .74, .27, .99 !default; // for nav, quickview\r\n\r\n$transition-ease: cubic-bezier(0.4, 0.0, 0.2, 1) !default;\r\n$transition-ease-out: cubic-bezier(0.0, 0.0, 0.2, 1) !default;\r\n$transition-ease-in: cubic-bezier(0.4, 0.0, 1, 1) !default;\r\n\r\n//Side Nav Width\r\n$side-nav-width: 200px !default;\r\n$mini-drawer-width: 80px !default;\r\n\r\n//App Bar Height\r\n$app-bar-height: 60px !default;\r\n\r\n//Footer Height\r\n$footer-height: 50px !default;\r\n\r\n//latter Spacing variables\r\n$letter-spacing-base: 3px !default;\r\n$letter-spacing-lg: 6px !default;\r\n$letter-spacing-xl: 8px !default;\r\n\r\n//Button Variables\r\n$btn-font-size-lg: $font-size-lg !default;\r\n$btn-font-size: $font-size-base !default;\r\n$btn-font-size-sm: $font-size-sm !default;\r\n$btn-font-size-xs: 10px !default;\r\n\r\n$btn-padding-lg: 16px 24px !default;\r\n$btn-padding: 12px 20px !default;\r\n$btn-padding-sm: 8px 15px !default;\r\n$btn-padding-xs: 6px 10px !default;\r\n\r\n$btn-fab-size-lg: 70px !default;\r\n$btn-fab-size-sm: 46px !default;\r\n$btn-fab-size-xs: 40px !default;\r\n\r\n$btn-line-height: 1.2;\r\n\r\n//Sizes Variables\r\n\r\n$size-20: 20px !default;\r\n$size-30: 30px !default;\r\n$size-40: 40px !default;\r\n$size-50: 50px !default;\r\n$size-60: 60px !default;\r\n$size-80: 80px !default;\r\n$size-100: 100px !default;\r\n$size-120: 120px !default;","// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n//\r\n// Color system\r\n//\r\n\r\n// stylelint-disable\r\n$white: #fff !default;\r\n$gray-100: #f8f9fa !default;\r\n$gray-200: #e9ecef !default;\r\n$gray-300: #dee2e6 !default;\r\n$gray-400: #ced4da !default;\r\n$gray-500: #adb5bd !default;\r\n$gray-600: #6c757d !default;\r\n$gray-700: #495057 !default;\r\n$gray-800: #343a40 !default;\r\n$gray-900: #212529 !default;\r\n$black: #000 !default;\r\n\r\n$grays: () !default;\r\n$grays: map-merge((\r\n        \"100\": $gray-100,\r\n        \"200\": $gray-200,\r\n        \"300\": $gray-300,\r\n        \"400\": $gray-400,\r\n        \"500\": $gray-500,\r\n        \"600\": $gray-600,\r\n        \"700\": $gray-700,\r\n        \"800\": $gray-800,\r\n        \"900\": $gray-900\r\n), $grays);\r\n\r\n$blue: #007bff !default;\r\n$indigo: #6610f2 !default;\r\n$purple: #6f42c1 !default;\r\n$pink: #e83e8c !default;\r\n$red: #dc3545 !default;\r\n$orange: #fd7e14 !default;\r\n$yellow: #ffc107 !default;\r\n$green: #28a745 !default;\r\n$teal: #20c997 !default;\r\n$cyan: #17a2b8 !default;\r\n\r\n$colors: () !default;\r\n$colors: map-merge((\r\n        \"blue\": $blue,\r\n        \"indigo\": $indigo,\r\n        \"purple\": $purple,\r\n        \"pink\": $pink,\r\n        \"red\": $red,\r\n        \"orange\": $orange,\r\n        \"yellow\": $yellow,\r\n        \"green\": $green,\r\n        \"teal\": $teal,\r\n        \"cyan\": $cyan,\r\n        \"white\": $white,\r\n        \"gray\": $gray-600,\r\n        \"gray-dark\": $gray-800\r\n), $colors);\r\n\r\n$primary: $blue !default;\r\n$secondary: $gray-600 !default;\r\n$success: $green !default;\r\n$info: $cyan !default;\r\n$warning: $yellow !default;\r\n$danger: $red !default;\r\n$light: $gray-100 !default;\r\n$dark: $gray-800 !default;\r\n\r\n$theme-colors: () !default;\r\n$theme-colors: map-merge((\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n), $theme-colors);\r\n// stylelint-enable\r\n\r\n// Set a specific jump point for requesting color jumps\r\n$theme-color-interval: 8% !default;\r\n\r\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\r\n$yiq-contrasted-threshold: 150 !default;\r\n\r\n// Customize the light and dark text colors for use in our YIQ color contrast function.\r\n$yiq-text-dark: $gray-900 !default;\r\n$yiq-text-light: $white !default;\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret: true !default;\r\n$enable-rounded: true !default;\r\n$enable-shadows: false !default;\r\n$enable-gradients: false !default;\r\n$enable-transitions: true !default;\r\n$enable-hover-media-query: false !default; // Deprecated, no longer affects any compiled CSS\r\n$enable-grid-classes: true !default;\r\n$enable-print-styles: true !default;\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n// stylelint-disable\r\n$spacer: 1rem !default;\r\n$spacers: () !default;\r\n$spacers: map-merge((\r\n        0: 0,\r\n        1: ($spacer * .25),\r\n        2: ($spacer * .5),\r\n        3: $spacer,\r\n        4: ($spacer * 1.5),\r\n        5: ($spacer * 3)\r\n), $spacers);\r\n\r\n// This variable affects the `.h-*` and `.w-*` classes.\r\n$sizes: () !default;\r\n$sizes: map-merge((\r\n        25: 25%,\r\n        50: 50%,\r\n        75: 75%,\r\n        100: 100%\r\n), $sizes);\r\n// stylelint-enable\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg: $white !default;\r\n$body-color: $gray-900 !default;\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color: theme-color(\"primary\") !default;\r\n$link-decoration: none !default;\r\n$link-hover-color: darken($link-color, 15%) !default;\r\n$link-hover-decoration: underline !default;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom: 1rem !default;\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n$grid-breakpoints: (\r\n        xs: 0,\r\n        sm: 576px,\r\n        md: 768px,\r\n        lg: 992px,\r\n        xl: 1200px\r\n) !default;\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints);\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n$container-max-widths: (\r\n        sm: 540px,\r\n        md: 720px,\r\n        lg: 960px,\r\n        xl: 1140px\r\n) !default;\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns: 12 !default;\r\n$grid-gutter-width: 30px !default;\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n$line-height-lg: 1.5 !default;\r\n$line-height-sm: 1.5 !default;\r\n\r\n$border-width: 1px !default;\r\n$border-color: $gray-300 !default;\r\n\r\n$border-radius: .25rem !default;\r\n$border-radius-lg: .3rem !default;\r\n$border-radius-sm: .2rem !default;\r\n\r\n$component-active-color: $white !default;\r\n$component-active-bg: theme-color(\"primary\") !default;\r\n\r\n$caret-width: .3em !default;\r\n\r\n$transition-base: all .2s ease-in-out !default;\r\n$transition-fade: opacity .15s linear !default;\r\n$transition-collapse: height .35s ease !default;\r\n\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !default;\r\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\r\n$font-family-base: $font-family-sans-serif !default;\r\n// stylelint-enable value-keyword-case\r\n\r\n$font-size-base: 1rem !default; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base * 1.25) !default;\r\n$font-size-sm: ($font-size-base * .875) !default;\r\n\r\n$font-weight-light: 300 !default;\r\n$font-weight-normal: 400 !default;\r\n$font-weight-bold: 700 !default;\r\n\r\n$font-weight-base: $font-weight-normal !default;\r\n$line-height-base: 1.5 !default;\r\n\r\n$h1-font-size: $font-size-base * 2.5 !default;\r\n$h2-font-size: $font-size-base * 2 !default;\r\n$h3-font-size: $font-size-base * 1.75 !default;\r\n$h4-font-size: $font-size-base * 1.5 !default;\r\n$h5-font-size: $font-size-base * 1.25 !default;\r\n$h6-font-size: $font-size-base !default;\r\n\r\n$headings-margin-bottom: ($spacer / 2) !default;\r\n$headings-font-family: inherit !default;\r\n$headings-font-weight: 500 !default;\r\n$headings-line-height: 1.2 !default;\r\n$headings-color: inherit !default;\r\n\r\n$display1-size: 6rem !default;\r\n$display2-size: 5.5rem !default;\r\n$display3-size: 4.5rem !default;\r\n$display4-size: 3.5rem !default;\r\n\r\n$display1-weight: 300 !default;\r\n$display2-weight: 300 !default;\r\n$display3-weight: 300 !default;\r\n$display4-weight: 300 !default;\r\n$display-line-height: $headings-line-height !default;\r\n\r\n$lead-font-size: ($font-size-base * 1.25) !default;\r\n$lead-font-weight: 300 !default;\r\n\r\n$small-font-size: 80% !default;\r\n\r\n$text-muted: $gray-600 !default;\r\n\r\n$blockquote-small-color: $gray-600 !default;\r\n$blockquote-font-size: ($font-size-base * 1.25) !default;\r\n\r\n$hr-border-color: rgba($black, .1) !default;\r\n$hr-border-width: $border-width !default;\r\n\r\n$mark-padding: .2em !default;\r\n\r\n$dt-font-weight: $font-weight-bold !default;\r\n\r\n$kbd-box-shadow: inset 0 -.1rem 0 rgba($black, .25) !default;\r\n$nested-kbd-font-weight: $font-weight-bold !default;\r\n\r\n$list-inline-padding: .5rem !default;\r\n\r\n$mark-bg: #fcf8e3 !default;\r\n\r\n$hr-margin-y: $spacer !default;\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n$table-cell-padding: .75rem !default;\r\n$table-cell-padding-sm: .3rem !default;\r\n\r\n$table-bg: transparent !default;\r\n$table-accent-bg: rgba($black, .05) !default;\r\n$table-hover-bg: rgba($black, .075) !default;\r\n$table-active-bg: $table-hover-bg !default;\r\n\r\n$table-border-width: $border-width !default;\r\n$table-border-color: $gray-300 !default;\r\n\r\n$table-head-bg: $gray-200 !default;\r\n$table-head-color: $gray-700 !default;\r\n\r\n$table-dark-bg: $gray-900 !default;\r\n$table-dark-accent-bg: rgba($white, .05) !default;\r\n$table-dark-hover-bg: rgba($white, .075) !default;\r\n$table-dark-border-color: lighten($gray-900, 7.5%) !default;\r\n$table-dark-color: $body-bg !default;\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n$input-btn-padding-y: .375rem !default;\r\n$input-btn-padding-x: .75rem !default;\r\n$input-btn-line-height: $line-height-base !default;\r\n\r\n$input-btn-focus-width: .2rem !default;\r\n$input-btn-focus-color: rgba($component-active-bg, .25) !default;\r\n$input-btn-focus-box-shadow: 0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\r\n\r\n$input-btn-padding-y-sm: .25rem !default;\r\n$input-btn-padding-x-sm: .5rem !default;\r\n$input-btn-line-height-sm: $line-height-sm !default;\r\n\r\n$input-btn-padding-y-lg: .5rem !default;\r\n$input-btn-padding-x-lg: 1rem !default;\r\n$input-btn-line-height-lg: $line-height-lg !default;\r\n\r\n$input-btn-border-width: $border-width !default;\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n$btn-padding-y: $input-btn-padding-y !default;\r\n$btn-padding-x: $input-btn-padding-x !default;\r\n$btn-line-height: $input-btn-line-height !default;\r\n\r\n$btn-padding-y-sm: $input-btn-padding-y-sm !default;\r\n$btn-padding-x-sm: $input-btn-padding-x-sm !default;\r\n$btn-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$btn-padding-y-lg: $input-btn-padding-y-lg !default;\r\n$btn-padding-x-lg: $input-btn-padding-x-lg !default;\r\n$btn-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$btn-border-width: $input-btn-border-width !default;\r\n\r\n$btn-font-weight: $font-weight-normal !default;\r\n$btn-box-shadow: inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\r\n$btn-focus-width: $input-btn-focus-width !default;\r\n$btn-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n$btn-disabled-opacity: .65 !default;\r\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, .125) !default;\r\n\r\n$btn-link-disabled-color: $gray-600 !default;\r\n\r\n$btn-block-spacing-y: .5rem !default;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius: $border-radius !default;\r\n$btn-border-radius-lg: $border-radius-lg !default;\r\n$btn-border-radius-sm: $border-radius-sm !default;\r\n\r\n$btn-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n// Forms\r\n\r\n$input-padding-y: $input-btn-padding-y !default;\r\n$input-padding-x: $input-btn-padding-x !default;\r\n$input-line-height: $input-btn-line-height !default;\r\n\r\n$input-padding-y-sm: $input-btn-padding-y-sm !default;\r\n$input-padding-x-sm: $input-btn-padding-x-sm !default;\r\n$input-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$input-padding-y-lg: $input-btn-padding-y-lg !default;\r\n$input-padding-x-lg: $input-btn-padding-x-lg !default;\r\n$input-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$input-bg: $white !default;\r\n$input-disabled-bg: $gray-200 !default;\r\n\r\n$input-color: $gray-700 !default;\r\n$input-border-color: $gray-400 !default;\r\n$input-border-width: $input-btn-border-width !default;\r\n$input-box-shadow: inset 0 1px 1px rgba($black, .075) !default;\r\n\r\n$input-border-radius: $border-radius !default;\r\n$input-border-radius-lg: $border-radius-lg !default;\r\n$input-border-radius-sm: $border-radius-sm !default;\r\n\r\n$input-focus-bg: $input-bg !default;\r\n$input-focus-border-color: lighten($component-active-bg, 25%) !default;\r\n$input-focus-color: $input-color !default;\r\n$input-focus-width: $input-btn-focus-width !default;\r\n$input-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$input-placeholder-color: $gray-600 !default;\r\n\r\n$input-height-border: $input-border-width * 2 !default;\r\n\r\n$input-height-inner: ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\r\n$input-height: calc(#{$input-height-inner} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-sm: ($font-size-sm * $input-btn-line-height-sm) + ($input-btn-padding-y-sm * 2) !default;\r\n$input-height-sm: calc(#{$input-height-inner-sm} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-lg: ($font-size-lg * $input-btn-line-height-lg) + ($input-btn-padding-y-lg * 2) !default;\r\n$input-height-lg: calc(#{$input-height-inner-lg} + #{$input-height-border}) !default;\r\n\r\n$input-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n$form-text-margin-top: .25rem !default;\r\n\r\n$form-check-input-gutter: 1.25rem !default;\r\n$form-check-input-margin-y: .3rem !default;\r\n$form-check-input-margin-x: .25rem !default;\r\n\r\n$form-check-inline-margin-x: .75rem !default;\r\n$form-check-inline-input-margin-x: .3125rem !default;\r\n\r\n$form-group-margin-bottom: 1rem !default;\r\n\r\n$input-group-addon-color: $input-color !default;\r\n$input-group-addon-bg: $gray-200 !default;\r\n$input-group-addon-border-color: $input-border-color !default;\r\n\r\n$custom-control-gutter: 1.5rem !default;\r\n$custom-control-spacer-x: 1rem !default;\r\n\r\n$custom-control-indicator-size: 1rem !default;\r\n$custom-control-indicator-bg: $gray-300 !default;\r\n$custom-control-indicator-bg-size: 50% 50% !default;\r\n$custom-control-indicator-box-shadow: inset 0 .25rem .25rem rgba($black, .1) !default;\r\n\r\n$custom-control-indicator-disabled-bg: $gray-200 !default;\r\n$custom-control-label-disabled-color: $gray-600 !default;\r\n\r\n$custom-control-indicator-checked-color: $component-active-color !default;\r\n$custom-control-indicator-checked-bg: $component-active-bg !default;\r\n$custom-control-indicator-checked-disabled-bg: rgba(theme-color(\"primary\"), .5) !default;\r\n$custom-control-indicator-checked-box-shadow: none !default;\r\n\r\n$custom-control-indicator-focus-box-shadow: 0 0 0 1px $body-bg, $input-btn-focus-box-shadow !default;\r\n\r\n$custom-control-indicator-active-color: $component-active-color !default;\r\n$custom-control-indicator-active-bg: lighten($component-active-bg, 35%) !default;\r\n$custom-control-indicator-active-box-shadow: none !default;\r\n\r\n$custom-checkbox-indicator-border-radius: $border-radius !default;\r\n$custom-checkbox-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-checkbox-indicator-indeterminate-bg: $component-active-bg !default;\r\n$custom-checkbox-indicator-indeterminate-color: $custom-control-indicator-checked-color !default;\r\n$custom-checkbox-indicator-icon-indeterminate: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-checkbox-indicator-indeterminate-box-shadow: none !default;\r\n\r\n$custom-radio-indicator-border-radius: 50% !default;\r\n$custom-radio-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='#{$custom-control-indicator-checked-color}'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-select-padding-y: .375rem !default;\r\n$custom-select-padding-x: .75rem !default;\r\n$custom-select-height: $input-height !default;\r\n$custom-select-indicator-padding: 1rem !default; // Extra padding to account for the presence of the background-image based indicator\r\n$custom-select-line-height: $input-btn-line-height !default;\r\n$custom-select-color: $input-color !default;\r\n$custom-select-disabled-color: $gray-600 !default;\r\n$custom-select-bg: $white !default;\r\n$custom-select-disabled-bg: $gray-200 !default;\r\n$custom-select-bg-size: 8px 10px !default; // In pixels because image dimensions\r\n$custom-select-indicator-color: $gray-800 !default;\r\n$custom-select-indicator: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-select-border-width: $input-btn-border-width !default;\r\n$custom-select-border-color: $input-border-color !default;\r\n$custom-select-border-radius: $border-radius !default;\r\n\r\n$custom-select-focus-border-color: $input-focus-border-color !default;\r\n$custom-select-focus-box-shadow: inset 0 1px 2px rgba($black, .075), 0 0 5px rgba($custom-select-focus-border-color, .5) !default;\r\n\r\n$custom-select-font-size-sm: 75% !default;\r\n$custom-select-height-sm: $input-height-sm !default;\r\n\r\n$custom-select-font-size-lg: 125% !default;\r\n$custom-select-height-lg: $input-height-lg !default;\r\n\r\n$custom-file-height: $input-height !default;\r\n$custom-file-focus-border-color: $input-focus-border-color !default;\r\n$custom-file-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$custom-file-padding-y: $input-btn-padding-y !default;\r\n$custom-file-padding-x: $input-btn-padding-x !default;\r\n$custom-file-line-height: $input-btn-line-height !default;\r\n$custom-file-color: $input-color !default;\r\n$custom-file-bg: $input-bg !default;\r\n$custom-file-border-width: $input-btn-border-width !default;\r\n$custom-file-border-color: $input-border-color !default;\r\n$custom-file-border-radius: $input-border-radius !default;\r\n$custom-file-box-shadow: $input-box-shadow !default;\r\n$custom-file-button-color: $custom-file-color !default;\r\n$custom-file-button-bg: $input-group-addon-bg !default;\r\n$custom-file-text: (\r\n        en: \"Browse\"\r\n) !default;\r\n\r\n// Form validation\r\n$form-feedback-margin-top: $form-text-margin-top !default;\r\n$form-feedback-font-size: $small-font-size !default;\r\n$form-feedback-valid-color: theme-color(\"success\") !default;\r\n$form-feedback-invalid-color: theme-color(\"danger\") !default;\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n$dropdown-min-width: 10rem !default;\r\n$dropdown-padding-y: .5rem !default;\r\n$dropdown-spacer: .125rem !default;\r\n$dropdown-bg: $white !default;\r\n$dropdown-border-color: rgba($black, .15) !default;\r\n$dropdown-border-radius: $border-radius !default;\r\n$dropdown-border-width: $border-width !default;\r\n$dropdown-divider-bg: $gray-200 !default;\r\n$dropdown-box-shadow: 0 .5rem 1rem rgba($black, .175) !default;\r\n\r\n$dropdown-link-color: $gray-900 !default;\r\n$dropdown-link-hover-color: darken($gray-900, 5%) !default;\r\n$dropdown-link-hover-bg: $gray-100 !default;\r\n\r\n$dropdown-link-active-color: $component-active-color !default;\r\n$dropdown-link-active-bg: $component-active-bg !default;\r\n\r\n$dropdown-link-disabled-color: $gray-600 !default;\r\n\r\n$dropdown-item-padding-y: .25rem !default;\r\n$dropdown-item-padding-x: 1.5rem !default;\r\n\r\n$dropdown-header-color: $gray-600 !default;\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n$zindex-dropdown: 1000 !default;\r\n$zindex-sticky: 1020 !default;\r\n$zindex-fixed: 1030 !default;\r\n$zindex-modal-backdrop: 1040 !default;\r\n$zindex-modal: 1050 !default;\r\n$zindex-popover: 1060 !default;\r\n$zindex-tooltip: 1070 !default;\r\n\r\n// Navs\r\n\r\n$nav-link-padding-y: .5rem !default;\r\n$nav-link-padding-x: 1rem !default;\r\n$nav-link-disabled-color: $gray-600 !default;\r\n\r\n$nav-tabs-border-color: $gray-300 !default;\r\n$nav-tabs-border-width: $border-width !default;\r\n$nav-tabs-border-radius: $border-radius !default;\r\n$nav-tabs-link-hover-border-color: $gray-200 $gray-200 $nav-tabs-border-color !default;\r\n$nav-tabs-link-active-color: $gray-700 !default;\r\n$nav-tabs-link-active-bg: $body-bg !default;\r\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\r\n\r\n$nav-pills-border-radius: $border-radius !default;\r\n$nav-pills-link-active-color: $component-active-color !default;\r\n$nav-pills-link-active-bg: $component-active-bg !default;\r\n\r\n// Navbar\r\n\r\n$navbar-padding-y: ($spacer / 2) !default;\r\n$navbar-padding-x: $spacer !default;\r\n\r\n$navbar-nav-link-padding-x: .5rem !default;\r\n\r\n$navbar-brand-font-size: $font-size-lg !default;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height: ($font-size-base * $line-height-base + $nav-link-padding-y * 2) !default;\r\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base !default;\r\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) / 2 !default;\r\n\r\n$navbar-toggler-padding-y: .25rem !default;\r\n$navbar-toggler-padding-x: .75rem !default;\r\n$navbar-toggler-font-size: $font-size-lg !default;\r\n$navbar-toggler-border-radius: $btn-border-radius !default;\r\n\r\n$navbar-dark-color: rgba($white, .5) !default;\r\n$navbar-dark-hover-color: rgba($white, .75) !default;\r\n$navbar-dark-active-color: $white !default;\r\n$navbar-dark-disabled-color: rgba($white, .25) !default;\r\n$navbar-dark-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-dark-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-dark-toggler-border-color: rgba($white, .1) !default;\r\n\r\n$navbar-light-color: rgba($black, .5) !default;\r\n$navbar-light-hover-color: rgba($black, .7) !default;\r\n$navbar-light-active-color: rgba($black, .9) !default;\r\n$navbar-light-disabled-color: rgba($black, .3) !default;\r\n$navbar-light-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\r\n\r\n// Pagination\r\n\r\n$pagination-padding-y: .5rem !default;\r\n$pagination-padding-x: .75rem !default;\r\n$pagination-padding-y-sm: .25rem !default;\r\n$pagination-padding-x-sm: .5rem !default;\r\n$pagination-padding-y-lg: .75rem !default;\r\n$pagination-padding-x-lg: 1.5rem !default;\r\n$pagination-line-height: 1.25 !default;\r\n\r\n$pagination-color: $link-color !default;\r\n$pagination-bg: $white !default;\r\n$pagination-border-width: $border-width !default;\r\n$pagination-border-color: $gray-300 !default;\r\n\r\n$pagination-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$pagination-hover-color: $link-hover-color !default;\r\n$pagination-hover-bg: $gray-200 !default;\r\n$pagination-hover-border-color: $gray-300 !default;\r\n\r\n$pagination-active-color: $component-active-color !default;\r\n$pagination-active-bg: $component-active-bg !default;\r\n$pagination-active-border-color: $pagination-active-bg !default;\r\n\r\n$pagination-disabled-color: $gray-600 !default;\r\n$pagination-disabled-bg: $white !default;\r\n$pagination-disabled-border-color: $gray-300 !default;\r\n\r\n// Jumbotron\r\n\r\n$jumbotron-padding: 2rem !default;\r\n$jumbotron-bg: $gray-200 !default;\r\n\r\n// Cards\r\n\r\n$card-spacer-y: .75rem !default;\r\n$card-spacer-x: 1.25rem !default;\r\n$card-border-width: $border-width !default;\r\n$card-border-radius: $border-radius !default;\r\n$card-border-color: rgba($black, .125) !default;\r\n$card-inner-border-radius: calc(#{$card-border-radius} - #{$card-border-width}) !default;\r\n$card-cap-bg: rgba($black, .03) !default;\r\n$card-bg: $white !default;\r\n\r\n$card-img-overlay-padding: 1.25rem !default;\r\n\r\n$card-group-margin: ($grid-gutter-width / 2) !default;\r\n$card-deck-margin: $card-group-margin !default;\r\n\r\n$card-columns-count: 3 !default;\r\n$card-columns-gap: 1.25rem !default;\r\n$card-columns-margin: $card-spacer-y !default;\r\n\r\n// Tooltips\r\n\r\n$tooltip-font-size: $font-size-sm !default;\r\n$tooltip-max-width: 200px !default;\r\n$tooltip-color: $white !default;\r\n$tooltip-bg: $black !default;\r\n$tooltip-border-radius: $border-radius !default;\r\n$tooltip-opacity: .9 !default;\r\n$tooltip-padding-y: .25rem !default;\r\n$tooltip-padding-x: .5rem !default;\r\n$tooltip-margin: 0 !default;\r\n\r\n$tooltip-arrow-width: .8rem !default;\r\n$tooltip-arrow-height: .4rem !default;\r\n$tooltip-arrow-color: $tooltip-bg !default;\r\n\r\n// Popovers\r\n\r\n$popover-font-size: $font-size-sm !default;\r\n$popover-bg: $white !default;\r\n$popover-max-width: 276px !default;\r\n$popover-border-width: $border-width !default;\r\n$popover-border-color: rgba($black, .2) !default;\r\n$popover-border-radius: $border-radius-lg !default;\r\n$popover-box-shadow: 0 .25rem .5rem rgba($black, .2) !default;\r\n\r\n$popover-header-bg: darken($popover-bg, 3%) !default;\r\n$popover-header-color: $headings-color !default;\r\n$popover-header-padding-y: .5rem !default;\r\n$popover-header-padding-x: .75rem !default;\r\n\r\n$popover-body-color: $body-color !default;\r\n$popover-body-padding-y: $popover-header-padding-y !default;\r\n$popover-body-padding-x: $popover-header-padding-x !default;\r\n\r\n$popover-arrow-width: 1rem !default;\r\n$popover-arrow-height: .5rem !default;\r\n$popover-arrow-color: $popover-bg !default;\r\n\r\n$popover-arrow-outer-color: fade-in($popover-border-color, .05) !default;\r\n\r\n// Badges\r\n\r\n$badge-font-size: 75% !default;\r\n$badge-font-weight: $font-weight-bold !default;\r\n$badge-padding-y: .25em !default;\r\n$badge-padding-x: .4em !default;\r\n$badge-border-radius: $border-radius !default;\r\n\r\n$badge-pill-padding-x: .6em !default;\r\n// Use a higher than normal value to ensure completely rounded edges when\r\n// customizing padding or font-size on labels.\r\n$badge-pill-border-radius: 10rem !default;\r\n\r\n// Modals\r\n\r\n// Padding applied to the modal body\r\n$modal-inner-padding: 1rem !default;\r\n\r\n$modal-dialog-margin: .5rem !default;\r\n$modal-dialog-margin-y-sm-up: 1.75rem !default;\r\n\r\n$modal-title-line-height: $line-height-base !default;\r\n\r\n$modal-content-bg: $white !default;\r\n$modal-content-border-color: rgba($black, .2) !default;\r\n$modal-content-border-width: $border-width !default;\r\n$modal-content-box-shadow-xs: 0 .25rem .5rem rgba($black, .5) !default;\r\n$modal-content-box-shadow-sm-up: 0 .5rem 1rem rgba($black, .5) !default;\r\n\r\n$modal-backdrop-bg: $black !default;\r\n$modal-backdrop-opacity: .5 !default;\r\n$modal-header-border-color: $gray-200 !default;\r\n$modal-footer-border-color: $modal-header-border-color !default;\r\n$modal-header-border-width: $modal-content-border-width !default;\r\n$modal-footer-border-width: $modal-header-border-width !default;\r\n$modal-header-padding: 1rem !default;\r\n\r\n$modal-lg: 800px !default;\r\n$modal-md: 500px !default;\r\n$modal-sm: 300px !default;\r\n\r\n$modal-transition: transform .3s ease-out !default;\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n$alert-padding-y: .75rem !default;\r\n$alert-padding-x: 1.25rem !default;\r\n$alert-margin-bottom: 1rem !default;\r\n$alert-border-radius: $border-radius !default;\r\n$alert-link-font-weight: $font-weight-bold !default;\r\n$alert-border-width: $border-width !default;\r\n\r\n$alert-bg-level: -10 !default;\r\n$alert-border-level: -9 !default;\r\n$alert-color-level: 6 !default;\r\n\r\n// Progress bars\r\n\r\n$progress-height: 1rem !default;\r\n$progress-font-size: ($font-size-base * .75) !default;\r\n$progress-bg: $gray-200 !default;\r\n$progress-border-radius: $border-radius !default;\r\n$progress-box-shadow: inset 0 .1rem .1rem rgba($black, .1) !default;\r\n$progress-bar-color: $white !default;\r\n$progress-bar-bg: theme-color(\"primary\") !default;\r\n$progress-bar-animation-timing: 1s linear infinite !default;\r\n$progress-bar-transition: width .6s ease !default;\r\n\r\n// List group\r\n\r\n$list-group-bg: $white !default;\r\n$list-group-border-color: rgba($black, .125) !default;\r\n$list-group-border-width: $border-width !default;\r\n$list-group-border-radius: $border-radius !default;\r\n\r\n$list-group-item-padding-y: .75rem !default;\r\n$list-group-item-padding-x: 1.25rem !default;\r\n\r\n$list-group-hover-bg: $gray-100 !default;\r\n$list-group-active-color: $component-active-color !default;\r\n$list-group-active-bg: $component-active-bg !default;\r\n$list-group-active-border-color: $list-group-active-bg !default;\r\n\r\n$list-group-disabled-color: $gray-600 !default;\r\n$list-group-disabled-bg: $list-group-bg !default;\r\n\r\n$list-group-action-color: $gray-700 !default;\r\n$list-group-action-hover-color: $list-group-action-color !default;\r\n\r\n$list-group-action-active-color: $body-color !default;\r\n$list-group-action-active-bg: $gray-200 !default;\r\n\r\n// Image thumbnails\r\n\r\n$thumbnail-padding: .25rem !default;\r\n$thumbnail-bg: $body-bg !default;\r\n$thumbnail-border-width: $border-width !default;\r\n$thumbnail-border-color: $gray-300 !default;\r\n$thumbnail-border-radius: $border-radius !default;\r\n$thumbnail-box-shadow: 0 1px 2px rgba($black, .075) !default;\r\n\r\n// Figures\r\n\r\n$figure-caption-font-size: 90% !default;\r\n$figure-caption-color: $gray-600 !default;\r\n\r\n// Breadcrumbs\r\n\r\n$breadcrumb-padding-y: .75rem !default;\r\n$breadcrumb-padding-x: 1rem !default;\r\n$breadcrumb-item-padding: .5rem !default;\r\n\r\n$breadcrumb-margin-bottom: 1rem !default;\r\n\r\n$breadcrumb-bg: $gray-200 !default;\r\n$breadcrumb-divider-color: $gray-600 !default;\r\n$breadcrumb-active-color: $gray-600 !default;\r\n$breadcrumb-divider: \"/\" !default;\r\n\r\n// Carousel\r\n\r\n$carousel-control-color: $white !default;\r\n$carousel-control-width: 15% !default;\r\n$carousel-control-opacity: .5 !default;\r\n\r\n$carousel-indicator-width: 30px !default;\r\n$carousel-indicator-height: 3px !default;\r\n$carousel-indicator-spacer: 3px !default;\r\n$carousel-indicator-active-bg: $white !default;\r\n\r\n$carousel-caption-width: 70% !default;\r\n$carousel-caption-color: $white !default;\r\n\r\n$carousel-control-icon-width: 20px !default;\r\n\r\n$carousel-control-prev-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$carousel-control-next-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$carousel-transition: transform .6s ease !default;\r\n\r\n// Close\r\n\r\n$close-font-size: $font-size-base * 1.5 !default;\r\n$close-font-weight: $font-weight-bold !default;\r\n//$close-color: $black !default;\r\n//$close-text-shadow: 0 1px 0 $white !default;\r\n\r\n// Code\r\n\r\n$code-font-size: 87.5% !default;\r\n$code-color: $pink !default;\r\n\r\n$kbd-padding-y: .2rem !default;\r\n$kbd-padding-x: .4rem !default;\r\n$kbd-font-size: $code-font-size !default;\r\n$kbd-color: $white !default;\r\n$kbd-bg: $gray-900 !default;\r\n\r\n$pre-color: $gray-900 !default;\r\n$pre-scrollable-max-height: 340px !default;\r\n\r\n// Printing\r\n$print-page-size: a3 !default;\r\n$print-body-min-width: map-get($grid-breakpoints, \"lg\") !default;\r\n","// stylelint-disable indentation\r\n\r\n// Hover mixin and `$enable-hover-media-query` are deprecated.\r\n//\r\n// Origally added during our alphas and maintained during betas, this mixin was\r\n// designed to prevent `:hover` stickiness on iOS—an issue where hover styles\r\n// would persist after initial touch.\r\n//\r\n// For backward compatibility, we've kept these mixins and updated them to\r\n// always return their regular psuedo-classes instead of a shimmed media query.\r\n//\r\n// Issue: https://github.com/twbs/bootstrap/issues/25195\r\n\r\n@mixin hover {\r\n  &:hover {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin hover-focus {\r\n  &:hover,\r\n  &:focus {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin plain-hover-focus {\r\n  &,\r\n  &:hover,\r\n  &:focus {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin hover-focus-active {\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    @content;\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important, selector-list-comma-newline-after\r\n\r\n//\r\n// Headings\r\n//\r\n\r\nh1, h2, h3, h4, h5, h6,\r\n.h1, .h2, .h3, .h4, .h5, .h6 {\r\n  margin-bottom: $headings-margin-bottom;\r\n  font-family: $headings-font-family;\r\n  font-weight: $headings-font-weight;\r\n  line-height: $headings-line-height;\r\n  color: $headings-color;\r\n}\r\n\r\nh1, .h1 {\r\n  font-size: $h1-font-size;\r\n}\r\n\r\nh2, .h2 {\r\n  font-size: $h2-font-size;\r\n}\r\n\r\nh3, .h3 {\r\n  font-size: $h3-font-size;\r\n}\r\n\r\nh4, .h4 {\r\n  font-size: $h4-font-size;\r\n}\r\n\r\nh5, .h5 {\r\n  font-size: $h5-font-size;\r\n}\r\n\r\nh6, .h6 {\r\n  font-size: $h6-font-size;\r\n}\r\n\r\n.lead {\r\n  font-size: $lead-font-size;\r\n  font-weight: $lead-font-weight;\r\n}\r\n\r\n// Type display classes\r\n.display-1 {\r\n  font-size: $display1-size;\r\n  font-weight: $display1-weight;\r\n  line-height: $display-line-height;\r\n}\r\n\r\n.display-2 {\r\n  font-size: $display2-size;\r\n  font-weight: $display2-weight;\r\n  line-height: $display-line-height;\r\n}\r\n\r\n.display-3 {\r\n  font-size: $display3-size;\r\n  font-weight: $display3-weight;\r\n  line-height: $display-line-height;\r\n}\r\n\r\n.display-4 {\r\n  font-size: $display4-size;\r\n  font-weight: $display4-weight;\r\n  line-height: $display-line-height;\r\n}\r\n\r\n//\r\n// Horizontal rules\r\n//\r\n\r\nhr {\r\n  margin-top: $hr-margin-y;\r\n  margin-bottom: $hr-margin-y;\r\n  border: 0;\r\n  border-top: $hr-border-width solid $hr-border-color;\r\n}\r\n\r\n//\r\n// Emphasis\r\n//\r\n\r\nsmall,\r\n.small {\r\n  font-size: $small-font-size;\r\n  font-weight: $font-weight-normal;\r\n}\r\n\r\nmark,\r\n.mark {\r\n  padding: $mark-padding;\r\n  background-color: $mark-bg;\r\n}\r\n\r\n//\r\n// Lists\r\n//\r\n\r\n.list-unstyled {\r\n  @include list-unstyled;\r\n}\r\n\r\n// Inline turns list items into inline-block\r\n.list-inline {\r\n  @include list-unstyled;\r\n}\r\n\r\n.list-inline-item {\r\n  display: inline-block;\r\n\r\n  &:not(:last-child) {\r\n    margin-right: $list-inline-padding;\r\n  }\r\n}\r\n\r\n//\r\n// Misc\r\n//\r\n\r\n// Builds on `abbr`\r\n.initialism {\r\n  font-size: 90%;\r\n  text-transform: uppercase;\r\n}\r\n\r\n// Blockquotes\r\n.blockquote {\r\n  margin-bottom: $spacer;\r\n  font-size: $blockquote-font-size;\r\n}\r\n\r\n.blockquote-footer {\r\n  display: block;\r\n  font-size: 80%; // back to default font-size\r\n  color: $blockquote-small-color;\r\n\r\n  &::before {\r\n    content: \"\\2014 \\00A0\"; // em dash, nbsp\r\n  }\r\n}\r\n","// Lists\r\n\r\n// Unstyled keeps list items block level, just removes default browser padding and list-style\r\n@mixin list-unstyled {\r\n  padding-left: 0;\r\n  list-style: none;\r\n}\r\n","// Responsive images (ensure images don't scale beyond their parents)\r\n//\r\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\r\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\r\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\r\n// which weren't expecting the images within themselves to be involuntarily resized.\r\n// See also https://github.com/twbs/bootstrap/issues/18178\r\n.img-fluid {\r\n  @include img-fluid;\r\n}\r\n\r\n// Image thumbnails\r\n.img-thumbnail {\r\n  padding: $thumbnail-padding;\r\n  background-color: $thumbnail-bg;\r\n  border: $thumbnail-border-width solid $thumbnail-border-color;\r\n  @include border-radius($thumbnail-border-radius);\r\n  @include box-shadow($thumbnail-box-shadow);\r\n\r\n  // Keep them at most 100% wide\r\n  @include img-fluid;\r\n}\r\n\r\n//\r\n// Figures\r\n//\r\n\r\n.figure {\r\n  // Ensures the caption's text aligns with the image.\r\n  display: inline-block;\r\n}\r\n\r\n.figure-img {\r\n  margin-bottom: ($spacer / 2);\r\n  line-height: 1;\r\n}\r\n\r\n.figure-caption {\r\n  font-size: $figure-caption-font-size;\r\n  color: $figure-caption-color;\r\n}\r\n","// Image Mixins\r\n// - Responsive image\r\n// - Retina image\r\n\r\n// Responsive image\r\n//\r\n// Keep images from scaling beyond the width of their parents.\r\n\r\n@mixin img-fluid {\r\n  // Part 1: Set a maximum relative to the parent\r\n  max-width: 100%;\r\n  // Part 2: Override the height to auto, otherwise images will be stretched\r\n  // when setting a width and height attribute on the img element.\r\n  height: auto;\r\n}\r\n\r\n// Retina image\r\n//\r\n// Short retina mixin for setting background-image and -size.\r\n\r\n// stylelint-disable indentation, media-query-list-comma-newline-after\r\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\r\n  background-image: url($file-1x);\r\n\r\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\r\n  // but doesn't convert dppx=>dpi.\r\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\r\n  // Compatibility info: https://caniuse.com/#feat=css-media-resolution\r\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\r\n  only screen and (min-resolution: 2dppx) { // Standardized\r\n    background-image: url($file-2x);\r\n    background-size: $width-1x $height-1x;\r\n  }\r\n}\r\n","// Single side border-radius\r\n\r\n@mixin border-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-top-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-top-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-right-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-right-radius: $radius;\r\n    border-bottom-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-bottom-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-bottom-right-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-left-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n","@mixin box-shadow($shadow...) {\r\n  @if $enable-shadows {\r\n    box-shadow: $shadow;\r\n  }\r\n}\r\n","// Inline and block code styles\r\ncode,\r\nkbd,\r\npre,\r\nsamp {\r\n  font-family: $font-family-monospace;\r\n}\r\n\r\n// Inline code\r\ncode {\r\n  font-size: $code-font-size;\r\n  color: $code-color;\r\n  word-break: break-word;\r\n\r\n  // Streamline the style when inside anchors to avoid broken underline and more\r\n  a > & {\r\n    color: inherit;\r\n  }\r\n}\r\n\r\n// User input typically entered via keyboard\r\nkbd {\r\n  padding: $kbd-padding-y $kbd-padding-x;\r\n  font-size: $kbd-font-size;\r\n  color: $kbd-color;\r\n  background-color: $kbd-bg;\r\n  @include border-radius($border-radius-sm);\r\n  @include box-shadow($kbd-box-shadow);\r\n\r\n  kbd {\r\n    padding: 0;\r\n    font-size: 100%;\r\n    font-weight: $nested-kbd-font-weight;\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n// Blocks of code\r\npre {\r\n  display: block;\r\n  font-size: $code-font-size;\r\n  color: $pre-color;\r\n\r\n  // Account for some code outputs that place code tags in pre tags\r\n  code {\r\n    font-size: inherit;\r\n    color: inherit;\r\n    word-break: normal;\r\n  }\r\n}\r\n\r\n// Enable scrollable blocks of code\r\n.pre-scrollable {\r\n  max-height: $pre-scrollable-max-height;\r\n  overflow-y: scroll;\r\n}\r\n","// Container widths\r\n//\r\n// Set the container width, and override it for fixed navbars in media queries.\r\n\r\n@if $enable-grid-classes {\r\n  .container {\r\n    @include make-container();\r\n    @include make-container-max-widths();\r\n  }\r\n}\r\n\r\n// Fluid container\r\n//\r\n// Utilizes the mixin meant for fixed width containers, but with 100% width for\r\n// fluid, full width layouts.\r\n\r\n@if $enable-grid-classes {\r\n  .container-fluid {\r\n    @include make-container();\r\n  }\r\n}\r\n\r\n// Row\r\n//\r\n// Rows contain and clear the floats of your columns.\r\n\r\n@if $enable-grid-classes {\r\n  .row {\r\n    @include make-row();\r\n  }\r\n\r\n  // Remove the negative margin from default .row, then the horizontal padding\r\n  // from all immediate children columns (to prevent runaway style inheritance).\r\n  .no-gutters {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n\r\n    > .col,\r\n    > [class*=\"col-\"] {\r\n      padding-right: 0;\r\n      padding-left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Columns\r\n//\r\n// Common styles for small and large grid columns\r\n\r\n@if $enable-grid-classes {\r\n  @include make-grid-columns();\r\n}\r\n","/// Grid system\r\n//\r\n// Generate semantic grid columns with these mixins.\r\n\r\n@mixin make-container() {\r\n  width: 100%;\r\n  padding-right: ($grid-gutter-width / 2);\r\n  padding-left: ($grid-gutter-width / 2);\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n// For each breakpoint, define the maximum width of the container in a media query\r\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\r\n  @each $breakpoint, $container-max-width in $max-widths {\r\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\r\n      max-width: $container-max-width;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin make-row() {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: ($grid-gutter-width / -2);\r\n  margin-left: ($grid-gutter-width / -2);\r\n}\r\n\r\n@mixin make-col-ready() {\r\n  position: relative;\r\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\r\n  // always setting `width: 100%;`. This works because we use `flex` values\r\n  // later on to override this initial width.\r\n  width: 100%;\r\n  min-height: 1px; // Prevent collapsing\r\n  padding-right: ($grid-gutter-width / 2);\r\n  padding-left: ($grid-gutter-width / 2);\r\n}\r\n\r\n@mixin make-col($size, $columns: $grid-columns) {\r\n  flex: 0 0 percentage($size / $columns);\r\n  // Add a `max-width` to ensure content within each column does not blow out\r\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\r\n  // do not appear to require this.\r\n  max-width: percentage($size / $columns);\r\n}\r\n\r\n@mixin make-col-offset($size, $columns: $grid-columns) {\r\n  $num: $size / $columns;\r\n  margin-left: if($num == 0, 0, percentage($num));\r\n}\r\n","// Breakpoint viewport sizes and media queries.\r\n//\r\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\r\n//\r\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\r\n//\r\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\r\n\r\n// Name of the next breakpoint, or null for the last breakpoint.\r\n//\r\n//    >> breakpoint-next(sm)\r\n//    md\r\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    md\r\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\r\n//    md\r\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\r\n  $n: index($breakpoint-names, $name);\r\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\r\n}\r\n\r\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\r\n//\r\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    576px\r\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\r\n  $min: map-get($breakpoints, $name);\r\n  @return if($min != 0, $min, null);\r\n}\r\n\r\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\r\n// The maximum value is calculated as the minimum of the next one less 0.02px\r\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\r\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\r\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\r\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\r\n//\r\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    767.98px\r\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\r\n  $next: breakpoint-next($name, $breakpoints);\r\n  @return if($next, breakpoint-min($next, $breakpoints) - .02px, null);\r\n}\r\n\r\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash infront.\r\n// Useful for making responsive utilities.\r\n//\r\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"\"  (Returns a blank string)\r\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"-sm\"\r\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\r\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\r\n}\r\n\r\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\r\n// Makes the @content apply to the given breakpoint and wider.\r\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($name, $breakpoints);\r\n  @if $min {\r\n    @media (min-width: $min) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\r\n// Makes the @content apply to the given breakpoint and narrower.\r\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\r\n  $max: breakpoint-max($name, $breakpoints);\r\n  @if $max {\r\n    @media (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Media that spans multiple breakpoint widths.\r\n// Makes the @content apply between the min and max breakpoints\r\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($lower, $breakpoints);\r\n  $max: breakpoint-max($upper, $breakpoints);\r\n\r\n  @if $min != null and $max != null {\r\n    @media (min-width: $min) and (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else if $max == null {\r\n    @include media-breakpoint-up($lower, $breakpoints) {\r\n      @content;\r\n    }\r\n  } @else if $min == null {\r\n    @include media-breakpoint-down($upper, $breakpoints) {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n// Media between the breakpoint's minimum and maximum widths.\r\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\r\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\r\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($name, $breakpoints);\r\n  $max: breakpoint-max($name, $breakpoints);\r\n\r\n  @if $min != null and $max != null {\r\n    @media (min-width: $min) and (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else if $max == null {\r\n    @include media-breakpoint-up($name, $breakpoints) {\r\n      @content;\r\n    }\r\n  } @else if $min == null {\r\n    @include media-breakpoint-down($name, $breakpoints) {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n","// Framework grid generation\r\n//\r\n// Used only by Bootstrap to generate the correct number of grid classes given\r\n// any value of `$grid-columns`.\r\n\r\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\r\n  // Common properties for all breakpoints\r\n  %grid-column {\r\n    position: relative;\r\n    width: 100%;\r\n    min-height: 1px; // Prevent columns from collapsing when empty\r\n    padding-right: ($gutter / 2);\r\n    padding-left: ($gutter / 2);\r\n  }\r\n\r\n  @each $breakpoint in map-keys($breakpoints) {\r\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\r\n\r\n    // Allow columns to stretch full width below their breakpoints\r\n    @for $i from 1 through $columns {\r\n      .col#{$infix}-#{$i} {\r\n        @extend %grid-column;\r\n      }\r\n    }\r\n    .col#{$infix},\r\n    .col#{$infix}-auto {\r\n      @extend %grid-column;\r\n    }\r\n\r\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\r\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\r\n      .col#{$infix} {\r\n        flex-basis: 0;\r\n        flex-grow: 1;\r\n        max-width: 100%;\r\n      }\r\n      .col#{$infix}-auto {\r\n        flex: 0 0 auto;\r\n        width: auto;\r\n        max-width: none; // Reset earlier grid tiers\r\n      }\r\n\r\n      @for $i from 1 through $columns {\r\n        .col#{$infix}-#{$i} {\r\n          @include make-col($i, $columns);\r\n        }\r\n      }\r\n\r\n      .order#{$infix}-first {\r\n        order: -1;\r\n      }\r\n\r\n      .order#{$infix}-last {\r\n        order: $columns + 1;\r\n      }\r\n\r\n      @for $i from 0 through $columns {\r\n        .order#{$infix}-#{$i} {\r\n          order: $i;\r\n        }\r\n      }\r\n\r\n      // `$columns - 1` because offsetting by the width of an entire row isn't possible\r\n      @for $i from 0 through ($columns - 1) {\r\n        @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\r\n          .offset#{$infix}-#{$i} {\r\n            @include make-col-offset($i, $columns);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// Basic Bootstrap table\r\n//\r\n\r\n.table {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  margin-bottom: $spacer;\r\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\r\n\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding;\r\n    vertical-align: top;\r\n    border-top: $table-border-width solid $table-border-color;\r\n  }\r\n\r\n  thead th {\r\n    vertical-align: bottom;\r\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\r\n  }\r\n\r\n  tbody + tbody {\r\n    border-top: (2 * $table-border-width) solid $table-border-color;\r\n  }\r\n\r\n  .table {\r\n    background-color: $body-bg;\r\n  }\r\n}\r\n\r\n//\r\n// Condensed table w/ half padding\r\n//\r\n\r\n.table-sm {\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding-sm;\r\n  }\r\n}\r\n\r\n// Bordered version\r\n//\r\n// Add borders all around the table and between all the columns.\r\n\r\n.table-bordered {\r\n  border: $table-border-width solid $table-border-color;\r\n\r\n  th,\r\n  td {\r\n    border: $table-border-width solid $table-border-color;\r\n  }\r\n\r\n  thead {\r\n    th,\r\n    td {\r\n      border-bottom-width: (2 * $table-border-width);\r\n    }\r\n  }\r\n}\r\n\r\n// Zebra-striping\r\n//\r\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\r\n\r\n.table-striped {\r\n  tbody tr:nth-of-type(odd) {\r\n    background-color: $table-accent-bg;\r\n  }\r\n}\r\n\r\n// Hover effect\r\n//\r\n// Placed here since it has to come after the potential zebra striping\r\n\r\n.table-hover {\r\n  tbody tr {\r\n    @include hover {\r\n      background-color: $table-hover-bg;\r\n    }\r\n  }\r\n}\r\n\r\n// Table backgrounds\r\n//\r\n// Exact selectors below required to override `.table-striped` and prevent\r\n// inheritance to nested tables.\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include table-row-variant($color, theme-color-level($color, -9));\r\n}\r\n\r\n@include table-row-variant(active, $table-active-bg);\r\n\r\n// Dark styles\r\n//\r\n// Same table markup, but inverted color scheme: dark background and light text.\r\n\r\n// stylelint-disable-next-line no-duplicate-selectors\r\n.table {\r\n  .thead-dark {\r\n    th {\r\n      color: $table-dark-color;\r\n      background-color: $table-dark-bg;\r\n      border-color: $table-dark-border-color;\r\n    }\r\n  }\r\n\r\n  .thead-light {\r\n    th {\r\n      color: $table-head-color;\r\n      background-color: $table-head-bg;\r\n      border-color: $table-border-color;\r\n    }\r\n  }\r\n}\r\n\r\n.table-dark {\r\n  color: $table-dark-color;\r\n  background-color: $table-dark-bg;\r\n\r\n  th,\r\n  td,\r\n  thead th {\r\n    border-color: $table-dark-border-color;\r\n  }\r\n\r\n  &.table-bordered {\r\n    border: 0;\r\n  }\r\n\r\n  &.table-striped {\r\n    tbody tr:nth-of-type(odd) {\r\n      background-color: $table-dark-accent-bg;\r\n    }\r\n  }\r\n\r\n  &.table-hover {\r\n    tbody tr {\r\n      @include hover {\r\n        background-color: $table-dark-hover-bg;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive tables\r\n//\r\n// Generate series of `.table-responsive-*` classes for configuring the screen\r\n// size of where your table will overflow.\r\n\r\n.table-responsive {\r\n  @each $breakpoint in map-keys($grid-breakpoints) {\r\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\r\n    $infix: breakpoint-infix($next, $grid-breakpoints);\r\n\r\n    &#{$infix} {\r\n      @include media-breakpoint-down($breakpoint) {\r\n        display: block;\r\n        width: 100%;\r\n        overflow-x: auto;\r\n        -webkit-overflow-scrolling: touch;\r\n        -ms-overflow-style: -ms-autohiding-scrollbar; // See https://github.com/twbs/bootstrap/pull/10057\r\n\r\n        // Prevent double border on horizontal scroll due to use of `display: block;`\r\n        > .table-bordered {\r\n          border: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.table-middle td,\r\n.table-middle thead th {\r\n  vertical-align: middle;\r\n}\r\n","// Tables\r\n\r\n@mixin table-row-variant($state, $background) {\r\n  // Exact selectors below required to override `.table-striped` and prevent\r\n  // inheritance to nested tables.\r\n  .table-#{$state} {\r\n    &,\r\n    > th,\r\n    > td {\r\n      background-color: $background;\r\n    }\r\n  }\r\n\r\n  // Hover states for `.table-hover`\r\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\r\n  .table-hover {\r\n    $hover-background: darken($background, 5%);\r\n\r\n    .table-#{$state} {\r\n      @include hover {\r\n        background-color: $hover-background;\r\n\r\n        > td,\r\n        > th {\r\n          background-color: $hover-background;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Bootstrap functions\r\n//\r\n// Utility mixins and functions for evalutating source code across our variables, maps, and mixins.\r\n\r\n// Ascending\r\n// Used to evaluate Sass maps like our grid breakpoints.\r\n@mixin _assert-ascending($map, $map-name) {\r\n  $prev-key: null;\r\n  $prev-num: null;\r\n  @each $key, $num in $map {\r\n    @if $prev-num == null {\r\n      // Do nothing\r\n    } @else if not comparable($prev-num, $num) {\r\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\r\n    } @else if $prev-num >= $num {\r\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\r\n    }\r\n    $prev-key: $key;\r\n    $prev-num: $num;\r\n  }\r\n}\r\n\r\n// Starts at zero\r\n// Another grid mixin that ensures the min-width of the lowest breakpoint starts at 0.\r\n@mixin _assert-starts-at-zero($map) {\r\n  $values: map-values($map);\r\n  $first-value: nth($values, 1);\r\n  @if $first-value != 0 {\r\n    @warn \"First breakpoint in `$grid-breakpoints` must start at 0, but starts at #{$first-value}.\";\r\n  }\r\n}\r\n\r\n// Replace `$search` with `$replace` in `$string`\r\n// Used on our SVG icon backgrounds for custom forms.\r\n//\r\n// @author Hugo Giraudel\r\n// @param {String} $string - Initial string\r\n// @param {String} $search - Substring to replace\r\n// @param {String} $replace ('') - New value\r\n// @return {String} - Updated string\r\n@function str-replace($string, $search, $replace: \"\") {\r\n  $index: str-index($string, $search);\r\n\r\n  @if $index {\r\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\r\n  }\r\n\r\n  @return $string;\r\n}\r\n\r\n// Color contrast\r\n@function color-yiq($color) {\r\n  $r: red($color);\r\n  $g: green($color);\r\n  $b: blue($color);\r\n\r\n  $yiq: (($r * 299) + ($g * 587) + ($b * 114)) / 1000;\r\n\r\n  @if ($yiq >= $yiq-contrasted-threshold) {\r\n    @return $yiq-text-dark;\r\n  } @else {\r\n    @return $yiq-text-light;\r\n  }\r\n}\r\n\r\n// Retrieve color Sass maps\r\n@function color($key: \"blue\") {\r\n  @return map-get($colors, $key);\r\n}\r\n\r\n@function theme-color($key: \"primary\") {\r\n  @return map-get($theme-colors, $key);\r\n}\r\n\r\n@function gray($key: \"100\") {\r\n  @return map-get($grays, $key);\r\n}\r\n\r\n// Request a theme color level\r\n@function theme-color-level($color-name: \"primary\", $level: 0) {\r\n  $color: theme-color($color-name);\r\n  $color-base: if($level > 0, #000, #fff);\r\n  $level: abs($level);\r\n\r\n  @return mix($color-base, $color, $level * $theme-color-interval);\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n//\r\n// Textual form controls\r\n//\r\n\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  padding: $input-padding-y $input-padding-x;\r\n  font-size: $font-size-base;\r\n  line-height: $input-line-height;\r\n  color: $input-color;\r\n  background-color: $input-bg;\r\n  background-clip: padding-box;\r\n  border: $input-border-width solid $input-border-color;\r\n\r\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\r\n  @if $enable-rounded {\r\n    // Manually use the if/else instead of the mixin to account for iOS override\r\n    border-radius: $input-border-radius;\r\n  } @else {\r\n    // Otherwise undo the iOS default\r\n    border-radius: 0;\r\n  }\r\n\r\n  @include box-shadow($input-box-shadow);\r\n  @include transition($input-transition);\r\n\r\n  // Unstyle the caret on `<select>`s in IE10+.\r\n  &::-ms-expand {\r\n    background-color: transparent;\r\n    border: 0;\r\n  }\r\n\r\n  // Customize the `:focus` state to imitate native WebKit styles.\r\n  @include form-control-focus();\r\n\r\n  // Placeholder\r\n  &::placeholder {\r\n    color: $input-placeholder-color;\r\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\r\n    opacity: 1;\r\n  }\r\n\r\n  // Disabled and read-only inputs\r\n  //\r\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\r\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\r\n  // don't honor that edge case; we style them as disabled anyway.\r\n  &:disabled,\r\n  &[readonly] {\r\n    background-color: $input-disabled-bg;\r\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\nselect.form-control {\r\n  &:not([size]):not([multiple]) {\r\n    height: $input-height;\r\n  }\r\n\r\n  &:focus::-ms-value {\r\n    // Suppress the nested default white text on blue background highlight given to\r\n    // the selected option text when the (still closed) <select> receives focus\r\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\r\n    // match the appearance of the native widget.\r\n    // See https://github.com/twbs/bootstrap/issues/19398.\r\n    color: $input-color;\r\n    background-color: $input-bg;\r\n  }\r\n}\r\n\r\n// Make file inputs better match text inputs by forcing them to new lines.\r\n.form-control-file,\r\n.form-control-range {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n//\r\n// Labels\r\n//\r\n\r\n// For use with horizontal and inline forms, when you need the label (or legend)\r\n// text to align with the form controls.\r\n.col-form-label {\r\n  padding-top: calc(#{$input-padding-y} + #{$input-border-width});\r\n  padding-bottom: calc(#{$input-padding-y} + #{$input-border-width});\r\n  margin-bottom: 0; // Override the `<label>/<legend>` default\r\n  font-size: inherit; // Override the `<legend>` default\r\n  line-height: $input-line-height;\r\n}\r\n\r\n.col-form-label-lg {\r\n  padding-top: calc(#{$input-padding-y-lg} + #{$input-border-width});\r\n  padding-bottom: calc(#{$input-padding-y-lg} + #{$input-border-width});\r\n  font-size: $font-size-lg;\r\n  line-height: $input-line-height-lg;\r\n}\r\n\r\n.col-form-label-sm {\r\n  padding-top: calc(#{$input-padding-y-sm} + #{$input-border-width});\r\n  padding-bottom: calc(#{$input-padding-y-sm} + #{$input-border-width});\r\n  font-size: $font-size-sm;\r\n  line-height: $input-line-height-sm;\r\n}\r\n\r\n// Readonly controls as plain text\r\n//\r\n// Apply class to a readonly input to make it appear like regular plain\r\n// text (without any border, background color, focus indicator)\r\n\r\n.form-control-plaintext {\r\n  display: block;\r\n  width: 100%;\r\n  padding-top: $input-padding-y;\r\n  padding-bottom: $input-padding-y;\r\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\r\n  line-height: $input-line-height;\r\n  background-color: transparent;\r\n  border: solid transparent;\r\n  border-width: $input-border-width 0;\r\n\r\n  &.form-control-sm,\r\n  &.form-control-lg {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n// Form control sizing\r\n//\r\n// Build on `.form-control` with modifier classes to decrease or increase the\r\n// height and font-size of form controls.\r\n//\r\n// The `.form-group-* form-control` variations are sadly duplicated to avoid the\r\n// issue documented in https://github.com/twbs/bootstrap/issues/15074.\r\n\r\n.form-control-sm {\r\n  padding: $input-padding-y-sm $input-padding-x-sm;\r\n  font-size: $font-size-sm;\r\n  line-height: $input-line-height-sm;\r\n  @include border-radius($input-border-radius-sm);\r\n}\r\n\r\nselect.form-control-sm {\r\n  &:not([size]):not([multiple]) {\r\n    height: $input-height-sm;\r\n  }\r\n}\r\n\r\n.form-control-lg {\r\n  padding: $input-padding-y-lg $input-padding-x-lg;\r\n  font-size: $font-size-lg;\r\n  line-height: $input-line-height-lg;\r\n  @include border-radius($input-border-radius-lg);\r\n}\r\n\r\nselect.form-control-lg {\r\n  &:not([size]):not([multiple]) {\r\n    height: $input-height-lg;\r\n  }\r\n}\r\n\r\n// Form groups\r\n//\r\n// Designed to help with the organization and spacing of vertical forms. For\r\n// horizontal forms, use the predefined grid classes.\r\n\r\n.form-group {\r\n  margin-bottom: $form-group-margin-bottom;\r\n}\r\n\r\n.form-text {\r\n  display: block;\r\n  margin-top: $form-text-margin-top;\r\n}\r\n\r\n// Form grid\r\n//\r\n// Special replacement for our grid system's `.row` for tighter form layouts.\r\n\r\n.form-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: -5px;\r\n  margin-left: -5px;\r\n\r\n  > .col,\r\n  > [class*=\"col-\"] {\r\n    padding-right: 5px;\r\n    padding-left: 5px;\r\n  }\r\n}\r\n\r\n// Checkboxes and radios\r\n//\r\n// Indent the labels to position radios/checkboxes as hanging controls.\r\n\r\n.form-check {\r\n  position: relative;\r\n  display: block;\r\n  padding-left: $form-check-input-gutter;\r\n}\r\n\r\n.form-check-input {\r\n  position: absolute;\r\n  margin-top: $form-check-input-margin-y;\r\n  margin-left: -$form-check-input-gutter;\r\n\r\n  &:disabled ~ .form-check-label {\r\n    color: $text-muted;\r\n  }\r\n}\r\n\r\n.form-check-label {\r\n  margin-bottom: 0; // Override default `<label>` bottom margin\r\n}\r\n\r\n.form-check-inline {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding-left: 0; // Override base .form-check\r\n  margin-right: $form-check-inline-margin-x;\r\n\r\n  // Undo .form-check-input defaults and add some `margin-right`.\r\n  .form-check-input {\r\n    position: static;\r\n    margin-top: 0;\r\n    margin-right: $form-check-inline-input-margin-x;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n// Form validation\r\n//\r\n// Provide feedback to users when form field values are valid or invalid. Works\r\n// primarily for client-side validation via scoped `:invalid` and `:valid`\r\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\r\n// server side validation.\r\n\r\n@include form-validation-state(\"valid\", $form-feedback-valid-color);\r\n@include form-validation-state(\"invalid\", $form-feedback-invalid-color);\r\n\r\n// Inline forms\r\n//\r\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\r\n// forms begin stacked on extra small (mobile) devices and then go inline when\r\n// viewports reach <768px.\r\n//\r\n// Requires wrapping inputs and labels with `.form-group` for proper display of\r\n// default HTML form controls and our custom form controls (e.g., input groups).\r\n\r\n.form-inline {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\r\n\r\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\r\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\r\n  // so we force that here.\r\n  .form-check {\r\n    width: 100%;\r\n  }\r\n\r\n  // Kick in the inline\r\n  @include media-breakpoint-up(sm) {\r\n    label {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    // Inline-block all the things for \"inline\"\r\n    .form-group {\r\n      display: flex;\r\n      flex: 0 0 auto;\r\n      flex-flow: row wrap;\r\n      align-items: center;\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    // Allow folks to *not* use `.form-group`\r\n    .form-control {\r\n      display: inline-block;\r\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\r\n      vertical-align: middle;\r\n    }\r\n\r\n    // Make static controls behave like regular ones\r\n    .form-control-plaintext {\r\n      display: inline-block;\r\n    }\r\n\r\n    .input-group {\r\n      width: auto;\r\n    }\r\n\r\n    // Remove default margin on radios/checkboxes that were used for stacking, and\r\n    // then undo the floating of radios and checkboxes to match.\r\n    .form-check {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      width: auto;\r\n      padding-left: 0;\r\n    }\r\n    .form-check-input {\r\n      position: relative;\r\n      margin-top: 0;\r\n      margin-right: $form-check-input-margin-x;\r\n      margin-left: 0;\r\n    }\r\n\r\n    .custom-control {\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n    .custom-control-label {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n","@mixin transition($transition...) {\r\n  @if $enable-transitions {\r\n    @if length($transition) == 0 {\r\n      transition: $transition-base;\r\n    } @else {\r\n      transition: $transition;\r\n    }\r\n  }\r\n}\r\n","// Form control focus state\r\n//\r\n// Generate a customized focus state and for any input with the specified color,\r\n// which defaults to the `$input-focus-border-color` variable.\r\n//\r\n// We highly encourage you to not customize the default value, but instead use\r\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\r\n// WebKit's default styles, but applicable to a wider range of browsers. Its\r\n// usability and accessibility should be taken into account with any change.\r\n//\r\n// Example usage: change the default blue border and shadow to white for better\r\n// contrast against a dark gray background.\r\n@mixin form-control-focus() {\r\n  &:focus {\r\n    color: $input-focus-color;\r\n    background-color: $input-focus-bg;\r\n    border-color: $input-focus-border-color;\r\n    outline: 0;\r\n    // Avoid using mixin so we can pass custom focus shadow properly\r\n    @if $enable-shadows {\r\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\r\n    } @else {\r\n      box-shadow: $input-focus-box-shadow;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin form-validation-state($state, $color) {\r\n  .#{$state}-feedback {\r\n    display: none;\r\n    width: 100%;\r\n    margin-top: $form-feedback-margin-top;\r\n    font-size: $form-feedback-font-size;\r\n    color: $color;\r\n  }\r\n\r\n  .#{$state}-tooltip {\r\n    position: absolute;\r\n    top: 100%;\r\n    z-index: 5;\r\n    display: none;\r\n    max-width: 100%; // Contain to parent when possible\r\n    padding: .5rem;\r\n    margin-top: .1rem;\r\n    font-size: .875rem;\r\n    line-height: 1;\r\n    color: #fff;\r\n    background-color: rgba($color, .8);\r\n    border-radius: .2rem;\r\n  }\r\n\r\n  .form-control,\r\n  .custom-select {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      border-color: $color;\r\n\r\n      &:focus {\r\n        border-color: $color;\r\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-check-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .form-check-label {\r\n        color: $color;\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  .custom-control-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .custom-control-label {\r\n        color: $color;\r\n\r\n        &::before {\r\n          background-color: lighten($color, 25%);\r\n        }\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n\r\n      &:checked {\r\n        ~ .custom-control-label::before {\r\n          @include gradient-bg(lighten($color, 10%));\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        ~ .custom-control-label::before {\r\n          box-shadow: 0 0 0 1px $body-bg, 0 0 0 $input-focus-width rgba($color, .25);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // custom file\r\n  .custom-file-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .custom-file-label {\r\n        border-color: $color;\r\n\r\n        &::before {\r\n          border-color: inherit;\r\n        }\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n\r\n      &:focus {\r\n        ~ .custom-file-label {\r\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Gradients\r\n\r\n@mixin gradient-bg($color) {\r\n  @if $enable-gradients {\r\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\r\n  } @else {\r\n    background-color: $color;\r\n  }\r\n}\r\n\r\n// Horizontal gradient, from left to right\r\n//\r\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\r\n@mixin gradient-x($start-color: #555, $end-color: #333, $start-percent: 0%, $end-percent: 100%) {\r\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\r\n  background-repeat: repeat-x;\r\n}\r\n\r\n// Vertical gradient, from top to bottom\r\n//\r\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\r\n@mixin gradient-y($start-color: #555, $end-color: #333, $start-percent: 0%, $end-percent: 100%) {\r\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\r\n  background-repeat: repeat-x;\r\n}\r\n\r\n@mixin gradient-directional($start-color: #555, $end-color: #333, $deg: 45deg) {\r\n  background-image: linear-gradient($deg, $start-color, $end-color);\r\n  background-repeat: repeat-x;\r\n}\r\n\r\n@mixin gradient-x-three-colors($start-color: #00b3ee, $mid-color: #7a43b6, $color-stop: 50%, $end-color: #c3325f) {\r\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n@mixin gradient-y-three-colors($start-color: #00b3ee, $mid-color: #7a43b6, $color-stop: 50%, $end-color: #c3325f) {\r\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n@mixin gradient-radial($inner-color: #555, $outer-color: #333) {\r\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n@mixin gradient-striped($color: rgba(255,255,255,.15), $angle: 45deg) {\r\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n//\r\n// Base styles\r\n//\r\n\r\n.btn {\r\n  display: inline-block;\r\n  font-weight: $btn-font-weight;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n  user-select: none;\r\n  border: $btn-border-width solid transparent;\r\n  @include button-size($btn-padding-y, $btn-padding-x, $font-size-base, $btn-line-height, $btn-border-radius);\r\n  @include transition($btn-transition);\r\n\r\n  // Share hover and focus styles\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    outline: 0;\r\n    box-shadow: $btn-focus-box-shadow;\r\n  }\r\n\r\n  // Disabled comes first so active can properly restyle\r\n  &.disabled,\r\n  &:disabled {\r\n    opacity: $btn-disabled-opacity;\r\n    @include box-shadow(none);\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .btn elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active {\r\n    background-image: none;\r\n    @include box-shadow($btn-active-box-shadow);\r\n\r\n    &:focus {\r\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\r\n    }\r\n  }\r\n}\r\n\r\n// Future-proof disabling of clicks on `<a>` elements\r\na.btn.disabled,\r\nfieldset:disabled a.btn {\r\n  pointer-events: none;\r\n}\r\n\r\n//\r\n// Alternate buttons\r\n//\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-#{$color} {\r\n    @include button-variant($value, $value);\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-outline-#{$color} {\r\n    @include button-outline-variant($value);\r\n  }\r\n}\r\n\r\n//\r\n// Link buttons\r\n//\r\n\r\n// Make a button look and behave like a link\r\n.btn-link {\r\n  font-weight: $font-weight-normal;\r\n  color: $link-color;\r\n  background-color: transparent;\r\n\r\n  @include hover {\r\n    color: $link-hover-color;\r\n    text-decoration: $link-hover-decoration;\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    text-decoration: $link-hover-decoration;\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled {\r\n    color: $btn-link-disabled-color;\r\n  }\r\n\r\n  // No need for an active state here\r\n}\r\n\r\n//\r\n// Button Sizes\r\n//\r\n\r\n.btn-lg {\r\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\r\n}\r\n\r\n.btn-sm {\r\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\r\n}\r\n\r\n//\r\n// Block button\r\n//\r\n\r\n.btn-block {\r\n  display: block;\r\n  width: 100%;\r\n\r\n  // Vertically space out multiple block buttons\r\n  + .btn-block {\r\n    margin-top: $btn-block-spacing-y;\r\n  }\r\n}\r\n\r\n// Specificity overrides\r\ninput[type=\"submit\"],\r\ninput[type=\"reset\"],\r\ninput[type=\"button\"] {\r\n  &.btn-block {\r\n    width: 100%;\r\n  }\r\n}\r\n","// Button variants\r\n//\r\n// Easily pump out default styles, as well as :hover, :focus, :active,\r\n// and disabled options for all buttons\r\n\r\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\r\n  color: color-yiq($background);\r\n  @include gradient-bg($background);\r\n  border-color: $border;\r\n  @include box-shadow($btn-box-shadow);\r\n\r\n  @include hover {\r\n    color: color-yiq($hover-background);\r\n    @include gradient-bg($hover-background);\r\n    border-color: $hover-border;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    // Avoid using mixin so we can pass custom focus shadow properly\r\n    @if $enable-shadows {\r\n      box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n    } @else {\r\n      box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n    }\r\n  }\r\n\r\n  // Disabled comes first so active can properly restyle\r\n  &.disabled,\r\n  &:disabled {\r\n    color: color-yiq($background);\r\n    background-color: $background;\r\n    border-color: $border;\r\n  }\r\n\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active,\r\n  .show > &.dropdown-toggle {\r\n    color: color-yiq($active-background);\r\n    background-color: $active-background;\r\n    @if $enable-gradients {\r\n      background-image: none; // Remove the gradient for the pressed/active state\r\n    }\r\n    border-color: $active-border;\r\n\r\n    &:focus {\r\n      // Avoid using mixin so we can pass custom focus shadow properly\r\n      @if $enable-shadows {\r\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n      } @else {\r\n        box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\r\n  color: $color;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: $color;\r\n\r\n  &:hover {\r\n    color: $color-hover;\r\n    background-color: $active-background;\r\n    border-color: $active-border;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $color;\r\n    background-color: transparent;\r\n  }\r\n\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active,\r\n  .show > &.dropdown-toggle {\r\n    color: color-yiq($active-background);\r\n    background-color: $active-background;\r\n    border-color: $active-border;\r\n\r\n    &:focus {\r\n      // Avoid using mixin so we can pass custom focus shadow properly\r\n      @if $enable-shadows and $btn-active-box-shadow != none {\r\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\r\n      } @else {\r\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Button sizes\r\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\r\n  padding: $padding-y $padding-x;\r\n  font-size: $font-size;\r\n  line-height: $line-height;\r\n  // Manually declare to provide an override to the browser default\r\n  @if $enable-rounded {\r\n    border-radius: $border-radius;\r\n  } @else {\r\n    border-radius: 0;\r\n  }\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n.fade {\r\n  opacity: 0;\r\n  @include transition($transition-fade);\r\n\r\n  &.show {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.collapse {\r\n  display: none;\r\n  &.show {\r\n    display: block;\r\n  }\r\n}\r\n\r\ntr {\r\n  &.collapse.show {\r\n    display: table-row;\r\n  }\r\n}\r\n\r\ntbody {\r\n  &.collapse.show {\r\n    display: table-row-group;\r\n  }\r\n}\r\n\r\n.collapsing {\r\n  position: relative;\r\n  height: 0;\r\n  overflow: hidden;\r\n  @include transition($transition-collapse);\r\n}\r\n","// The dropdown wrapper (`<div>`)\r\n.dropup,\r\n.dropdown {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-toggle {\r\n  // Generate the caret automatically\r\n  @include caret;\r\n}\r\n\r\n// The dropdown menu\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  z-index: $zindex-dropdown;\r\n  display: none; // none by default, but block on \"open\" of the menu\r\n  float: left;\r\n  min-width: $dropdown-min-width;\r\n  padding: $dropdown-padding-y 0;\r\n  margin: $dropdown-spacer 0 0; // override default ul\r\n  font-size: $font-size-base; // Redeclare because nesting can cause inheritance issues\r\n  color: $body-color;\r\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\r\n  list-style: none;\r\n  background-color: $dropdown-bg;\r\n  background-clip: padding-box;\r\n  border: $dropdown-border-width solid $dropdown-border-color;\r\n  @include border-radius($dropdown-border-radius);\r\n  @include box-shadow($dropdown-box-shadow);\r\n}\r\n\r\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\r\n// Just add .dropup after the standard .dropdown class and you're set.\r\n.dropup {\r\n  .dropdown-menu {\r\n    margin-top: 0;\r\n    margin-bottom: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(up);\r\n  }\r\n}\r\n\r\n.dropright {\r\n  .dropdown-menu {\r\n    margin-top: 0;\r\n    margin-left: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(right);\r\n    &::after {\r\n      vertical-align: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropleft {\r\n  .dropdown-menu {\r\n    margin-top: 0;\r\n    margin-right: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(left);\r\n    &::before {\r\n      vertical-align: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Dividers (basically an `<hr>`) within the dropdown\r\n.dropdown-divider {\r\n  @include nav-divider($dropdown-divider-bg);\r\n}\r\n\r\n// Links, buttons, and more within the dropdown menu\r\n//\r\n// `<button>`-specific styles are denoted with `// For <button>s`\r\n.dropdown-item {\r\n  display: block;\r\n  width: 100%; // For `<button>`s\r\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n  clear: both;\r\n  font-weight: $font-weight-normal;\r\n  color: $dropdown-link-color;\r\n  text-align: inherit; // For `<button>`s\r\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\r\n  background-color: transparent; // For `<button>`s\r\n  border: 0; // For `<button>`s\r\n\r\n  @include hover-focus {\r\n    color: $dropdown-link-hover-color;\r\n    text-decoration: none;\r\n    @include gradient-bg($dropdown-link-hover-bg);\r\n  }\r\n\r\n  &.active,\r\n  &:active {\r\n    color: $dropdown-link-active-color;\r\n    text-decoration: none;\r\n    @include gradient-bg($dropdown-link-active-bg);\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $dropdown-link-disabled-color;\r\n    background-color: transparent;\r\n    // Remove CSS gradients if they're enabled\r\n    @if $enable-gradients {\r\n      background-image: none;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu.show {\r\n  display: block;\r\n}\r\n\r\n// Dropdown section headers\r\n.dropdown-header {\r\n  display: block;\r\n  padding: $dropdown-padding-y $dropdown-item-padding-x;\r\n  margin-bottom: 0; // for use with heading elements\r\n  font-size: $font-size-sm;\r\n  color: $dropdown-header-color;\r\n  white-space: nowrap; // as with > li > a\r\n}\r\n","@mixin caret-down {\r\n  border-top: $caret-width solid;\r\n  border-right: $caret-width solid transparent;\r\n  border-bottom: 0;\r\n  border-left: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret-up {\r\n  border-top: 0;\r\n  border-right: $caret-width solid transparent;\r\n  border-bottom: $caret-width solid;\r\n  border-left: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret-right {\r\n  border-top: $caret-width solid transparent;\r\n  border-bottom: $caret-width solid transparent;\r\n  border-left: $caret-width solid;\r\n}\r\n\r\n@mixin caret-left {\r\n  border-top: $caret-width solid transparent;\r\n  border-right: $caret-width solid;\r\n  border-bottom: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret($direction: down) {\r\n  @if $enable-caret {\r\n    &::after {\r\n      display: inline-block;\r\n      width: 0;\r\n      height: 0;\r\n      margin-left: $caret-width * .85;\r\n      vertical-align: $caret-width * .85;\r\n      content: \"\";\r\n      @if $direction == down {\r\n        @include caret-down;\r\n      } @else if $direction == up {\r\n        @include caret-up;\r\n      } @else if $direction == right {\r\n        @include caret-right;\r\n      }\r\n    }\r\n\r\n    @if $direction == left {\r\n      &::after {\r\n        display: none;\r\n      }\r\n\r\n      &::before {\r\n        display: inline-block;\r\n        width: 0;\r\n        height: 0;\r\n        margin-right: $caret-width * .85;\r\n        vertical-align: $caret-width * .85;\r\n        content: \"\";\r\n        @include caret-left;\r\n      }\r\n    }\r\n\r\n    &:empty::after {\r\n      margin-left: 0;\r\n    }\r\n  }\r\n}\r\n","// Horizontal dividers\r\n//\r\n// Dividers (basically an hr) within dropdowns and nav lists\r\n\r\n@mixin nav-divider($color: #e5e5e5) {\r\n  height: 0;\r\n  margin: ($spacer / 2) 0;\r\n  overflow: hidden;\r\n  border-top: 1px solid $color;\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: inline-flex;\r\n  vertical-align: middle; // match .btn alignment given font-size hack above\r\n\r\n  > .btn {\r\n    position: relative;\r\n    flex: 0 1 auto;\r\n\r\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\r\n    // the borders properly\r\n    @include hover {\r\n      z-index: 1;\r\n    }\r\n    &:focus,\r\n    &:active,\r\n    &.active {\r\n      z-index: 1;\r\n    }\r\n  }\r\n\r\n  // Prevent double borders when buttons are next to each other\r\n  .btn + .btn,\r\n  .btn + .btn-group,\r\n  .btn-group + .btn,\r\n  .btn-group + .btn-group {\r\n    margin-left: -$btn-border-width;\r\n  }\r\n}\r\n\r\n// Optional: Group multiple button groups together for a toolbar\r\n.btn-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n\r\n  .input-group {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.btn-group {\r\n  > .btn:first-child {\r\n    margin-left: 0;\r\n  }\r\n\r\n  // Reset rounded corners\r\n  > .btn:not(:last-child):not(.dropdown-toggle),\r\n  > .btn-group:not(:last-child) > .btn {\r\n    @include border-right-radius(0);\r\n  }\r\n\r\n  > .btn:not(:first-child),\r\n  > .btn-group:not(:first-child) > .btn {\r\n    @include border-left-radius(0);\r\n  }\r\n}\r\n\r\n// Sizing\r\n//\r\n// Remix the default button sizing classes into new ones for easier manipulation.\r\n\r\n.btn-group-sm > .btn {\r\n  @extend .btn-sm;\r\n}\r\n\r\n.btn-group-lg > .btn {\r\n  @extend .btn-lg;\r\n}\r\n\r\n//\r\n// Split button dropdowns\r\n//\r\n\r\n.dropdown-toggle-split {\r\n  padding-right: $btn-padding-x * .75;\r\n  padding-left: $btn-padding-x * .75;\r\n\r\n  &::after {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.btn-sm + .dropdown-toggle-split {\r\n  padding-right: $btn-padding-x-sm * .75;\r\n  padding-left: $btn-padding-x-sm * .75;\r\n}\r\n\r\n.btn-lg + .dropdown-toggle-split {\r\n  padding-right: $btn-padding-x-lg * .75;\r\n  padding-left: $btn-padding-x-lg * .75;\r\n}\r\n\r\n// The clickable button for toggling the menu\r\n// Set the same inset shadow as the :active state\r\n.btn-group.show .dropdown-toggle {\r\n  @include box-shadow($btn-active-box-shadow);\r\n\r\n  // Show no shadow for `.btn-link` since it has no other button styles.\r\n  &.btn-link {\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n//\r\n// Vertical button groups\r\n//\r\n\r\n.btn-group-vertical {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n\r\n  .btn,\r\n  .btn-group {\r\n    width: 100%;\r\n  }\r\n\r\n  > .btn + .btn,\r\n  > .btn + .btn-group,\r\n  > .btn-group + .btn,\r\n  > .btn-group + .btn-group {\r\n    margin-top: -$btn-border-width;\r\n    margin-left: 0;\r\n  }\r\n\r\n  // Reset rounded corners\r\n  > .btn:not(:last-child):not(.dropdown-toggle),\r\n  > .btn-group:not(:last-child) > .btn {\r\n    @include border-bottom-radius(0);\r\n  }\r\n\r\n  > .btn:not(:first-child),\r\n  > .btn-group:not(:first-child) > .btn {\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n// Checkbox and radio options\r\n//\r\n// In order to support the browser's form validation feedback, powered by the\r\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\r\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\r\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\r\n// certain cases which is prevented by using `clip` and `pointer-events`.\r\n// This way, we ensure a DOM element is visible to position the popover from.\r\n//\r\n// See https://github.com/twbs/bootstrap/pull/12794 and\r\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\r\n\r\n.btn-group-toggle {\r\n  > .btn,\r\n  > .btn-group > .btn {\r\n    margin-bottom: 0; // Override default `<label>` value\r\n\r\n    input[type=\"radio\"],\r\n    input[type=\"checkbox\"] {\r\n      position: absolute;\r\n      clip: rect(0, 0, 0, 0);\r\n      pointer-events: none;\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n//\r\n// Base styles\r\n//\r\n\r\n.input-group {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap; // For form validation feedback\r\n  align-items: stretch;\r\n  width: 100%;\r\n\r\n  > .form-control,\r\n  > .custom-select,\r\n  > .custom-file {\r\n    position: relative; // For focus state's z-index\r\n    flex: 1 1 auto;\r\n    // Add width 1% and flex-basis auto to ensure that button will not wrap out\r\n    // the column. Applies to IE Edge+ and Firefox. Chrome does not require this.\r\n    width: 1%;\r\n    margin-bottom: 0;\r\n\r\n    // Bring the \"active\" form control to the top of surrounding elements\r\n    &:focus {\r\n      z-index: 3;\r\n    }\r\n\r\n    + .form-control,\r\n    + .custom-select,\r\n    + .custom-file {\r\n      margin-left: -$input-border-width;\r\n    }\r\n  }\r\n\r\n  > .form-control,\r\n  > .custom-select {\r\n    &:not(:last-child) {\r\n      @include border-right-radius(0);\r\n    }\r\n    &:not(:first-child) {\r\n      @include border-left-radius(0);\r\n    }\r\n  }\r\n\r\n  // Custom file inputs have more complex markup, thus requiring different\r\n  // border-radius overrides.\r\n  > .custom-file {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    &:not(:last-child) .custom-file-label,\r\n    &:not(:last-child) .custom-file-label::before {\r\n      @include border-right-radius(0);\r\n    }\r\n    &:not(:first-child) .custom-file-label,\r\n    &:not(:first-child) .custom-file-label::before {\r\n      @include border-left-radius(0);\r\n    }\r\n  }\r\n}\r\n\r\n// Prepend and append\r\n//\r\n// While it requires one extra layer of HTML for each, dedicated prepend and\r\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\r\n// 3) support HTML5 form validation.\r\n\r\n.input-group-prepend,\r\n.input-group-append {\r\n  display: flex;\r\n\r\n  // Ensure buttons are always above inputs for more visually pleasing borders.\r\n  // This isn't needed for `.input-group-text` since it shares the same border-color\r\n  // as our inputs.\r\n  .btn {\r\n    position: relative;\r\n    z-index: 2;\r\n  }\r\n\r\n  .btn + .btn,\r\n  .btn + .input-group-text,\r\n  .input-group-text + .input-group-text,\r\n  .input-group-text + .btn {\r\n    margin-left: -$input-border-width;\r\n  }\r\n}\r\n\r\n.input-group-prepend {\r\n  margin-right: -$input-border-width;\r\n}\r\n\r\n.input-group-append {\r\n  margin-left: -$input-border-width;\r\n}\r\n\r\n// Textual addons\r\n//\r\n// Serves as a catch-all element for any text or radio/checkbox input you wish\r\n// to prepend or append to an input.\r\n\r\n.input-group-text {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: $input-padding-y $input-padding-x;\r\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\r\n  font-size: $font-size-base; // Match inputs\r\n  font-weight: $font-weight-normal;\r\n  line-height: $input-line-height;\r\n  color: $input-group-addon-color;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: $input-group-addon-bg;\r\n  border: $input-border-width solid $input-group-addon-border-color;\r\n  @include border-radius($input-border-radius);\r\n\r\n  // Nuke default margins from checkboxes and radios to vertically center within.\r\n  input[type=\"radio\"],\r\n  input[type=\"checkbox\"] {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n// Sizing\r\n//\r\n// Remix the default form control sizing classes into new ones for easier\r\n// manipulation.\r\n\r\n.input-group-lg > .form-control,\r\n.input-group-lg > .input-group-prepend > .input-group-text,\r\n.input-group-lg > .input-group-append > .input-group-text,\r\n.input-group-lg > .input-group-prepend > .btn,\r\n.input-group-lg > .input-group-append > .btn {\r\n  @extend .form-control-lg;\r\n}\r\n\r\n.input-group-sm > .form-control,\r\n.input-group-sm > .input-group-prepend > .input-group-text,\r\n.input-group-sm > .input-group-append > .input-group-text,\r\n.input-group-sm > .input-group-prepend > .btn,\r\n.input-group-sm > .input-group-append > .btn {\r\n  @extend .form-control-sm;\r\n}\r\n\r\n// Prepend and append rounded corners\r\n//\r\n// These rulesets must come after the sizing ones to properly override sm and lg\r\n// border-radius values when extending. They're more specific than we'd like\r\n// with the `.input-group >` part, but without it, we cannot override the sizing.\r\n\r\n.input-group > .input-group-prepend > .btn,\r\n.input-group > .input-group-prepend > .input-group-text,\r\n.input-group > .input-group-append:not(:last-child) > .btn,\r\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\r\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\r\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\r\n  @include border-right-radius(0);\r\n}\r\n\r\n.input-group > .input-group-append > .btn,\r\n.input-group > .input-group-append > .input-group-text,\r\n.input-group > .input-group-prepend:not(:first-child) > .btn,\r\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\r\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\r\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\r\n  @include border-left-radius(0);\r\n}\r\n","// Embedded icons from Open Iconic.\r\n// Released under MIT and copyright 2014 Waybury.\r\n// https://useiconic.com/open\r\n\r\n// Checkboxes and radios\r\n//\r\n// Base class takes care of all the key behavioral aspects.\r\n\r\n.custom-control {\r\n  position: relative;\r\n  display: block;\r\n  min-height: (1rem * $line-height-base);\r\n  padding-left: $custom-control-gutter;\r\n}\r\n\r\n.custom-control-inline {\r\n  display: inline-flex;\r\n  margin-right: $custom-control-spacer-x;\r\n}\r\n\r\n.custom-control-input {\r\n  position: absolute;\r\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\r\n  opacity: 0;\r\n\r\n  &:checked ~ .custom-control-label::before {\r\n    color: $custom-control-indicator-checked-color;\r\n    @include gradient-bg($custom-control-indicator-checked-bg);\r\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\r\n  }\r\n\r\n  &:focus ~ .custom-control-label::before {\r\n    // the mixin is not used here to make sure there is feedback\r\n    box-shadow: $custom-control-indicator-focus-box-shadow;\r\n  }\r\n\r\n  &:active ~ .custom-control-label::before {\r\n    color: $custom-control-indicator-active-color;\r\n    background-color: $custom-control-indicator-active-bg;\r\n    @include box-shadow($custom-control-indicator-active-box-shadow);\r\n  }\r\n\r\n  &:disabled {\r\n    ~ .custom-control-label {\r\n      color: $custom-control-label-disabled-color;\r\n\r\n      &::before {\r\n        background-color: $custom-control-indicator-disabled-bg;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Custom control indicators\r\n//\r\n// Build the custom controls out of psuedo-elements.\r\n\r\n.custom-control-label {\r\n  margin-bottom: 0;\r\n\r\n  // Background-color and (when enabled) gradient\r\n  &::before {\r\n    position: absolute;\r\n    top: (($line-height-base - $custom-control-indicator-size) / 2);\r\n    left: 0;\r\n    display: block;\r\n    width: $custom-control-indicator-size;\r\n    height: $custom-control-indicator-size;\r\n    pointer-events: none;\r\n    content: \"\";\r\n    user-select: none;\r\n    background-color: $custom-control-indicator-bg;\r\n    @include box-shadow($custom-control-indicator-box-shadow);\r\n  }\r\n\r\n  // Foreground (icon)\r\n  &::after {\r\n    position: absolute;\r\n    top: (($line-height-base - $custom-control-indicator-size) / 2);\r\n    left: 0;\r\n    display: block;\r\n    width: $custom-control-indicator-size;\r\n    height: $custom-control-indicator-size;\r\n    content: \"\";\r\n    background-repeat: no-repeat;\r\n    background-position: center center;\r\n    background-size: $custom-control-indicator-bg-size;\r\n  }\r\n}\r\n\r\n// Checkboxes\r\n//\r\n// Tweak just a few things for checkboxes.\r\n\r\n.custom-checkbox {\r\n  .custom-control-label::before {\r\n    @include border-radius($custom-checkbox-indicator-border-radius);\r\n  }\r\n\r\n  .custom-control-input:checked ~ .custom-control-label {\r\n    &::before {\r\n      @include gradient-bg($custom-control-indicator-checked-bg);\r\n    }\r\n    &::after {\r\n      background-image: $custom-checkbox-indicator-icon-checked;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:indeterminate ~ .custom-control-label {\r\n    &::before {\r\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\r\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\r\n    }\r\n    &::after {\r\n      background-image: $custom-checkbox-indicator-icon-indeterminate;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:disabled {\r\n    &:checked ~ .custom-control-label::before {\r\n      background-color: $custom-control-indicator-checked-disabled-bg;\r\n    }\r\n    &:indeterminate ~ .custom-control-label::before {\r\n      background-color: $custom-control-indicator-checked-disabled-bg;\r\n    }\r\n  }\r\n}\r\n\r\n// Radios\r\n//\r\n// Tweak just a few things for radios.\r\n\r\n.custom-radio {\r\n  .custom-control-label::before {\r\n    border-radius: $custom-radio-indicator-border-radius;\r\n  }\r\n\r\n  .custom-control-input:checked ~ .custom-control-label {\r\n    &::before {\r\n      @include gradient-bg($custom-control-indicator-checked-bg);\r\n    }\r\n    &::after {\r\n      background-image: $custom-radio-indicator-icon-checked;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:disabled {\r\n    &:checked ~ .custom-control-label::before {\r\n      background-color: $custom-control-indicator-checked-disabled-bg;\r\n    }\r\n  }\r\n}\r\n\r\n// Select\r\n//\r\n// Replaces the browser default select with a custom one, mostly pulled from\r\n// http://primercss.io.\r\n//\r\n\r\n.custom-select {\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: $custom-select-height;\r\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\r\n  line-height: $custom-select-line-height;\r\n  color: $custom-select-color;\r\n  vertical-align: middle;\r\n  background: $custom-select-bg $custom-select-indicator no-repeat right $custom-select-padding-x center;\r\n  background-size: $custom-select-bg-size;\r\n  border: $custom-select-border-width solid $custom-select-border-color;\r\n  @if $enable-rounded {\r\n    border-radius: $custom-select-border-radius;\r\n  } @else {\r\n    border-radius: 0;\r\n  }\r\n  appearance: none;\r\n\r\n  &:focus {\r\n    border-color: $custom-select-focus-border-color;\r\n    outline: 0;\r\n    box-shadow: $custom-select-focus-box-shadow;\r\n\r\n    &::-ms-value {\r\n      // For visual consistency with other platforms/browsers,\r\n      // suppress the default white text on blue background highlight given to\r\n      // the selected option text when the (still closed) <select> receives focus\r\n      // in IE and (under certain conditions) Edge.\r\n      // See https://github.com/twbs/bootstrap/issues/19398.\r\n      color: $input-color;\r\n      background-color: $input-bg;\r\n    }\r\n  }\r\n\r\n  &[multiple],\r\n  &[size]:not([size=\"1\"]) {\r\n    height: auto;\r\n    padding-right: $custom-select-padding-x;\r\n    background-image: none;\r\n  }\r\n\r\n  &:disabled {\r\n    color: $custom-select-disabled-color;\r\n    background-color: $custom-select-disabled-bg;\r\n  }\r\n\r\n  // Hides the default caret in IE11\r\n  &::-ms-expand {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.custom-select-sm {\r\n  height: $custom-select-height-sm;\r\n  padding-top: $custom-select-padding-y;\r\n  padding-bottom: $custom-select-padding-y;\r\n  font-size: $custom-select-font-size-sm;\r\n}\r\n\r\n.custom-select-lg {\r\n  height: $custom-select-height-lg;\r\n  padding-top: $custom-select-padding-y;\r\n  padding-bottom: $custom-select-padding-y;\r\n  font-size: $custom-select-font-size-lg;\r\n}\r\n\r\n// File\r\n//\r\n// Custom file input.\r\n\r\n.custom-file {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: $custom-file-height;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-file-input {\r\n  position: relative;\r\n  z-index: 2;\r\n  width: 100%;\r\n  height: $custom-file-height;\r\n  margin: 0;\r\n  opacity: 0;\r\n\r\n  &:focus ~ .custom-file-control {\r\n    border-color: $custom-file-focus-border-color;\r\n    box-shadow: $custom-file-focus-box-shadow;\r\n\r\n    &::before {\r\n      border-color: $custom-file-focus-border-color;\r\n    }\r\n  }\r\n\r\n  @each $lang, $value in $custom-file-text {\r\n    &:lang(#{$lang}) ~ .custom-file-label::after {\r\n      content: $value;\r\n    }\r\n  }\r\n}\r\n\r\n.custom-file-label {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 1;\r\n  height: $custom-file-height;\r\n  padding: $custom-file-padding-y $custom-file-padding-x;\r\n  line-height: $custom-file-line-height;\r\n  color: $custom-file-color;\r\n  background-color: $custom-file-bg;\r\n  border: $custom-file-border-width solid $custom-file-border-color;\r\n  @include border-radius($custom-file-border-radius);\r\n  @include box-shadow($custom-file-box-shadow);\r\n\r\n  &::after {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 3;\r\n    display: block;\r\n    height: calc(#{$custom-file-height} - #{$custom-file-border-width} * 2);\r\n    padding: $custom-file-padding-y $custom-file-padding-x;\r\n    line-height: $custom-file-line-height;\r\n    color: $custom-file-button-color;\r\n    content: \"Browse\";\r\n    @include gradient-bg($custom-file-button-bg);\r\n    border-left: $custom-file-border-width solid $custom-file-border-color;\r\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\r\n  }\r\n}\r\n","// Base class\r\n//\r\n// Kickstart any navigation component with a set of style resets. Works with\r\n// `<nav>`s or `<ul>`s.\r\n\r\n.nav {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n\r\n.nav-link {\r\n  display: block;\r\n  padding: $nav-link-padding-y $nav-link-padding-x;\r\n\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  // Disabled state lightens text\r\n  &.disabled {\r\n    color: $nav-link-disabled-color;\r\n  }\r\n}\r\n\r\n//\r\n// Tabs\r\n//\r\n\r\n.nav-tabs {\r\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\r\n\r\n  .nav-item {\r\n    margin-bottom: -$nav-tabs-border-width;\r\n  }\r\n\r\n  .nav-link {\r\n    border: $nav-tabs-border-width solid transparent;\r\n    @include border-top-radius($nav-tabs-border-radius);\r\n\r\n    @include hover-focus {\r\n      border-color: $nav-tabs-link-hover-border-color;\r\n    }\r\n\r\n    &.disabled {\r\n      color: $nav-link-disabled-color;\r\n      background-color: transparent;\r\n      border-color: transparent;\r\n    }\r\n  }\r\n\r\n  .nav-link.active,\r\n  .nav-item.show .nav-link {\r\n    color: $nav-tabs-link-active-color;\r\n    background-color: $nav-tabs-link-active-bg;\r\n    border-color: $nav-tabs-link-active-border-color;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    // Make dropdown border overlap tab border\r\n    margin-top: -$nav-tabs-border-width;\r\n    // Remove the top rounded corners here since there is a hard edge above the menu\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n//\r\n// Pills\r\n//\r\n\r\n.nav-pills {\r\n  .nav-link {\r\n    @include border-radius($nav-pills-border-radius);\r\n  }\r\n\r\n  .nav-link.active,\r\n  .show > .nav-link {\r\n    color: $nav-pills-link-active-color;\r\n    background-color: $nav-pills-link-active-bg;\r\n  }\r\n}\r\n\r\n//\r\n// Justified variants\r\n//\r\n\r\n.nav-fill {\r\n  .nav-item {\r\n    flex: 1 1 auto;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.nav-justified {\r\n  .nav-item {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n// Tabbable tabs\r\n//\r\n// Hide tabbable panes to start, show them when `.active`\r\n\r\n.tab-content {\r\n  > .tab-pane {\r\n    display: none;\r\n  }\r\n  > .active {\r\n    display: block;\r\n  }\r\n}\r\n","// Contents\r\n//\r\n// Navbar\r\n// Navbar brand\r\n// Navbar nav\r\n// Navbar text\r\n// Navbar divider\r\n// Responsive navbar\r\n// Navbar position\r\n// Navbar themes\r\n\r\n// Navbar\r\n//\r\n// Provide a static navbar from which we expand to create full-width, fixed, and\r\n// other navbar variations.\r\n\r\n.navbar {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\r\n  align-items: center;\r\n  justify-content: space-between; // space out brand from logo\r\n  padding: $navbar-padding-y $navbar-padding-x;\r\n\r\n  // Because flex properties aren't inherited, we need to redeclare these first\r\n  // few properities so that content nested within behave properly.\r\n  > .container,\r\n  > .container-fluid {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n// Navbar brand\r\n//\r\n// Used for brand, project, or site names.\r\n\r\n.navbar-brand {\r\n  display: inline-block;\r\n  padding-top: $navbar-brand-padding-y;\r\n  padding-bottom: $navbar-brand-padding-y;\r\n  margin-right: $navbar-padding-x;\r\n  font-size: $navbar-brand-font-size;\r\n  line-height: inherit;\r\n  white-space: nowrap;\r\n\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n// Navbar nav\r\n//\r\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\r\n\r\n.navbar-nav {\r\n  display: flex;\r\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n\r\n  .nav-link {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    position: static;\r\n    float: none;\r\n  }\r\n}\r\n\r\n// Navbar text\r\n//\r\n//\r\n\r\n.navbar-text {\r\n  display: inline-block;\r\n  padding-top: $nav-link-padding-y;\r\n  padding-bottom: $nav-link-padding-y;\r\n}\r\n\r\n// Responsive navbar\r\n//\r\n// Custom styles for responsive collapsing and toggling of navbar contents.\r\n// Powered by the collapse Bootstrap JavaScript plugin.\r\n\r\n// When collapsed, prevent the toggleable navbar contents from appearing in\r\n// the default flexbox row orienation. Requires the use of `flex-wrap: wrap`\r\n// on the `.navbar` parent.\r\n.navbar-collapse {\r\n  flex-basis: 100%;\r\n  flex-grow: 1;\r\n  // For always expanded or extra full navbars, ensure content aligns itself\r\n  // properly vertically. Can be easily overridden with flex utilities.\r\n  align-items: center;\r\n}\r\n\r\n// Button for toggling the navbar when in its collapsed state\r\n.navbar-toggler {\r\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\r\n  font-size: $navbar-toggler-font-size;\r\n  line-height: 1;\r\n  background-color: transparent; // remove default button style\r\n  border: $border-width solid transparent; // remove default button style\r\n  @include border-radius($navbar-toggler-border-radius);\r\n\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n// Keep as a separate element so folks can easily override it with another icon\r\n// or image file as needed.\r\n.navbar-toggler-icon {\r\n  display: inline-block;\r\n  width: 1.5em;\r\n  height: 1.5em;\r\n  vertical-align: middle;\r\n  content: \"\";\r\n  background: no-repeat center center;\r\n  background-size: 100% 100%;\r\n}\r\n\r\n// Generate series of `.navbar-expand-*` responsive classes for configuring\r\n// where your navbar collapses.\r\n.navbar-expand {\r\n  @each $breakpoint in map-keys($grid-breakpoints) {\r\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\r\n    $infix: breakpoint-infix($next, $grid-breakpoints);\r\n\r\n    &#{$infix} {\r\n      @include media-breakpoint-down($breakpoint) {\r\n        > .container,\r\n        > .container-fluid {\r\n          padding-right: 0;\r\n          padding-left: 0;\r\n        }\r\n      }\r\n\r\n      @include media-breakpoint-up($next) {\r\n        flex-flow: row nowrap;\r\n        justify-content: flex-start;\r\n\r\n        .navbar-nav {\r\n          flex-direction: row;\r\n\r\n          .dropdown-menu {\r\n            position: absolute;\r\n          }\r\n\r\n          .dropdown-menu-right {\r\n            right: 0;\r\n            left: auto; // Reset the default from `.dropdown-menu`\r\n          }\r\n\r\n          .nav-link {\r\n            padding-right: $navbar-nav-link-padding-x;\r\n            padding-left: $navbar-nav-link-padding-x;\r\n          }\r\n        }\r\n\r\n        // For nesting containers, have to redeclare for alignment purposes\r\n        > .container,\r\n        > .container-fluid {\r\n          flex-wrap: nowrap;\r\n        }\r\n\r\n        .navbar-collapse {\r\n          display: flex !important; // stylelint-disable-line declaration-no-important\r\n\r\n          // Changes flex-bases to auto because of an IE10 bug\r\n          flex-basis: auto;\r\n        }\r\n\r\n        .navbar-toggler {\r\n          display: none;\r\n        }\r\n\r\n        .dropup {\r\n          .dropdown-menu {\r\n            top: auto;\r\n            bottom: 100%;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Navbar themes\r\n//\r\n// Styles for switching between navbars with light or dark background.\r\n\r\n// Dark links against a light background\r\n.navbar-light {\r\n  .navbar-brand {\r\n    color: $navbar-light-active-color;\r\n\r\n    @include hover-focus {\r\n      color: $navbar-light-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-link {\r\n      color: $navbar-light-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-light-hover-color;\r\n      }\r\n\r\n      &.disabled {\r\n        color: $navbar-light-disabled-color;\r\n      }\r\n    }\r\n\r\n    .show > .nav-link,\r\n    .active > .nav-link,\r\n    .nav-link.show,\r\n    .nav-link.active {\r\n      color: $navbar-light-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-toggler {\r\n    color: $navbar-light-color;\r\n    border-color: $navbar-light-toggler-border-color;\r\n  }\r\n\r\n  .navbar-toggler-icon {\r\n    background-image: $navbar-light-toggler-icon-bg;\r\n  }\r\n\r\n  .navbar-text {\r\n    color: $navbar-light-color;\r\n    a {\r\n      color: $navbar-light-active-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-light-active-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// White links against a dark background\r\n.navbar-dark {\r\n  .navbar-brand {\r\n    color: $navbar-dark-active-color;\r\n\r\n    @include hover-focus {\r\n      color: $navbar-dark-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-link {\r\n      color: $navbar-dark-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-dark-hover-color;\r\n      }\r\n\r\n      &.disabled {\r\n        color: $navbar-dark-disabled-color;\r\n      }\r\n    }\r\n\r\n    .show > .nav-link,\r\n    .active > .nav-link,\r\n    .nav-link.show,\r\n    .nav-link.active {\r\n      color: $navbar-dark-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-toggler {\r\n    color: $navbar-dark-color;\r\n    border-color: $navbar-dark-toggler-border-color;\r\n  }\r\n\r\n  .navbar-toggler-icon {\r\n    background-image: $navbar-dark-toggler-icon-bg;\r\n  }\r\n\r\n  .navbar-text {\r\n    color: $navbar-dark-color;\r\n    a {\r\n      color: $navbar-dark-active-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-dark-active-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  background-color: $card-bg;\r\n  background-clip: border-box;\r\n  border: $card-border-width solid $card-border-color;\r\n  @include border-radius($card-border-radius);\r\n\r\n  > hr {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n  }\r\n\r\n  > .list-group:first-child {\r\n    .list-group-item:first-child {\r\n      @include border-top-radius($card-border-radius);\r\n    }\r\n  }\r\n\r\n  > .list-group:last-child {\r\n    .list-group-item:last-child {\r\n      @include border-bottom-radius($card-border-radius);\r\n    }\r\n  }\r\n}\r\n\r\n.card-body {\r\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\r\n  // as much space as possible, ensuring footers are aligned to the bottom.\r\n  flex: 1 1 auto;\r\n  padding: $card-spacer-x;\r\n}\r\n\r\n.card-title {\r\n  margin-bottom: $card-spacer-y;\r\n}\r\n\r\n.card-subtitle {\r\n  margin-top: -($card-spacer-y / 2);\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-text:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-link {\r\n  @include hover {\r\n    text-decoration: none;\r\n  }\r\n\r\n  + .card-link {\r\n    margin-left: $card-spacer-x;\r\n  }\r\n}\r\n\r\n//\r\n// Optional textual caps\r\n//\r\n\r\n.card-header {\r\n  padding: $card-spacer-y $card-spacer-x;\r\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\r\n  background-color: $card-cap-bg;\r\n  border-bottom: $card-border-width solid $card-border-color;\r\n\r\n  &:first-child {\r\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\r\n  }\r\n\r\n  + .list-group {\r\n    .list-group-item:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.card-footer {\r\n  padding: $card-spacer-y $card-spacer-x;\r\n  background-color: $card-cap-bg;\r\n  border-top: $card-border-width solid $card-border-color;\r\n\r\n  &:last-child {\r\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\r\n  }\r\n}\r\n\r\n//\r\n// Header navs\r\n//\r\n\r\n.card-header-tabs {\r\n  margin-right: -($card-spacer-x / 2);\r\n  margin-bottom: -$card-spacer-y;\r\n  margin-left: -($card-spacer-x / 2);\r\n  border-bottom: 0;\r\n}\r\n\r\n.card-header-pills {\r\n  margin-right: -($card-spacer-x / 2);\r\n  margin-left: -($card-spacer-x / 2);\r\n}\r\n\r\n// Card image\r\n.card-img-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: $card-img-overlay-padding;\r\n}\r\n\r\n.card-img {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n  @include border-radius($card-inner-border-radius);\r\n}\r\n\r\n// Card image caps\r\n.card-img-top {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n  @include border-top-radius($card-inner-border-radius);\r\n}\r\n\r\n.card-img-bottom {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n  @include border-bottom-radius($card-inner-border-radius);\r\n}\r\n\r\n// Card deck\r\n\r\n.card-deck {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  .card {\r\n    margin-bottom: $card-deck-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    flex-flow: row wrap;\r\n    margin-right: -$card-deck-margin;\r\n    margin-left: -$card-deck-margin;\r\n\r\n    .card {\r\n      display: flex;\r\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#4-flex-shorthand-declarations-with-unitless-flex-basis-values-are-ignored\r\n      flex: 1 0 0%;\r\n      flex-direction: column;\r\n      margin-right: $card-deck-margin;\r\n      margin-bottom: 0; // Override the default\r\n      margin-left: $card-deck-margin;\r\n    }\r\n  }\r\n}\r\n\r\n//\r\n// Card groups\r\n//\r\n\r\n.card-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  // The child selector allows nested `.card` within `.card-group`\r\n  // to display properly.\r\n  > .card {\r\n    margin-bottom: $card-group-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    flex-flow: row wrap;\r\n    // The child selector allows nested `.card` within `.card-group`\r\n    // to display properly.\r\n    > .card {\r\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#4-flex-shorthand-declarations-with-unitless-flex-basis-values-are-ignored\r\n      flex: 1 0 0%;\r\n      margin-bottom: 0;\r\n\r\n      + .card {\r\n        margin-left: 0;\r\n        border-left: 0;\r\n      }\r\n\r\n      // Handle rounded corners\r\n      @if $enable-rounded {\r\n        &:first-child {\r\n          @include border-right-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            border-top-right-radius: 0;\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            border-bottom-right-radius: 0;\r\n          }\r\n        }\r\n\r\n        &:last-child {\r\n          @include border-left-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            border-top-left-radius: 0;\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            border-bottom-left-radius: 0;\r\n          }\r\n        }\r\n\r\n        &:only-child {\r\n          @include border-radius($card-border-radius);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            @include border-top-radius($card-border-radius);\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            @include border-bottom-radius($card-border-radius);\r\n          }\r\n        }\r\n\r\n        &:not(:first-child):not(:last-child):not(:only-child) {\r\n          @include border-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-img-bottom,\r\n          .card-header,\r\n          .card-footer {\r\n            @include border-radius(0);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n//\r\n// Columns\r\n//\r\n\r\n.card-columns {\r\n  .card {\r\n    margin-bottom: $card-columns-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    column-count: $card-columns-count;\r\n    column-gap: $card-columns-gap;\r\n\r\n    .card {\r\n      display: inline-block; // Don't let them vertically span multiple columns\r\n      width: 100%; // Don't let their width change\r\n    }\r\n  }\r\n}\r\n",".breadcrumb {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\r\n  margin-bottom: $breadcrumb-margin-bottom;\r\n  list-style: none;\r\n  background-color: $breadcrumb-bg;\r\n  @include border-radius($border-radius);\r\n}\r\n\r\n.breadcrumb-item {\r\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\r\n  + .breadcrumb-item::before {\r\n    display: inline-block; // Suppress underlining of the separator in modern browsers\r\n    padding-right: $breadcrumb-item-padding;\r\n    padding-left: $breadcrumb-item-padding;\r\n    color: $breadcrumb-divider-color;\r\n    content: \"#{$breadcrumb-divider}\";\r\n  }\r\n\r\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\r\n  // without `<ul>`s. The `::before` pseudo-element generates an element\r\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\r\n  //\r\n  // To trick IE into suppressing the underline, we give the pseudo-element an\r\n  // underline and then immediately remove it.\r\n  + .breadcrumb-item:hover::before {\r\n    text-decoration: underline;\r\n  }\r\n  // stylelint-disable-next-line no-duplicate-selectors\r\n  + .breadcrumb-item:hover::before {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.active {\r\n    color: $breadcrumb-active-color;\r\n  }\r\n}\r\n",".pagination {\r\n  display: flex;\r\n  @include list-unstyled();\r\n  @include border-radius();\r\n}\r\n\r\n.page-link {\r\n  position: relative;\r\n  display: block;\r\n  padding: $pagination-padding-y $pagination-padding-x;\r\n  margin-left: -$pagination-border-width;\r\n  line-height: $pagination-line-height;\r\n  color: $pagination-color;\r\n  background-color: $pagination-bg;\r\n  border: $pagination-border-width solid $pagination-border-color;\r\n\r\n  &:hover {\r\n    color: $pagination-hover-color;\r\n    text-decoration: none;\r\n    background-color: $pagination-hover-bg;\r\n    border-color: $pagination-hover-border-color;\r\n  }\r\n\r\n  &:focus {\r\n    z-index: 2;\r\n    outline: 0;\r\n    box-shadow: $pagination-focus-box-shadow;\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .page-link elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.page-item {\r\n  &:first-child {\r\n    .page-link {\r\n      margin-left: 0;\r\n      @include border-left-radius($border-radius);\r\n    }\r\n  }\r\n  &:last-child {\r\n    .page-link {\r\n      @include border-right-radius($border-radius);\r\n    }\r\n  }\r\n\r\n  &.active .page-link {\r\n    z-index: 1;\r\n    color: $pagination-active-color;\r\n    background-color: $pagination-active-bg;\r\n    border-color: $pagination-active-border-color;\r\n  }\r\n\r\n  &.disabled .page-link {\r\n    color: $pagination-disabled-color;\r\n    pointer-events: none;\r\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\r\n    cursor: auto;\r\n    background-color: $pagination-disabled-bg;\r\n    border-color: $pagination-disabled-border-color;\r\n  }\r\n}\r\n\r\n//\r\n// Sizing\r\n//\r\n\r\n.pagination-lg {\r\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $border-radius-lg);\r\n}\r\n\r\n.pagination-sm {\r\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $border-radius-sm);\r\n}\r\n","// Pagination\r\n\r\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\r\n  .page-link {\r\n    padding: $padding-y $padding-x;\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n  }\r\n\r\n  .page-item {\r\n    &:first-child {\r\n      .page-link {\r\n        @include border-left-radius($border-radius);\r\n      }\r\n    }\r\n    &:last-child {\r\n      .page-link {\r\n        @include border-right-radius($border-radius);\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Base class\r\n//\r\n// Requires one of the contextual, color modifier classes for `color` and\r\n// `background-color`.\r\n\r\n.badge {\r\n  display: inline-block;\r\n  padding: $badge-padding-y $badge-padding-x;\r\n  font-size: $badge-font-size;\r\n  font-weight: $badge-font-weight;\r\n  line-height: 1;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: baseline;\r\n  @include border-radius($badge-border-radius);\r\n\r\n  // Empty badges collapse automatically\r\n  &:empty {\r\n    display: none;\r\n  }\r\n}\r\n\r\n// Quick fix for badges in buttons\r\n.btn .badge {\r\n  position: relative;\r\n  top: -1px;\r\n}\r\n\r\n// Pill badges\r\n//\r\n// Make them extra rounded with a modifier to replace v3's badges.\r\n\r\n.badge-pill {\r\n  padding-right: $badge-pill-padding-x;\r\n  padding-left: $badge-pill-padding-x;\r\n  @include border-radius($badge-pill-border-radius);\r\n}\r\n\r\n// Colors\r\n//\r\n// Contextual variations (linked badges get darker on :hover).\r\n\r\n@each $color, $value in $theme-colors {\r\n  .badge-#{$color} {\r\n    @include badge-variant($value);\r\n  }\r\n}\r\n","@mixin badge-variant($bg) {\r\n  color: color-yiq($bg);\r\n  background-color: $bg;\r\n\r\n  &[href] {\r\n    @include hover-focus {\r\n      color: color-yiq($bg);\r\n      text-decoration: none;\r\n      background-color: darken($bg, 10%);\r\n    }\r\n  }\r\n}\r\n",".jumbotron {\r\n  padding: $jumbotron-padding ($jumbotron-padding / 2);\r\n  margin-bottom: $jumbotron-padding;\r\n  background-color: $jumbotron-bg;\r\n  @include border-radius($border-radius-lg);\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\r\n  }\r\n}\r\n\r\n.jumbotron-fluid {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n  @include border-radius(0);\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.alert {\r\n  position: relative;\r\n  padding: $alert-padding-y $alert-padding-x;\r\n  margin-bottom: $alert-margin-bottom;\r\n  border: $alert-border-width solid transparent;\r\n  @include border-radius($alert-border-radius);\r\n}\r\n\r\n// Headings for larger alerts\r\n.alert-heading {\r\n  // Specified to prevent conflicts of changing $headings-color\r\n  color: inherit;\r\n}\r\n\r\n// Provide class for links that match alerts\r\n.alert-link {\r\n  font-weight: $alert-link-font-weight;\r\n}\r\n\r\n// Dismissible alerts\r\n//\r\n// Expand the right padding and account for the close button's positioning.\r\n\r\n.alert-dismissible {\r\n  padding-right: ($close-font-size + $alert-padding-x * 2);\r\n\r\n  // Adjust close link position\r\n  .close {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    padding: $alert-padding-y $alert-padding-x;\r\n    color: inherit;\r\n  }\r\n}\r\n\r\n// Alternate styles\r\n//\r\n// Generate contextual modifier classes for colorizing the alert.\r\n\r\n@each $color, $value in $theme-colors {\r\n  .alert-#{$color} {\r\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\r\n  }\r\n}\r\n","@mixin alert-variant($background, $border, $color) {\r\n  color: $color;\r\n  @include gradient-bg($background);\r\n  border-color: $border;\r\n\r\n  hr {\r\n    border-top-color: darken($border, 5%);\r\n  }\r\n\r\n  .alert-link {\r\n    color: darken($color, 10%);\r\n  }\r\n}\r\n","@keyframes progress-bar-stripes {\r\n  from {\r\n    background-position: $progress-height 0;\r\n  }\r\n  to {\r\n    background-position: 0 0;\r\n  }\r\n}\r\n\r\n.progress {\r\n  display: flex;\r\n  height: $progress-height;\r\n  overflow: hidden; // force rounded corners by cropping it\r\n  font-size: $progress-font-size;\r\n  background-color: $progress-bg;\r\n  @include border-radius($progress-border-radius);\r\n  @include box-shadow($progress-box-shadow);\r\n}\r\n\r\n.progress-bar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  color: $progress-bar-color;\r\n  text-align: center;\r\n  background-color: $progress-bar-bg;\r\n  @include transition($progress-bar-transition);\r\n}\r\n\r\n.progress-bar-striped {\r\n  @include gradient-striped();\r\n  background-size: $progress-height $progress-height;\r\n}\r\n\r\n.progress-bar-animated {\r\n  animation: progress-bar-stripes $progress-bar-animation-timing;\r\n}\r\n",".media {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.media-body {\r\n  flex: 1;\r\n}\r\n\r\n.social-list-line:not(:last-child) {\r\n  padding-bottom: 25px;\r\n}\r\n\r\n","// Base class\r\n//\r\n// Easily usable on <ul>, <ol>, or <div>.\r\n\r\n.list-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  // No need to set list-style: none; since .list-group-item is block level\r\n  padding-left: 0; // reset padding because ul and ol\r\n  margin-bottom: 0;\r\n}\r\n\r\n// Interactive list items\r\n//\r\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\r\n// list items. Includes an extra `.active` modifier class for selected items.\r\n\r\n.list-group-item-action {\r\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\r\n  color: $list-group-action-color;\r\n  text-align: inherit; // For `<button>`s (anchors inherit)\r\n\r\n  // Hover state\r\n  @include hover-focus {\r\n    color: $list-group-action-hover-color;\r\n    text-decoration: none;\r\n    background-color: $list-group-hover-bg;\r\n  }\r\n\r\n  &:active {\r\n    color: $list-group-action-active-color;\r\n    background-color: $list-group-action-active-bg;\r\n  }\r\n}\r\n\r\n// Individual list items\r\n//\r\n// Use on `li`s or `div`s within the `.list-group` parent.\r\n\r\n.list-group-item {\r\n  position: relative;\r\n  display: block;\r\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\r\n  // Place the border on the list items and negative margin up for better styling\r\n  margin-bottom: -$list-group-border-width;\r\n  background-color: $list-group-bg;\r\n  border: $list-group-border-width solid $list-group-border-color;\r\n\r\n  &:first-child {\r\n    @include border-top-radius($list-group-border-radius);\r\n  }\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n    @include border-bottom-radius($list-group-border-radius);\r\n  }\r\n\r\n  @include hover-focus {\r\n    z-index: 1; // Place hover/active items above their siblings for proper border styling\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $list-group-disabled-color;\r\n    background-color: $list-group-disabled-bg;\r\n  }\r\n\r\n  // Include both here for `<a>`s and `<button>`s\r\n  &.active {\r\n    z-index: 2; // Place active items above their siblings for proper border styling\r\n    color: $list-group-active-color;\r\n    background-color: $list-group-active-bg;\r\n    border-color: $list-group-active-border-color;\r\n  }\r\n}\r\n\r\n// Flush list items\r\n//\r\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\r\n// useful within other components (e.g., cards).\r\n\r\n.list-group-flush {\r\n  .list-group-item {\r\n    border-right: 0;\r\n    border-left: 0;\r\n    @include border-radius(0);\r\n  }\r\n\r\n  &:first-child {\r\n    .list-group-item:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n\r\n  &:last-child {\r\n    .list-group-item:last-child {\r\n      border-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Contextual variants\r\n//\r\n// Add modifier classes to change text and background color on individual items.\r\n// Organizationally, this must come after the `:hover` states.\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\r\n}\r\n","// List Groups\r\n\r\n@mixin list-group-item-variant($state, $background, $color) {\r\n  .list-group-item-#{$state} {\r\n    color: $color;\r\n    background-color: $background;\r\n\r\n    &.list-group-item-action {\r\n      @include hover-focus {\r\n        color: $color;\r\n        background-color: darken($background, 5%);\r\n      }\r\n\r\n      &.active {\r\n        color: #fff;\r\n        background-color: $color;\r\n        border-color: $color;\r\n      }\r\n    }\r\n  }\r\n}\r\n",".close {\r\n  float: right;\r\n  font-size: $close-font-size;\r\n  font-weight: $close-font-weight;\r\n  line-height: 1;\r\n  //color: $close-color;\r\n // text-shadow: $close-text-shadow;\r\n  opacity: .5;\r\n\r\n  @include hover-focus {\r\n    //color: $close-color;\r\n    text-decoration: none;\r\n    opacity: .75;\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .close elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n// Additional properties for button version\r\n// iOS requires the button element instead of an anchor tag.\r\n// If you want the anchor version, it requires `href=\"#\"`.\r\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\r\n\r\n// stylelint-disable property-no-vendor-prefix, selector-no-qualifying-type\r\nbutton.close {\r\n  padding: 0;\r\n  background-color: transparent;\r\n  border: 0;\r\n  -webkit-appearance: none;\r\n}\r\n\r\n// stylelint-enable\r\n","// .modal-open      - body class for killing the scroll\r\n// .modal           - container to scroll within\r\n// .modal-dialog    - positioning shell for the actual modal\r\n// .modal-content   - actual modal w/ bg and corners and stuff\r\n\r\n// Kill the scroll on the body\r\n.modal-open {\r\n  overflow: hidden;\r\n}\r\n\r\n// Container that the modal scrolls within\r\n.modal {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-modal;\r\n  display: none;\r\n  overflow: hidden;\r\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\r\n  // https://github.com/twbs/bootstrap/pull/10951.\r\n  outline: 0;\r\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\r\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\r\n  // See also https://github.com/twbs/bootstrap/issues/17695\r\n\r\n  .modal-open & {\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n  }\r\n}\r\n\r\n// Shell div to position the modal with bottom padding\r\n.modal-dialog {\r\n  position: relative;\r\n  width: auto;\r\n  margin: $modal-dialog-margin;\r\n  // allow clicks to pass through for custom click handling to close modal\r\n  pointer-events: none;\r\n\r\n  // When fading in the modal, animate it to slide down\r\n  .modal.fade & {\r\n    @include transition($modal-transition);\r\n    transform: translate(0, -25%);\r\n  }\r\n  .modal.show & {\r\n    transform: translate(0, 0);\r\n  }\r\n}\r\n\r\n.modal-dialog-centered {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: calc(100% - (#{$modal-dialog-margin} * 2));\r\n}\r\n\r\n// Actual modal\r\n.modal-content {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\r\n  // counteract the pointer-events: none; in the .modal-dialog\r\n  pointer-events: auto;\r\n  background-color: $modal-content-bg;\r\n  background-clip: padding-box;\r\n  border: $modal-content-border-width solid $modal-content-border-color;\r\n  @include border-radius($border-radius-lg);\r\n  @include box-shadow($modal-content-box-shadow-xs);\r\n  // Remove focus outline from opened modal\r\n  outline: 0;\r\n}\r\n\r\n// Modal background\r\n.modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-modal-backdrop;\r\n  background-color: $modal-backdrop-bg;\r\n\r\n  // Fade for backdrop\r\n  &.fade {\r\n    opacity: 0;\r\n  }\r\n  &.show {\r\n    opacity: $modal-backdrop-opacity;\r\n  }\r\n}\r\n\r\n// Modal header\r\n// Top section of the modal w/ title and dismiss\r\n.modal-header {\r\n  display: flex;\r\n  align-items: flex-start; // so the close btn always stays on the upper right corner\r\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\r\n  padding: $modal-header-padding;\r\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\r\n  @include border-top-radius($border-radius-lg);\r\n\r\n  .close {\r\n    padding: $modal-header-padding;\r\n    // auto on the left force icon to the right even when there is no .modal-title\r\n    margin: (-$modal-header-padding) (-$modal-header-padding) (-$modal-header-padding) auto;\r\n  }\r\n}\r\n\r\n// Title text within header\r\n.modal-title {\r\n  margin-bottom: 0;\r\n  line-height: $modal-title-line-height;\r\n}\r\n\r\n// Modal body\r\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\r\n.modal-body {\r\n  position: relative;\r\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\r\n  // when should there be a fixed height on `.modal-dialog`.\r\n  flex: 1 1 auto;\r\n  padding: $modal-inner-padding;\r\n}\r\n\r\n// Footer (for actions)\r\n.modal-footer {\r\n  display: flex;\r\n  align-items: center; // vertically center\r\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\r\n  padding: $modal-inner-padding;\r\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\r\n\r\n  // Easily place margin between footer elements\r\n  > :not(:first-child) {\r\n    margin-left: .25rem;\r\n  }\r\n  > :not(:last-child) {\r\n    margin-right: .25rem;\r\n  }\r\n}\r\n\r\n// Measure scrollbar width for padding body during modal show/hide\r\n.modal-scrollbar-measure {\r\n  position: absolute;\r\n  top: -9999px;\r\n  width: 50px;\r\n  height: 50px;\r\n  overflow: scroll;\r\n}\r\n\r\n// Scale up the modal\r\n@include media-breakpoint-up(sm) {\r\n  // Automatically set modal's width for larger viewports\r\n  .modal-dialog {\r\n    max-width: $modal-md;\r\n    margin: $modal-dialog-margin-y-sm-up auto;\r\n  }\r\n\r\n  .modal-dialog-centered {\r\n    min-height: calc(100% - (#{$modal-dialog-margin-y-sm-up} * 2));\r\n  }\r\n\r\n  .modal-content {\r\n    @include box-shadow($modal-content-box-shadow-sm-up);\r\n  }\r\n\r\n  .modal-sm {\r\n    max-width: $modal-sm;\r\n  }\r\n\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n  .modal-lg {\r\n    max-width: $modal-lg;\r\n  }\r\n}\r\n","// Base class\r\n.tooltip {\r\n  position: absolute;\r\n  z-index: $zindex-tooltip;\r\n  display: block;\r\n  margin: $tooltip-margin;\r\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\r\n  // So reset our font and text properties to avoid inheriting weird values.\r\n  @include reset-text();\r\n  font-size: $tooltip-font-size;\r\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\r\n  word-wrap: break-word;\r\n  opacity: 0;\r\n\r\n  &.show {\r\n    opacity: $tooltip-opacity;\r\n  }\r\n\r\n  .arrow {\r\n    position: absolute;\r\n    display: block;\r\n    width: $tooltip-arrow-width;\r\n    height: $tooltip-arrow-height;\r\n\r\n    &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      border-color: transparent;\r\n      border-style: solid;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-top {\r\n  padding: $tooltip-arrow-height 0;\r\n\r\n  .arrow {\r\n    bottom: 0;\r\n\r\n    &::before {\r\n      top: 0;\r\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\r\n      border-top-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-right {\r\n  padding: 0 $tooltip-arrow-height;\r\n\r\n  .arrow {\r\n    left: 0;\r\n    width: $tooltip-arrow-height;\r\n    height: $tooltip-arrow-width;\r\n\r\n    &::before {\r\n      right: 0;\r\n      border-width: ($tooltip-arrow-width / 2) $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\r\n      border-right-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-bottom {\r\n  padding: $tooltip-arrow-height 0;\r\n\r\n  .arrow {\r\n    top: 0;\r\n\r\n    &::before {\r\n      bottom: 0;\r\n      border-width: 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\r\n      border-bottom-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-left {\r\n  padding: 0 $tooltip-arrow-height;\r\n\r\n  .arrow {\r\n    right: 0;\r\n    width: $tooltip-arrow-height;\r\n    height: $tooltip-arrow-width;\r\n\r\n    &::before {\r\n      left: 0;\r\n      border-width: ($tooltip-arrow-width / 2) 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\r\n      border-left-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-auto {\r\n  &[x-placement^=\"top\"] {\r\n    @extend .bs-tooltip-top;\r\n  }\r\n  &[x-placement^=\"right\"] {\r\n    @extend .bs-tooltip-right;\r\n  }\r\n  &[x-placement^=\"bottom\"] {\r\n    @extend .bs-tooltip-bottom;\r\n  }\r\n  &[x-placement^=\"left\"] {\r\n    @extend .bs-tooltip-left;\r\n  }\r\n}\r\n\r\n// Wrapper for the tooltip content\r\n.tooltip-inner {\r\n  max-width: $tooltip-max-width;\r\n  padding: $tooltip-padding-y $tooltip-padding-x;\r\n  color: $tooltip-color;\r\n  text-align: center;\r\n  background-color: $tooltip-bg;\r\n  @include border-radius($tooltip-border-radius);\r\n}\r\n","@mixin reset-text {\r\n  font-family: $font-family-base;\r\n  // We deliberately do NOT reset font-size or word-wrap.\r\n  font-style: normal;\r\n  font-weight: $font-weight-normal;\r\n  line-height: $line-height-base;\r\n  text-align: left; // Fallback for where `start` is not supported\r\n  text-align: start; // stylelint-disable-line declaration-block-no-duplicate-properties\r\n  text-decoration: none;\r\n  text-shadow: none;\r\n  text-transform: none;\r\n  letter-spacing: normal;\r\n  word-break: normal;\r\n  word-spacing: normal;\r\n  white-space: normal;\r\n  line-break: auto;\r\n}\r\n",".popover {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: $zindex-popover;\r\n  display: block;\r\n  max-width: $popover-max-width;\r\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\r\n  // So reset our font and text properties to avoid inheriting weird values.\r\n  @include reset-text();\r\n  font-size: $popover-font-size;\r\n  // Allow breaking very long words so they don't overflow the popover's bounds\r\n  word-wrap: break-word;\r\n  background-color: $popover-bg;\r\n  background-clip: padding-box;\r\n  border: $popover-border-width solid $popover-border-color;\r\n  @include border-radius($popover-border-radius);\r\n  @include box-shadow($popover-box-shadow);\r\n\r\n  .arrow {\r\n    position: absolute;\r\n    display: block;\r\n    width: $popover-arrow-width;\r\n    height: $popover-arrow-height;\r\n    margin: 0 $border-radius-lg;\r\n\r\n    &::before,\r\n    &::after {\r\n      position: absolute;\r\n      display: block;\r\n      content: \"\";\r\n      border-color: transparent;\r\n      border-style: solid;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-popover-top {\r\n  margin-bottom: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    bottom: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\r\n  }\r\n\r\n  .arrow::before {\r\n    bottom: 0;\r\n    border-top-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    bottom: $popover-border-width;\r\n    border-top-color: $popover-arrow-color;\r\n  }\r\n}\r\n\r\n.bs-popover-right {\r\n  margin-left: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    left: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n    width: $popover-arrow-height;\r\n    height: $popover-arrow-width;\r\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\r\n  }\r\n\r\n  .arrow::before {\r\n    left: 0;\r\n    border-right-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    left: $popover-border-width;\r\n    border-right-color: $popover-arrow-color;\r\n  }\r\n}\r\n\r\n.bs-popover-bottom {\r\n  margin-top: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    top: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\r\n  }\r\n\r\n  .arrow::before {\r\n    top: 0;\r\n    border-bottom-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    top: $popover-border-width;\r\n    border-bottom-color: $popover-arrow-color;\r\n  }\r\n\r\n  // This will remove the popover-header's border just below the arrow\r\n  .popover-header::before {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 50%;\r\n    display: block;\r\n    width: $popover-arrow-width;\r\n    margin-left: ($popover-arrow-width / -2);\r\n    content: \"\";\r\n    border-bottom: $popover-border-width solid $popover-header-bg;\r\n  }\r\n}\r\n\r\n.bs-popover-left {\r\n  margin-right: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    right: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n    width: $popover-arrow-height;\r\n    height: $popover-arrow-width;\r\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\r\n  }\r\n\r\n  .arrow::before {\r\n    right: 0;\r\n    border-left-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    right: $popover-border-width;\r\n    border-left-color: $popover-arrow-color;\r\n  }\r\n}\r\n\r\n.bs-popover-auto {\r\n  &[x-placement^=\"top\"] {\r\n    @extend .bs-popover-top;\r\n  }\r\n  &[x-placement^=\"right\"] {\r\n    @extend .bs-popover-right;\r\n  }\r\n  &[x-placement^=\"bottom\"] {\r\n    @extend .bs-popover-bottom;\r\n  }\r\n  &[x-placement^=\"left\"] {\r\n    @extend .bs-popover-left;\r\n  }\r\n}\r\n\r\n// Offset the popover to account for the popover arrow\r\n.popover-header {\r\n  padding: $popover-header-padding-y $popover-header-padding-x;\r\n  margin-bottom: 0; // Reset the default from Reboot\r\n  font-size: $font-size-base;\r\n  color: $popover-header-color;\r\n  background-color: $popover-header-bg;\r\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\r\n  $offset-border-width: calc(#{$border-radius-lg} - #{$popover-border-width});\r\n  @include border-top-radius($offset-border-width);\r\n\r\n  &:empty {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.popover-body {\r\n  padding: $popover-body-padding-y $popover-body-padding-x;\r\n  color: $popover-body-color;\r\n}\r\n","// Wrapper for the slide container and indicators\r\n.carousel {\r\n  position: relative;\r\n}\r\n\r\n.carousel-inner {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.carousel-item {\r\n  position: relative;\r\n  display: none;\r\n  align-items: center;\r\n  width: 100%;\r\n  @include transition($carousel-transition);\r\n  backface-visibility: hidden;\r\n  perspective: 1000px;\r\n}\r\n\r\n.carousel-item.active,\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  display: block;\r\n}\r\n\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n\r\n// CSS3 transforms when supported by the browser\r\n.carousel-item-next.carousel-item-left,\r\n.carousel-item-prev.carousel-item-right {\r\n  transform: translateX(0);\r\n\r\n  @supports (transform-style: preserve-3d) {\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n}\r\n\r\n.carousel-item-next,\r\n.active.carousel-item-right {\r\n  transform: translateX(100%);\r\n\r\n  @supports (transform-style: preserve-3d) {\r\n    transform: translate3d(100%, 0, 0);\r\n  }\r\n}\r\n\r\n.carousel-item-prev,\r\n.active.carousel-item-left {\r\n  transform: translateX(-100%);\r\n\r\n  @supports (transform-style: preserve-3d) {\r\n    transform: translate3d(-100%, 0, 0);\r\n  }\r\n}\r\n\r\n//\r\n// Left/right controls for nav\r\n//\r\n\r\n.carousel-control-prev,\r\n.carousel-control-next {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  // Use flex for alignment (1-3)\r\n  display: flex; // 1. allow flex styles\r\n  align-items: center; // 2. vertically center contents\r\n  justify-content: center; // 3. horizontally center contents\r\n  width: $carousel-control-width;\r\n  color: $carousel-control-color;\r\n  text-align: center;\r\n  opacity: $carousel-control-opacity;\r\n  // We can't have a transition here because WebKit cancels the carousel\r\n  // animation if you trip this while in the middle of another animation.\r\n\r\n  // Hover/focus state\r\n  @include hover-focus {\r\n    color: $carousel-control-color;\r\n    text-decoration: none;\r\n    outline: 0;\r\n    opacity: .9;\r\n  }\r\n}\r\n\r\n.carousel-control-prev {\r\n  left: 0;\r\n  @if $enable-gradients {\r\n    background: linear-gradient(90deg, rgba(0, 0, 0, .25), rgba(0, 0, 0, .001));\r\n  }\r\n}\r\n\r\n.carousel-control-next {\r\n  right: 0;\r\n  @if $enable-gradients {\r\n    background: linear-gradient(270deg, rgba(0, 0, 0, .25), rgba(0, 0, 0, .001));\r\n  }\r\n}\r\n\r\n// Icons for within\r\n.carousel-control-prev-icon,\r\n.carousel-control-next-icon {\r\n  display: inline-block;\r\n  width: $carousel-control-icon-width;\r\n  height: $carousel-control-icon-width;\r\n  background: transparent no-repeat center center;\r\n  background-size: 100% 100%;\r\n}\r\n\r\n.carousel-control-prev-icon {\r\n  background-image: $carousel-control-prev-icon-bg;\r\n}\r\n\r\n.carousel-control-next-icon {\r\n  background-image: $carousel-control-next-icon-bg;\r\n}\r\n\r\n// Optional indicator pips\r\n//\r\n// Add an ordered list with the following class and add a list item for each\r\n// slide your carousel holds.\r\n\r\n.carousel-indicators {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 10px;\r\n  left: 0;\r\n  z-index: 15;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding-left: 0; // override <ol> default\r\n  // Use the .carousel-control's width as margin so we don't overlay those\r\n  margin-right: $carousel-control-width;\r\n  margin-left: $carousel-control-width;\r\n  list-style: none;\r\n\r\n  li {\r\n    position: relative;\r\n    flex: 0 1 auto;\r\n    width: $carousel-indicator-width;\r\n    height: $carousel-indicator-height;\r\n    margin-right: $carousel-indicator-spacer;\r\n    margin-left: $carousel-indicator-spacer;\r\n    text-indent: -999px;\r\n    background-color: rgba($carousel-indicator-active-bg, .5);\r\n\r\n    // Use pseudo classes to increase the hit area by 10px on top and bottom.\r\n    &::before {\r\n      position: absolute;\r\n      top: -10px;\r\n      left: 0;\r\n      display: inline-block;\r\n      width: 100%;\r\n      height: 10px;\r\n      content: \"\";\r\n    }\r\n    &::after {\r\n      position: absolute;\r\n      bottom: -10px;\r\n      left: 0;\r\n      display: inline-block;\r\n      width: 100%;\r\n      height: 10px;\r\n      content: \"\";\r\n    }\r\n  }\r\n\r\n  .active {\r\n    background-color: $carousel-indicator-active-bg;\r\n  }\r\n}\r\n\r\n// Optional captions\r\n//\r\n//\r\n\r\n.carousel-caption {\r\n  position: absolute;\r\n  right: ((100% - $carousel-caption-width) / 2);\r\n  bottom: 20px;\r\n  left: ((100% - $carousel-caption-width) / 2);\r\n  z-index: 10;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n  color: $carousel-caption-color;\r\n  text-align: center;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n.align-baseline {\r\n  vertical-align: baseline !important;\r\n}\r\n\r\n// Browser default\r\n.align-top {\r\n  vertical-align: top !important;\r\n}\r\n\r\n.align-middle {\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.align-bottom {\r\n  vertical-align: bottom !important;\r\n}\r\n\r\n.align-text-bottom {\r\n  vertical-align: text-bottom !important;\r\n}\r\n\r\n.align-text-top {\r\n  vertical-align: text-top !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Contextual backgrounds\r\n\r\n@mixin bg-variant($parent, $color) {\r\n  #{$parent} {\r\n    background-color: $color !important;\r\n  }\r\n  a#{$parent},\r\n  button#{$parent} {\r\n    @include hover-focus {\r\n      background-color: darken($color, 10%) !important;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin bg-gradient-variant($parent, $color) {\r\n  #{$parent} {\r\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include bg-variant(\".bg-#{$color}\", $value);\r\n}\r\n\r\n@if $enable-gradients {\r\n  @each $color, $value in $theme-colors {\r\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\r\n  }\r\n}\r\n\r\n.bg-white {\r\n  background-color: $white !important;\r\n}\r\n\r\n.bg-transparent {\r\n  background-color: transparent !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n//\r\n// Border\r\n//\r\n\r\n.border {\r\n  border: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-top {\r\n  border-top: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-right {\r\n  border-right: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-left {\r\n  border-left: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-0 {\r\n  border: 0 !important;\r\n}\r\n\r\n.border-top-0 {\r\n  border-top: 0 !important;\r\n}\r\n\r\n.border-right-0 {\r\n  border-right: 0 !important;\r\n}\r\n\r\n.border-bottom-0 {\r\n  border-bottom: 0 !important;\r\n}\r\n\r\n.border-left-0 {\r\n  border-left: 0 !important;\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .border-#{$color} {\r\n    border-color: $value !important;\r\n  }\r\n}\r\n\r\n.border-white {\r\n  border-color: $white !important;\r\n}\r\n\r\n//\r\n// Border-radius\r\n//\r\n\r\n.rounded {\r\n  border-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-top {\r\n  border-top-left-radius: $border-radius !important;\r\n  border-top-right-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-right {\r\n  border-top-right-radius: $border-radius !important;\r\n  border-bottom-right-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-bottom {\r\n  border-bottom-right-radius: $border-radius !important;\r\n  border-bottom-left-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-left {\r\n  border-top-left-radius: $border-radius !important;\r\n  border-bottom-left-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-circle {\r\n  border-radius: 50% !important;\r\n}\r\n\r\n.rounded-0 {\r\n  border-radius: 0 !important;\r\n}\r\n","@mixin clearfix() {\r\n  &::after {\r\n    display: block;\r\n    clear: both;\r\n    content: \"\";\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n//\r\n// Utilities for common `display` values\r\n//\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .d#{$infix}-none {\r\n      display: none !important;\r\n    }\r\n    .d#{$infix}-inline {\r\n      display: inline !important;\r\n    }\r\n    .d#{$infix}-inline-block {\r\n      display: inline-block !important;\r\n    }\r\n    .d#{$infix}-block {\r\n      display: block !important;\r\n    }\r\n    .d#{$infix}-table {\r\n      display: table !important;\r\n    }\r\n    .d#{$infix}-table-row {\r\n      display: table-row !important;\r\n    }\r\n    .d#{$infix}-table-cell {\r\n      display: table-cell !important;\r\n    }\r\n    .d#{$infix}-flex {\r\n      display: flex !important;\r\n    }\r\n    .d#{$infix}-inline-flex {\r\n      display: inline-flex !important;\r\n    }\r\n  }\r\n}\r\n\r\n//\r\n// Utilities for toggling `display` in print\r\n//\r\n\r\n@media print {\r\n  .d-print-none {\r\n    display: none !important;\r\n  }\r\n  .d-print-inline {\r\n    display: inline !important;\r\n  }\r\n  .d-print-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n  .d-print-block {\r\n    display: block !important;\r\n  }\r\n  .d-print-table {\r\n    display: table !important;\r\n  }\r\n  .d-print-table-row {\r\n    display: table-row !important;\r\n  }\r\n  .d-print-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n  .d-print-flex {\r\n    display: flex !important;\r\n  }\r\n  .d-print-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n","// Credit: Nicolas Gallagher and SUIT CSS.\r\n\r\n.embed-responsive {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0;\r\n  overflow: hidden;\r\n\r\n  &::before {\r\n    display: block;\r\n    content: \"\";\r\n  }\r\n\r\n  .embed-responsive-item,\r\n  iframe,\r\n  embed,\r\n  object,\r\n  video {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    border: 0;\r\n  }\r\n}\r\n\r\n.embed-responsive-21by9 {\r\n  &::before {\r\n    padding-top: percentage(9 / 21);\r\n  }\r\n}\r\n\r\n.embed-responsive-16by9 {\r\n  &::before {\r\n    padding-top: percentage(9 / 16);\r\n  }\r\n}\r\n\r\n.embed-responsive-4by3 {\r\n  &::before {\r\n    padding-top: percentage(3 / 4);\r\n  }\r\n}\r\n\r\n.embed-responsive-1by1 {\r\n  &::before {\r\n    padding-top: percentage(1 / 1);\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Flex variation\r\n//\r\n// Custom styles for additional flex alignment options.\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .flex#{$infix}-row {\r\n      flex-direction: row !important;\r\n    }\r\n    .flex#{$infix}-column {\r\n      flex-direction: column !important;\r\n    }\r\n    .flex#{$infix}-row-reverse {\r\n      flex-direction: row-reverse !important;\r\n    }\r\n    .flex#{$infix}-column-reverse {\r\n      flex-direction: column-reverse !important;\r\n    }\r\n\r\n    .flex#{$infix}-wrap {\r\n      flex-wrap: wrap !important;\r\n    }\r\n    .flex#{$infix}-nowrap {\r\n      flex-wrap: nowrap !important;\r\n    }\r\n    .flex#{$infix}-wrap-reverse {\r\n      flex-wrap: wrap-reverse !important;\r\n    }\r\n\r\n    .justify-content#{$infix}-start {\r\n      justify-content: flex-start !important;\r\n    }\r\n    .justify-content#{$infix}-end {\r\n      justify-content: flex-end !important;\r\n    }\r\n    .justify-content#{$infix}-center {\r\n      justify-content: center !important;\r\n    }\r\n    .justify-content#{$infix}-between {\r\n      justify-content: space-between !important;\r\n    }\r\n    .justify-content#{$infix}-around {\r\n      justify-content: space-around !important;\r\n    }\r\n\r\n    .align-items#{$infix}-start {\r\n      align-items: flex-start !important;\r\n    }\r\n    .align-items#{$infix}-end {\r\n      align-items: flex-end !important;\r\n    }\r\n    .align-items#{$infix}-center {\r\n      align-items: center !important;\r\n    }\r\n    .align-items#{$infix}-baseline {\r\n      align-items: baseline !important;\r\n    }\r\n    .align-items#{$infix}-stretch {\r\n      align-items: stretch !important;\r\n    }\r\n\r\n    .align-content#{$infix}-start {\r\n      align-content: flex-start !important;\r\n    }\r\n    .align-content#{$infix}-end {\r\n      align-content: flex-end !important;\r\n    }\r\n    .align-content#{$infix}-center {\r\n      align-content: center !important;\r\n    }\r\n    .align-content#{$infix}-between {\r\n      align-content: space-between !important;\r\n    }\r\n    .align-content#{$infix}-around {\r\n      align-content: space-around !important;\r\n    }\r\n    .align-content#{$infix}-stretch {\r\n      align-content: stretch !important;\r\n    }\r\n\r\n    .align-self#{$infix}-auto {\r\n      align-self: auto !important;\r\n    }\r\n    .align-self#{$infix}-start {\r\n      align-self: flex-start !important;\r\n    }\r\n    .align-self#{$infix}-end {\r\n      align-self: flex-end !important;\r\n    }\r\n    .align-self#{$infix}-center {\r\n      align-self: center !important;\r\n    }\r\n    .align-self#{$infix}-baseline {\r\n      align-self: baseline !important;\r\n    }\r\n    .align-self#{$infix}-stretch {\r\n      align-self: stretch !important;\r\n    }\r\n  }\r\n}\r\n","@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .float#{$infix}-left {\r\n      @include float-left;\r\n    }\r\n    .float#{$infix}-right {\r\n      @include float-right;\r\n    }\r\n    .float#{$infix}-none {\r\n      @include float-none;\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n@mixin float-left {\r\n  float: left !important;\r\n}\r\n\r\n@mixin float-right {\r\n  float: right !important;\r\n}\r\n\r\n@mixin float-none {\r\n  float: none !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Common values\r\n\r\n// Sass list not in variables since it's not intended for customization.\r\n$positions: static, relative, absolute, fixed, sticky;\r\n\r\n@each $position in $positions {\r\n  .position-#{$position} {\r\n    position: $position !important;\r\n  }\r\n}\r\n\r\n// Shorthand\r\n\r\n.fixed-top {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: $zindex-fixed;\r\n}\r\n\r\n.fixed-bottom {\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-fixed;\r\n}\r\n\r\n.sticky-top {\r\n  @supports (position: sticky) {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: $zindex-sticky;\r\n  }\r\n}\r\n","//\r\n// Screenreaders\r\n//\r\n\r\n.sr-only {\r\n  @include sr-only();\r\n}\r\n\r\n.sr-only-focusable {\r\n  @include sr-only-focusable();\r\n}\r\n","// Only display content to screen readers\r\n//\r\n// See: http://a11yproject.com/posts/how-to-hide-content/\r\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\r\n\r\n@mixin sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  clip-path: inset(50%);\r\n  border: 0;\r\n}\r\n\r\n// Use in conjunction with .sr-only to only display content when it's focused.\r\n//\r\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\r\n//\r\n// Credit: HTML5 Boilerplate\r\n\r\n@mixin sr-only-focusable {\r\n  &:active,\r\n  &:focus {\r\n    position: static;\r\n    width: auto;\r\n    height: auto;\r\n    overflow: visible;\r\n    clip: auto;\r\n    white-space: normal;\r\n    clip-path: none;\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Width and height\r\n\r\n@each $prop, $abbrev in (width: w, height: h) {\r\n  @each $size, $length in $sizes {\r\n    .#{$abbrev}-#{$size} {\r\n      #{$prop}: $length !important;\r\n    }\r\n  }\r\n}\r\n\r\n.mw-100 {\r\n  max-width: 100% !important;\r\n}\r\n\r\n.mh-100 {\r\n  max-height: 100% !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Margin and Padding\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    @each $prop, $abbrev in (margin: m, padding: p) {\r\n      @each $size, $length in $spacers {\r\n\r\n        .#{$abbrev}#{$infix}-#{$size} {\r\n          #{$prop}: $length !important;\r\n        }\r\n        .#{$abbrev}t#{$infix}-#{$size},\r\n        .#{$abbrev}y#{$infix}-#{$size} {\r\n          #{$prop}-top: $length !important;\r\n        }\r\n        .#{$abbrev}r#{$infix}-#{$size},\r\n        .#{$abbrev}x#{$infix}-#{$size} {\r\n          #{$prop}-right: $length !important;\r\n        }\r\n        .#{$abbrev}b#{$infix}-#{$size},\r\n        .#{$abbrev}y#{$infix}-#{$size} {\r\n          #{$prop}-bottom: $length !important;\r\n        }\r\n        .#{$abbrev}l#{$infix}-#{$size},\r\n        .#{$abbrev}x#{$infix}-#{$size} {\r\n          #{$prop}-left: $length !important;\r\n        }\r\n      }\r\n    }\r\n\r\n    // Some special margin utils\r\n    .m#{$infix}-auto {\r\n      margin: auto !important;\r\n    }\r\n    .mt#{$infix}-auto,\r\n    .my#{$infix}-auto {\r\n      margin-top: auto !important;\r\n    }\r\n    .mr#{$infix}-auto,\r\n    .mx#{$infix}-auto {\r\n      margin-right: auto !important;\r\n    }\r\n    .mb#{$infix}-auto,\r\n    .my#{$infix}-auto {\r\n      margin-bottom: auto !important;\r\n    }\r\n    .ml#{$infix}-auto,\r\n    .mx#{$infix}-auto {\r\n      margin-left: auto !important;\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n//\r\n// Text\r\n//\r\n\r\n// Alignment\r\n\r\n.text-justify {\r\n  text-align: justify !important;\r\n}\r\n\r\n.text-nowrap {\r\n  white-space: nowrap !important;\r\n}\r\n\r\n.text-truncate {\r\n  @include text-truncate;\r\n}\r\n\r\n// Responsive alignment\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .text#{$infix}-left {\r\n      text-align: left !important;\r\n    }\r\n    .text#{$infix}-right {\r\n      text-align: right !important;\r\n    }\r\n    .text#{$infix}-center {\r\n      text-align: center !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Transformation\r\n\r\n.text-lowercase {\r\n  text-transform: lowercase !important;\r\n}\r\n\r\n.text-uppercase {\r\n  text-transform: uppercase !important;\r\n}\r\n\r\n.text-capitalize {\r\n  text-transform: capitalize !important;\r\n}\r\n\r\n// Weight and italics\r\n\r\n.font-weight-light {\r\n  font-weight: $font-weight-light !important;\r\n}\r\n\r\n.font-weight-normal {\r\n  font-weight: $font-weight-normal !important;\r\n}\r\n\r\n.font-weight-bold {\r\n  font-weight: $font-weight-bold !important;\r\n}\r\n\r\n.font-italic {\r\n  font-style: italic !important;\r\n}\r\n\r\n// Contextual colors\r\n\r\n.text-white {\r\n  color: #fff !important;\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include text-emphasis-variant(\".text-#{$color}\", $value);\r\n}\r\n\r\n.text-muted {\r\n  color: $text-muted !important;\r\n}\r\n\r\n// Misc\r\n\r\n.text-hide {\r\n  @include text-hide();\r\n}\r\n","// Text truncate\r\n// Requires inline-block or block for proper styling\r\n\r\n@mixin text-truncate() {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Typography\r\n\r\n@mixin text-emphasis-variant($parent, $color) {\r\n  #{$parent} {\r\n    color: $color !important;\r\n  }\r\n  a#{$parent} {\r\n    @include hover-focus {\r\n      color: darken($color, 10%) !important;\r\n    }\r\n  }\r\n}\r\n","// CSS image replacement\r\n@mixin text-hide() {\r\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\r\n  font: 0/0 a;\r\n  color: transparent;\r\n  text-shadow: none;\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n","//\r\n// Visibility utilities\r\n//\r\n\r\n.visible {\r\n  @include invisible(visible);\r\n}\r\n\r\n.invisible {\r\n  @include invisible(hidden);\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Visibility\r\n\r\n@mixin invisible($visibility) {\r\n  visibility: $visibility !important;\r\n}\r\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\r\n\r\n// Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css\r\n\r\n// ==========================================================================\r\n// Print styles.\r\n// Inlined to avoid the additional HTTP request:\r\n// http://www.phpied.com/delay-loading-your-print-css/\r\n// ==========================================================================\r\n\r\n@if $enable-print-styles {\r\n  @media print {\r\n    *,\r\n    *::before,\r\n    *::after {\r\n      // Bootstrap specific; comment out `color` and `background`\r\n      //color: #000 !important; // Black prints faster: http://www.sanbeiji.com/archives/953\r\n      text-shadow: none !important;\r\n      //background: transparent !important;\r\n      box-shadow: none !important;\r\n    }\r\n\r\n    a {\r\n      &:not(.btn) {\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n\r\n    // Bootstrap specific; comment the following selector out\r\n    //a[href]::after {\r\n    //  content: \" (\" attr(href) \")\";\r\n    //}\r\n\r\n    abbr[title]::after {\r\n      content: \" (\" attr(title) \")\";\r\n    }\r\n\r\n    // Bootstrap specific; comment the following selector out\r\n    //\r\n    // Don't show links that are fragment identifiers,\r\n    // or use the `javascript:` pseudo protocol\r\n    //\r\n\r\n    //a[href^=\"#\"]::after,\r\n    //a[href^=\"javascript:\"]::after {\r\n    // content: \"\";\r\n    //}\r\n\r\n    pre {\r\n      white-space: pre-wrap !important;\r\n    }\r\n    pre,\r\n    blockquote {\r\n      border: $border-width solid #999; // Bootstrap custom code; using `$border-width` instead of 1px\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    //\r\n    // Printing Tables:\r\n    // http://css-discuss.incutio.com/wiki/Printing_Tables\r\n    //\r\n\r\n    thead {\r\n      display: table-header-group;\r\n    }\r\n\r\n    tr,\r\n    img {\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    p,\r\n    h2,\r\n    h3 {\r\n      orphans: 3;\r\n      widows: 3;\r\n    }\r\n\r\n    h2,\r\n    h3 {\r\n      page-break-after: avoid;\r\n    }\r\n\r\n    // Bootstrap specific changes start\r\n\r\n    // Specify a size and min-width to make printing closer across browsers.\r\n    // We don't set margin here because it breaks `size` in Chrome. We also\r\n    // don't use `!important` on `size` as it breaks in Chrome.\r\n    @page {\r\n      size: $print-page-size;\r\n    }\r\n    body {\r\n      min-width: $print-body-min-width !important;\r\n    }\r\n    .container {\r\n      min-width: $print-body-min-width !important;\r\n    }\r\n\r\n    // Bootstrap components\r\n    .navbar {\r\n      display: none;\r\n    }\r\n    .badge {\r\n      border: $border-width solid #000;\r\n    }\r\n\r\n    .table {\r\n      border-collapse: collapse !important;\r\n\r\n      td,\r\n      th {\r\n        background-color: #fff !important;\r\n      }\r\n    }\r\n    .table-bordered {\r\n      th,\r\n      td {\r\n        border: 1px solid #ddd !important;\r\n      }\r\n    }\r\n\r\n    // Bootstrap specific changes end\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
